import _Reflect$construct from '@babel/runtime-corejs3/core-js-stable/reflect/construct';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _inherits from '@babel/runtime-corejs3/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime-corejs3/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime-corejs3/helpers/getPrototypeOf';
import { Prop, Component, Vue as Vue$1, Watch, Ref } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/includes';
import Vue from 'vue';
import gsap$1, { gsap } from 'gsap';
import _reverseInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/reverse';
import _WeakMap from '@babel/runtime-corejs3/core-js-stable/weak-map';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import { serviceDetails, onTest, getLocale, setLangInLocalStorage, isLanguageSwitcherEnabled, supportedLocales, defaRetailerGroupHandle, retailerGroupLogoSrc, resendConfirmationEmail, confirmRegistrationOrPasswordRecovery, RELEASE_VERSION, fromUrlToApplicationDisplayName, formatDatetimeShortWithSeconds, isElliOrder, formatDateShortWithDots } from '@defa-as/utils';
import _setTimeout from '@babel/runtime-corejs3/core-js-stable/set-timeout';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _findIndexInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find-index';
import _fillInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/fill';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import { format, parseISO, isBefore, set } from 'date-fns';
import _toConsumableArray from '@babel/runtime-corejs3/helpers/toConsumableArray';
import _reduceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/reduce';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _regeneratorRuntime from '@babel/runtime-corejs3/regenerator';
import _asyncToGenerator from '@babel/runtime-corejs3/helpers/asyncToGenerator';
import _Promise from '@babel/runtime-corejs3/core-js-stable/promise';
import _Object$values from '@babel/runtime-corejs3/core-js-stable/object/values';
import _flatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/flat';
import _sortInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/sort';
import _sliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/slice';
import _findInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find';
import VueRecaptcha from 'vue-recaptcha';
import { debounce } from 'lodash-es';
import _indexOfInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/index-of';
import _Array$isArray from '@babel/runtime-corejs3/core-js-stable/array/is-array';
import VueSelect from 'vue-select';
import _parseInt from '@babel/runtime-corejs3/core-js-stable/parse-int';
import Datepicker from 'vue2-datepicker';
import _padStartInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/pad-start';
import VueDropzone from 'vue2-dropzone';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

var hasRequiredRule = function hasRequiredRule(rules) {
  if (typeof rules === "string") {
    return _includesInstanceProperty(rules).call(rules, "required");
  }

  return rules === null || rules === void 0 ? void 0 : rules.required;
}; // See https://github.com/logaretm/vee-validate/issues/2570 and https://github.com/logaretm/vee-validate/issues/1093

var getRules = function getRules(rules, disabled) {
  return disabled ? null : rules;
};

var DurationMixin = Vue.extend({
  props: {
    duration: {
      type: Number,
      default: 0.3
    }
  }
});

var script$1f = Vue.extend({
  name: "DefaTransitionFadeOutIn",
  mixins: [DurationMixin],
  props: {
    delay: {
      type: Number,
      default: 0
    },
    enterDelay: {
      type: Number,
      default: 0
    },
    leaveDelay: {
      type: Number,
      default: 0
    },
    appear: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onEnter: function onEnter(el, done) {
      gsap.fromTo(el, {
        autoAlpha: 0
      }, {
        autoAlpha: 1,
        duration: this.duration,
        delay: this.enterDelay || this.delay,
        onComplete: done
      });
    },
    onLeave: function onLeave(el, done) {
      gsap.to(el, {
        autoAlpha: 0,
        duration: this.duration,
        delay: this.leaveDelay || this.delay,
        onComplete: done
      });
    }
  }
});

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__$1f = script$1f;

/* template */
var __vue_render__$1f = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":_vm.appear,"css":false,"mode":"out-in"},on:{"enter":_vm.onEnter,"leave":_vm.onLeave}},[_vm._t("default")],2)};
var __vue_staticRenderFns__$1f = [];

  /* style */
  const __vue_inject_styles__$1f = undefined;
  /* scoped */
  const __vue_scope_id__$1f = undefined;
  /* module identifier */
  const __vue_module_identifier__$1f = undefined;
  /* functional template */
  const __vue_is_functional_template__$1f = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1f = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1f, staticRenderFns: __vue_staticRenderFns__$1f },
    __vue_inject_styles__$1f,
    __vue_script__$1f,
    __vue_scope_id__$1f,
    __vue_is_functional_template__$1f,
    __vue_module_identifier__$1f,
    false,
    undefined,
    undefined,
    undefined
  );

var script$1e = Vue.extend({
  name: "DefaTransitionExpand",
  mixins: [DurationMixin],
  props: {
    transitionGroup: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: "span"
    }
  },
  data: function data() {
    // Keep timelines in a map as we need one timeline per element in case this is used as a transition group
    return {
      timelines: new _WeakMap()
    };
  },
  computed: {
    transitionType: function transitionType() {
      return this.transitionGroup ? "transition-group" : "transition";
    }
  },
  methods: {
    beforeEnter: function beforeEnter(el) {
      gsap.set(el, {
        transformOrigin: "50% 0"
      });
    },
    onEnter: function onEnter(el, done) {
      if (!this.timelines.has(el)) {
        this.constructTimeline(el);
      }

      this.timelines.get(el).eventCallback("onComplete", done).play();
    },
    beforeLeave: function beforeLeave(el) {
      gsap.set(el, {
        transformOrigin: "50% 0"
      });
    },
    onLeave: function onLeave(el, done) {
      var _context;

      if (!this.timelines.has(el)) {
        this.constructTimeline(el, 1);
      }

      _reverseInstanceProperty(_context = this.timelines.get(el).eventCallback("onReverseComplete", done)).call(_context);
    },
    constructTimeline: function constructTimeline(el) {
      var progress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.timelines.set(el, gsap.timeline({
        defaults: {
          duration: this.duration,
          ease: "none"
        },
        paused: true
      }).from(el, {
        marginTop: 0,
        marginBottom: 0,
        scaleY: 0
      }).fromTo(el, {
        height: 0
      }, {
        height: "auto"
      }, "<").progress(progress));
    }
  }
});

/* script */
const __vue_script__$1e = script$1e;

/* template */
var __vue_render__$1e = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.transitionType,{tag:"component",attrs:{"css":false,"tag":_vm.tag},on:{"before-enter":_vm.beforeEnter,"before-leave":_vm.beforeLeave,"enter":_vm.onEnter,"leave":_vm.onLeave}},[_vm._t("default")],2)};
var __vue_staticRenderFns__$1e = [];

  /* style */
  const __vue_inject_styles__$1e = undefined;
  /* scoped */
  const __vue_scope_id__$1e = undefined;
  /* module identifier */
  const __vue_module_identifier__$1e = undefined;
  /* functional template */
  const __vue_is_functional_template__$1e = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1e = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1e, staticRenderFns: __vue_staticRenderFns__$1e },
    __vue_inject_styles__$1e,
    __vue_script__$1e,
    __vue_scope_id__$1e,
    __vue_is_functional_template__$1e,
    __vue_module_identifier__$1e,
    false,
    undefined,
    undefined,
    undefined
  );

/**
 * This transition class basically makes sure elements reveal and leave in a staggered fashion.
 * The "hard" part about this is making sure that on the leave transition, the elements leave from last
 * to first. This requires us to implement a semi-hacky feature by requiring a "data-index" property
 * to be set on any elements in the slot that we want to be animated because we need to know where
 * in the list the element is.
 */

var script$1d = Vue.extend({
  name: "DefaTransitionStaggerList",
  mixins: [DurationMixin],
  props: {
    totalAnimatableElements: {
      type: Number,
      required: true
    }
  },
  computed: {
    stagger: function stagger() {
      return this.duration / 2;
    },
    maxIndex: function maxIndex() {
      return this.totalAnimatableElements - 1;
    }
  },
  methods: {
    beforeEnter: function beforeEnter(el) {
      gsap.set(el, {
        transformOrigin: "50% 0"
      });
    },
    onEnter: function onEnter(el, done) {
      var index = Number(el.dataset.index);
      var delay = this.stagger * index;
      gsap.fromTo(el, {
        height: 0,
        scaleY: 0
      }, {
        height: "auto",
        scaleY: 1,
        delay: delay,
        duration: this.duration,
        onComplete: done
      });
    },
    beforeLeave: function beforeLeave(el) {
      gsap.set(el, {
        transformOrigin: "50% 0"
      });
    },
    onLeave: function onLeave(el, done) {
      var index = Number(el.dataset.index);
      var delay = this.maxIndex * this.stagger - this.stagger * index;
      gsap.to(el, {
        duration: this.duration,
        height: 0,
        scaleY: 0,
        delay: delay,
        onComplete: done
      });
    }
  }
});

/* script */
const __vue_script__$1d = script$1d;

/* template */
var __vue_render__$1d = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TransitionGroup',{attrs:{"css":false},on:{"before-enter":_vm.beforeEnter,"enter":_vm.onEnter,"before-leave":_vm.beforeLeave,"leave":_vm.onLeave}},[_vm._t("default")],2)};
var __vue_staticRenderFns__$1d = [];

  /* style */
  const __vue_inject_styles__$1d = undefined;
  /* scoped */
  const __vue_scope_id__$1d = undefined;
  /* module identifier */
  const __vue_module_identifier__$1d = undefined;
  /* functional template */
  const __vue_is_functional_template__$1d = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1d = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1d, staticRenderFns: __vue_staticRenderFns__$1d },
    __vue_inject_styles__$1d,
    __vue_script__$1d,
    __vue_scope_id__$1d,
    __vue_is_functional_template__$1d,
    __vue_module_identifier__$1d,
    false,
    undefined,
    undefined,
    undefined
  );

var script$1c = Vue.extend({
  name: "DefaTransitionSlideInFromLeft",
  mixins: [DurationMixin],
  methods: {
    onEnter: function onEnter(el, done) {
      gsap$1.fromTo(el, {
        xPercent: -100
      }, {
        duration: this.duration,
        xPercent: 0,
        onComplete: done
      });
    },
    onLeave: function onLeave(el, done) {
      gsap$1.to(el, {
        duration: this.duration,
        xPercent: -100,
        onComplete: done
      });
    }
  }
});

/* script */
const __vue_script__$1c = script$1c;

/* template */
var __vue_render__$1c = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false},on:{"enter":_vm.onEnter,"leave":_vm.onLeave}},[_vm._t("default")],2)};
var __vue_staticRenderFns__$1c = [];

  /* style */
  const __vue_inject_styles__$1c = undefined;
  /* scoped */
  const __vue_scope_id__$1c = undefined;
  /* module identifier */
  const __vue_module_identifier__$1c = undefined;
  /* functional template */
  const __vue_is_functional_template__$1c = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1c = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1c, staticRenderFns: __vue_staticRenderFns__$1c },
    __vue_inject_styles__$1c,
    __vue_script__$1c,
    __vue_scope_id__$1c,
    __vue_is_functional_template__$1c,
    __vue_module_identifier__$1c,
    false,
    undefined,
    undefined,
    undefined
  );

var script$1b = Vue.extend({
  name: "DefaTransitionFadeSlide",
  mixins: [DurationMixin],
  props: {
    yPositionStart: {
      type: Number,
      default: -1
    },
    yPositionStartUnits: {
      type: String,
      default: "rem"
    },
    yPositionEnd: {
      type: Number,
      default: -1
    },
    yPositionEndUnits: {
      type: String,
      default: "rem"
    }
  },
  methods: {
    beforeEnter: function beforeEnter(el) {
      var _context;

      gsap.set(el, {
        y: _concatInstanceProperty(_context = "".concat(this.yPositionStart)).call(_context, this.yPositionStartUnits),
        autoAlpha: 0
      });
    },
    onEnter: function onEnter(el, done) {
      gsap.to(el, {
        y: 0,
        autoAlpha: 1,
        duration: this.duration,
        onComplete: done
      });
    },
    onLeave: function onLeave(el, done) {
      var _context2;

      gsap.to(el, {
        y: _concatInstanceProperty(_context2 = "".concat(this.yPositionEnd)).call(_context2, this.yPositionEndUnits),
        autoAlpha: 0,
        duration: this.duration,
        onComplete: done
      });
    }
  }
});

/* script */
const __vue_script__$1b = script$1b;

/* template */
var __vue_render__$1b = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false,"mode":"out-in"},on:{"before-enter":_vm.beforeEnter,"enter":_vm.onEnter,"leave":_vm.onLeave}},[_vm._t("default")],2)};
var __vue_staticRenderFns__$1b = [];

  /* style */
  const __vue_inject_styles__$1b = undefined;
  /* scoped */
  const __vue_scope_id__$1b = undefined;
  /* module identifier */
  const __vue_module_identifier__$1b = undefined;
  /* functional template */
  const __vue_is_functional_template__$1b = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1b = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1b, staticRenderFns: __vue_staticRenderFns__$1b },
    __vue_inject_styles__$1b,
    __vue_script__$1b,
    __vue_scope_id__$1b,
    __vue_is_functional_template__$1b,
    __vue_module_identifier__$1b,
    false,
    undefined,
    undefined,
    undefined
  );

var script$1a = Vue.extend({
  name: "DefaTransitionSlide",
  mixins: [DurationMixin],
  props: {
    appear: {
      type: Boolean,
      default: false
    },
    percentageBeforeEnter: {
      type: Number,
      default: -100
    },
    percentageAfterEnter: {
      type: Number,
      default: 0
    },
    percentageAfterLeave: {
      type: Number,
      default: -100
    },
    enterDelay: {
      type: Number,
      default: 0
    },
    direction: {
      type: String,
      default: "vertical"
    }
  },
  computed: {
    transitionProp: function transitionProp() {
      return this.direction === "vertical" ? "yPercent" : "xPercent";
    }
  },
  methods: {
    onEnter: function onEnter(el, done) {
      var _gsap$fromTo, _gsap$fromTo2;

      gsap.fromTo(el, (_gsap$fromTo = {}, _defineProperty(_gsap$fromTo, this.transitionProp, this.percentageBeforeEnter), _defineProperty(_gsap$fromTo, "autoAlpha", 0), _gsap$fromTo), (_gsap$fromTo2 = {
        delay: this.enterDelay,
        duration: this.duration,
        autoAlpha: 1
      }, _defineProperty(_gsap$fromTo2, this.transitionProp, this.percentageAfterEnter), _defineProperty(_gsap$fromTo2, "onComplete", done), _gsap$fromTo2));
    },
    onLeave: function onLeave(el, done) {
      var _gsap$to;

      gsap.to(el, (_gsap$to = {
        duration: this.duration,
        autoAlpha: 0
      }, _defineProperty(_gsap$to, this.transitionProp, this.percentageAfterLeave), _defineProperty(_gsap$to, "onComplete", done), _gsap$to));
    }
  }
});

/* script */
const __vue_script__$1a = script$1a;

/* template */
var __vue_render__$1a = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":_vm.appear,"css":false,"tag":"div"},on:{"enter":_vm.onEnter,"leave":_vm.onLeave}},[_vm._t("default")],2)};
var __vue_staticRenderFns__$1a = [];

  /* style */
  const __vue_inject_styles__$1a = undefined;
  /* scoped */
  const __vue_scope_id__$1a = undefined;
  /* module identifier */
  const __vue_module_identifier__$1a = undefined;
  /* functional template */
  const __vue_is_functional_template__$1a = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1a = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1a, staticRenderFns: __vue_staticRenderFns__$1a },
    __vue_inject_styles__$1a,
    __vue_script__$1a,
    __vue_scope_id__$1a,
    __vue_is_functional_template__$1a,
    __vue_module_identifier__$1a,
    false,
    undefined,
    undefined,
    undefined
  );

function _createSuper$H(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$H(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$H() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaCircleWrapper = /*#__PURE__*/function (_Vue) {
  _inherits(DefaCircleWrapper, _Vue);

  var _super = _createSuper$H(DefaCircleWrapper);

  function DefaCircleWrapper() {
    _classCallCheck(this, DefaCircleWrapper);

    return _super.apply(this, arguments);
  }

  return DefaCircleWrapper;
}(Vue$1);

__decorate([Prop({
  default: "div",
  type: String
}), __metadata("design:type", String)], DefaCircleWrapper.prototype, "tag", void 0);

DefaCircleWrapper = __decorate([Component], DefaCircleWrapper);
var script$19 = DefaCircleWrapper;

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$19 = script$19;

/* template */
var __vue_render__$19 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"defa-circle-wrapper",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)};
var __vue_staticRenderFns__$19 = [];

  /* style */
  const __vue_inject_styles__$19 = function (inject) {
    if (!inject) return
    inject("data-v-582a83fd_0", { source: ".defa-circle-wrapper{width:2rem;height:2rem;border:2px solid #000;border-radius:50%;display:flex;justify-content:center;align-items:center}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$19 = undefined;
  /* module identifier */
  const __vue_module_identifier__$19 = undefined;
  /* functional template */
  const __vue_is_functional_template__$19 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$19 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$19, staticRenderFns: __vue_staticRenderFns__$19 },
    __vue_inject_styles__$19,
    __vue_script__$19,
    __vue_scope_id__$19,
    __vue_is_functional_template__$19,
    __vue_module_identifier__$19,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$G(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$G(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$G() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaBaseNotification = /*#__PURE__*/function (_Vue) {
  _inherits(DefaBaseNotification, _Vue);

  var _super = _createSuper$G(DefaBaseNotification);

  function DefaBaseNotification() {
    var _this;

    _classCallCheck(this, DefaBaseNotification);

    _this = _super.apply(this, arguments);
    _this.timeoutId = null;
    _this.mouseInside = false;
    return _this;
  }

  _createClass(DefaBaseNotification, [{
    key: "onMouseEnter",
    value: function onMouseEnter() {
      this.mouseInside = true;
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave() {
      this.mouseInside = false;

      if (!this.timeoutId) {
        this.$emit("close");
      }
    }
  }, {
    key: "onClickCross",
    value: function onClickCross() {
      this.$emit("close");
      this.timeoutId = null;
    }
  }, {
    key: "onShowChange",
    value: function onShowChange(show) {
      var _this2 = this;

      if (show) {
        this.timeoutId = _setTimeout(function () {
          if (!_this2.mouseInside) {
            _this2.$emit("close");
          }

          _this2.timeoutId = null;
        }, 10000);
      } else {
        if (this.timeoutId) {
          clearTimeout(this.timeoutId);
        }
      }
    }
  }]);

  return DefaBaseNotification;
}(Vue$1);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseNotification.prototype, "show", void 0);

__decorate([Prop({
  default: null,
  type: Object
}), __metadata("design:type", Object)], DefaBaseNotification.prototype, "contentStyle", void 0);

__decorate([Watch("show"), __metadata("design:type", Function), __metadata("design:paramtypes", [Boolean]), __metadata("design:returntype", void 0)], DefaBaseNotification.prototype, "onShowChange", null);

DefaBaseNotification = __decorate([Component({
  components: {
    DefaTransitionSlide: __vue_component__$1a
  },
  name: "DefaBaseNotification"
})], DefaBaseNotification);
var script$18 = DefaBaseNotification;

/* script */
const __vue_script__$18 = script$18;

/* template */
var __vue_render__$18 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaTransitionSlide',{attrs:{"duration":0.5}},[(_vm.show)?_c('div',{staticClass:"base-notification__content",style:(_vm.contentStyle),on:{"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave}},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"base-notification__content__icon-cross",on:{"click":_vm.onClickCross}},[_vm._v("\n      ×\n    ")])],2):_vm._e()])};
var __vue_staticRenderFns__$18 = [];

  /* style */
  const __vue_inject_styles__$18 = function (inject) {
    if (!inject) return
    inject("data-v-f26a4436_0", { source: ".base-notification__content[data-v-f26a4436]{position:fixed;z-index:100;top:0;right:0;padding:2rem 1.5rem 1.5rem 1.5rem;text-align:center;background-color:#fff;color:#000;border-bottom:2px solid #000;font-weight:700;width:100%;display:flex;gap:1rem}@media (min-width:768px){.base-notification__content[data-v-f26a4436]{width:min(45rem,40%);border-bottom-left-radius:1.5rem;border-left:2px solid #000}}.base-notification__content__icon-cross[data-v-f26a4436]{position:absolute;right:.5rem;top:0;cursor:pointer;font-size:2rem;color:#000;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$18 = "data-v-f26a4436";
  /* module identifier */
  const __vue_module_identifier__$18 = undefined;
  /* functional template */
  const __vue_is_functional_template__$18 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$18 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$18, staticRenderFns: __vue_staticRenderFns__$18 },
    __vue_inject_styles__$18,
    __vue_script__$18,
    __vue_scope_id__$18,
    __vue_is_functional_template__$18,
    __vue_module_identifier__$18,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$F(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$F(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$F() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaNotificationError = /*#__PURE__*/function (_Vue) {
  _inherits(DefaNotificationError, _Vue);

  var _super = _createSuper$F(DefaNotificationError);

  function DefaNotificationError() {
    _classCallCheck(this, DefaNotificationError);

    return _super.apply(this, arguments);
  }

  _createClass(DefaNotificationError, [{
    key: "serviceDetails",
    get: function get() {
      return serviceDetails();
    }
  }]);

  return DefaNotificationError;
}(Vue$1);

__decorate([Prop({
  default: "",
  type: String
}), __metadata("design:type", String)], DefaNotificationError.prototype, "errorMessageKey", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaNotificationError.prototype, "show", void 0);

DefaNotificationError = __decorate([Component({
  components: {
    DefaBaseNotification: __vue_component__$18,
    DefaCircleWrapper: __vue_component__$19
  },
  name: "DefaNotificationError"
})], DefaNotificationError);
var script$17 = DefaNotificationError;

/* script */
const __vue_script__$17 = script$17;

/* template */
var __vue_render__$17 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaBaseNotification',_vm._g({attrs:{"show":_vm.show}},_vm.$listeners),[_c('DefaCircleWrapper',{staticClass:"notification-error__icon-exclamation"},[_vm._v("\n    !\n  ")]),_vm._v(" "),_vm._t("default",function(){return [_c('i18n',{attrs:{"path":_vm.errorMessageKey,"tag":"div"},scopedSlots:_vm._u([{key:"defaMailLink",fn:function(){return [_c('a',{staticClass:"notification-error__link",attrs:{"href":_vm.serviceDetails.emailLink}},[_vm._v(_vm._s(_vm.serviceDetails.email)+"\n        ")])]},proxy:true},{key:"defaPhoneLink",fn:function(){return [_c('a',{staticClass:"notification-error__link",attrs:{"href":_vm.serviceDetails.phoneLink}},[_vm._v("\n          "+_vm._s(_vm.serviceDetails.phone)+"\n        ")])]},proxy:true}])})]})],2)};
var __vue_staticRenderFns__$17 = [];

  /* style */
  const __vue_inject_styles__$17 = function (inject) {
    if (!inject) return
    inject("data-v-518e4c33_0", { source: ".notification-error__link[data-v-518e4c33]{color:var(--defa-oreon-color-primary);text-decoration:none}.notification-error__icon-exclamation[data-v-518e4c33]{flex-basis:2rem;flex-shrink:0;color:#fff;font-size:1.5rem;background-color:var(--defa-oreon-color-error);border-color:var(--defa-oreon-color-error);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$17 = "data-v-518e4c33";
  /* module identifier */
  const __vue_module_identifier__$17 = undefined;
  /* functional template */
  const __vue_is_functional_template__$17 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$17 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$17, staticRenderFns: __vue_staticRenderFns__$17 },
    __vue_inject_styles__$17,
    __vue_script__$17,
    __vue_scope_id__$17,
    __vue_is_functional_template__$17,
    __vue_module_identifier__$17,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$16 = Vue.extend({
  name: "DefaModal",
  components: {
    DefaTransitionFadeOutIn: __vue_component__$1f,
    DefaTransitionSlide: __vue_component__$1a
  },
  props: {
    show: {
      type: Boolean,
      default: true
    },
    duration: {
      type: Number,
      default: 0.3
    },
    enterDelay: {
      type: Number,
      default: 0
    },
    appear: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClickBackdrop: function onClickBackdrop() {
      this.$emit("close");
    }
  }
});

/* script */
const __vue_script__$16 = script$16;

/* template */
var __vue_render__$16 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DefaTransitionSlide',{attrs:{"duration":_vm.duration,"enter-delay":_vm.enterDelay,"percentage-after-enter":-50,"percentage-after-leave":-100,"percentage-before-enter":-100,"appear":""}},[(_vm.show)?_c('div',{staticClass:"defa-modal"},[_vm._t("default")],2):_vm._e()]),_vm._v(" "),_c('DefaTransitionFadeOutIn',{attrs:{"duration":_vm.duration,"enter-delay":_vm.enterDelay,"appear":""}},[(_vm.show)?_c('div',{staticClass:"backdrop",on:{"click":_vm.onClickBackdrop}}):_vm._e()])],1)};
var __vue_staticRenderFns__$16 = [];

  /* style */
  const __vue_inject_styles__$16 = function (inject) {
    if (!inject) return
    inject("data-v-c90d4240_0", { source: ".defa-modal[data-v-c90d4240]{background-color:#fff;position:fixed;left:50%;top:50%;transform:translateX(-50%);border-radius:.25em;box-shadow:0 0 15px rgba(0,0,0,.25);padding:1.5em;z-index:101;text-align:center;line-height:1.6;width:40rem;max-width:90%}.backdrop[data-v-c90d4240]{position:fixed;top:0;left:0;z-index:100;background-color:rgba(0,0,0,.6);width:100%;height:100%;cursor:pointer}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$16 = "data-v-c90d4240";
  /* module identifier */
  const __vue_module_identifier__$16 = undefined;
  /* functional template */
  const __vue_is_functional_template__$16 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$16 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$16, staticRenderFns: __vue_staticRenderFns__$16 },
    __vue_inject_styles__$16,
    __vue_script__$16,
    __vue_scope_id__$16,
    __vue_is_functional_template__$16,
    __vue_module_identifier__$16,
    false,
    createInjector,
    undefined,
    undefined
  );

function ownKeys$3(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys$3(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys$3(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }
var script$15 = Vue.extend({
  name: "DefaInfoBubble",
  props: {
    position: {
      type: String,
      default: "bottom-left"
    }
  },
  computed: {
    serviceDetails: function serviceDetails$1() {
      var serviceDetails$1 = serviceDetails();
      return _objectSpread$3(_objectSpread$3({}, serviceDetails$1), {}, {
        email: serviceDetails$1.hasEmailAlternative ? serviceDetails$1.emailAlternative : serviceDetails$1.email,
        emailLink: serviceDetails$1.hasEmailAlternative ? serviceDetails$1.emailAlternativeLink : serviceDetails$1.emailLink
      });
    }
  }
});

/* script */
const __vue_script__$15 = script$15;

/* template */
var __vue_render__$15 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-bubble",class:_vm.position},[_c('span',{staticClass:"info-bubble__close",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("×")]),_vm._v(" "),_vm._t("default",function(){return [_c('i18n',{attrs:{"path":"defaInfoBubble.defaultText"},scopedSlots:_vm._u([{key:"defaMailLink",fn:function(){return [_c('a',{attrs:{"href":_vm.serviceDetails.emailLink}},[_vm._v(_vm._s(_vm.serviceDetails.email))])]},proxy:true},{key:"defaPhoneLink",fn:function(){return [_c('a',{attrs:{"href":_vm.serviceDetails.phoneLink}},[_vm._v(_vm._s(_vm.serviceDetails.phone))])]},proxy:true}])})]})],2)};
var __vue_staticRenderFns__$15 = [];

  /* style */
  const __vue_inject_styles__$15 = function (inject) {
    if (!inject) return
    inject("data-v-a7c34602_0", { source: ".info-bubble[data-v-a7c34602]{box-shadow:0 3px 15px #00000024;z-index:1;padding:1.5rem;border-radius:1rem;background-color:#fff;width:18rem;font-weight:400}.info-bubble[data-v-a7c34602]:after{content:\"\";width:0;height:0;position:absolute;z-index:1;margin-left:-20px;border-top:solid 20px #fff;border-left:solid 20px transparent;border-right:solid 20px transparent}.info-bubble.bottom-left[data-v-a7c34602]:after{top:100%;left:20%}.info-bubble.bottom-right[data-v-a7c34602]:after{top:100%;right:20%}.info-bubble__close[data-v-a7c34602]{color:#cecece;font-size:2rem;position:absolute;right:12px;top:0;cursor:pointer}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$15 = "data-v-a7c34602";
  /* module identifier */
  const __vue_module_identifier__$15 = undefined;
  /* functional template */
  const __vue_is_functional_template__$15 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$15 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$15, staticRenderFns: __vue_staticRenderFns__$15 },
    __vue_inject_styles__$15,
    __vue_script__$15,
    __vue_scope_id__$15,
    __vue_is_functional_template__$15,
    __vue_module_identifier__$15,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$E(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$E(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$E() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaTestHeader = /*#__PURE__*/function (_Vue) {
  _inherits(DefaTestHeader, _Vue);

  var _super = _createSuper$E(DefaTestHeader);

  function DefaTestHeader() {
    var _this;

    _classCallCheck(this, DefaTestHeader);

    _this = _super.apply(this, arguments);
    _this.shown = true;
    return _this;
  }

  _createClass(DefaTestHeader, [{
    key: "onClose",
    value: function onClose() {
      this.shown = false;
    }
  }, {
    key: "onTest",
    get: function get() {
      return onTest();
    }
  }]);

  return DefaTestHeader;
}(Vue$1);

DefaTestHeader = __decorate([Component({
  components: {
    DefaTransitionSlide: __vue_component__$1a
  },
  name: "DefaTestHeader"
})], DefaTestHeader);
var script$14 = DefaTestHeader;

/* script */
const __vue_script__$14 = script$14;

/* template */
var __vue_render__$14 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.onTest)?_c('DefaTransitionSlide',{attrs:{"enter-delay":1,"appear":""}},[_c('header',{directives:[{name:"show",rawName:"v-show",value:(_vm.shown),expression:"shown"}],staticClass:"test-header",on:{"click":_vm.onClose}},[_vm._v("\n    "+_vm._s(_vm.$t("defaTestHeader.text"))+"\n  ")])]):_vm._e()};
var __vue_staticRenderFns__$14 = [];

  /* style */
  const __vue_inject_styles__$14 = function (inject) {
    if (!inject) return
    inject("data-v-fc9ddbbe_0", { source: ".test-header[data-v-fc9ddbbe]{position:fixed;text-align:center;top:0;left:0;z-index:100;cursor:pointer;width:100vw;color:#fff;font-size:1.5rem;font-weight:700;padding:1rem 0;background-color:var(--defa-oreon-color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$14 = "data-v-fc9ddbbe";
  /* module identifier */
  const __vue_module_identifier__$14 = undefined;
  /* functional template */
  const __vue_is_functional_template__$14 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$14 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$14, staticRenderFns: __vue_staticRenderFns__$14 },
    __vue_inject_styles__$14,
    __vue_script__$14,
    __vue_scope_id__$14,
    __vue_is_functional_template__$14,
    __vue_module_identifier__$14,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$D(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$D(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$D() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaAlertHeader = /*#__PURE__*/function (_Vue) {
  _inherits(DefaAlertHeader, _Vue);

  var _super = _createSuper$D(DefaAlertHeader);

  function DefaAlertHeader() {
    var _this;

    _classCallCheck(this, DefaAlertHeader);

    _this = _super.apply(this, arguments);
    _this.shown = true;
    _this.content = _this.$t("defaAlertHeader.text");
    _this.href = _this.$t("defaAlertHeader.link");
    return _this;
  }

  _createClass(DefaAlertHeader, [{
    key: "onClose",
    value: function onClose() {
      if (this.href.length > 3 && this.href !== "defaAlertHeader.link") {
        window.location.href = String(this.href);
      } else {
        this.shown = false;
      }
    }
  }, {
    key: "showBanner",
    get: function get() {
      return this.content.length > 3 && this.content !== "defaAlertHeader.text";
    }
  }]);

  return DefaAlertHeader;
}(Vue$1);

DefaAlertHeader = __decorate([Component({
  components: {
    DefaTransitionSlide: __vue_component__$1a
  },
  name: "defaAlertHeader"
})], DefaAlertHeader);
var script$13 = DefaAlertHeader;

/* script */
const __vue_script__$13 = script$13;

/* template */
var __vue_render__$13 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBanner)?_c('DefaTransitionSlide',{attrs:{"enter-delay":1,"appear":""}},[_c('header',{directives:[{name:"show",rawName:"v-show",value:(_vm.shown),expression:"shown"}],staticClass:"alert-header",on:{"click":_vm.onClose}},[_vm._v("\n    "+_vm._s(_vm.$t("defaAlertHeader.text"))+"\n  ")])]):_vm._e()};
var __vue_staticRenderFns__$13 = [];

  /* style */
  const __vue_inject_styles__$13 = function (inject) {
    if (!inject) return
    inject("data-v-735824ee_0", { source: ".alert-header[data-v-735824ee]{position:fixed;text-align:center;top:0;left:0;z-index:100;cursor:pointer;width:100vw;color:#fff;font-size:1.5rem;font-weight:700;padding:1rem 0;background-color:var(--defa-oreon-color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$13 = "data-v-735824ee";
  /* module identifier */
  const __vue_module_identifier__$13 = undefined;
  /* functional template */
  const __vue_is_functional_template__$13 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$13 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$13, staticRenderFns: __vue_staticRenderFns__$13 },
    __vue_inject_styles__$13,
    __vue_script__$13,
    __vue_scope_id__$13,
    __vue_is_functional_template__$13,
    __vue_module_identifier__$13,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$C(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$C(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$C() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaPageNotFound = /*#__PURE__*/function (_Vue) {
  _inherits(DefaPageNotFound, _Vue);

  var _super = _createSuper$C(DefaPageNotFound);

  function DefaPageNotFound() {
    _classCallCheck(this, DefaPageNotFound);

    return _super.apply(this, arguments);
  }

  _createClass(DefaPageNotFound, [{
    key: "cssProps",
    get: function get() {
      return {
        "--text-color": this.textColor
      };
    }
  }]);

  return DefaPageNotFound;
}(Vue$1);

__decorate([Prop({
  default: "black",
  type: String
}), __metadata("design:type", String)], DefaPageNotFound.prototype, "textColor", void 0);

DefaPageNotFound = __decorate([Component({
  name: "DefaPageNotFound"
})], DefaPageNotFound);
var script$12 = DefaPageNotFound;

/* script */
const __vue_script__$12 = script$12;

/* template */
var __vue_render__$12 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-not-found",style:(_vm.cssProps)},[_c('h2',{staticClass:"text"},[_vm._v("\n    "+_vm._s(_vm.$t("defaPageNotFound.text"))+"\n  ")]),_vm._v(" "),_c('svg',{staticClass:"page-not-found__icon",attrs:{"viewBox":"0 0 122.88 98.31","x":"0px","y":"0px"}},[_c('g',[_c('path',{staticClass:"st0",attrs:{"d":"M8.32,0h106.24c4.57,0,8.32,3.74,8.32,8.32V90c0,4.57-3.74,8.32-8.32,8.32l-106.24,0C3.74,98.31,0,94.57,0,90 V8.32C0,3.74,3.74,0,8.32,0L8.32,0z M37.46,65.4H23.01v-6.53l14.45-17.18h6.9v17.56h3.59v6.15h-3.59v5.35h-6.9V65.4L37.46,65.4z M37.46,59.25v-9.02l-7.63,9.02H37.46L37.46,59.25z M49.77,56.34c0-5.43,0.98-9.23,2.93-11.39c1.96-2.17,4.94-3.25,8.93-3.25 c1.92,0,3.51,0.24,4.74,0.71c1.24,0.47,2.24,1.09,3.02,1.85c0.78,0.76,1.4,1.56,1.84,2.39c0.45,0.84,0.81,1.82,1.08,2.93 c0.53,2.13,0.8,4.35,0.8,6.67c0,5.18-0.88,8.97-2.63,11.37c-1.75,2.4-4.77,3.61-9.06,3.61c-2.4,0-4.34-0.39-5.83-1.15 c-1.48-0.77-2.69-1.89-3.65-3.37c-0.69-1.05-1.22-2.49-1.61-4.31C49.96,60.56,49.77,58.55,49.77,56.34L49.77,56.34z M57.63,56.35 c0,3.63,0.32,6.12,0.96,7.45c0.64,1.33,1.58,2,2.8,2c0.8,0,1.5-0.28,2.1-0.84c0.59-0.57,1.02-1.46,1.3-2.68 c0.28-1.22,0.42-3.13,0.42-5.71c0-3.79-0.32-6.34-0.96-7.65c-0.65-1.3-1.61-1.96-2.89-1.96c-1.32,0-2.26,0.67-2.85,2 C57.92,50.28,57.63,52.75,57.63,56.35L57.63,56.35z M89.37,65.4H74.92v-6.53l14.45-17.18h6.9v17.56h3.59v6.15h-3.59v5.35h-6.9V65.4 L89.37,65.4z M89.37,59.25v-9.02l-7.63,9.02H89.37L89.37,59.25z M117.97,23.29H5.29v67.51c0,0.64,0.25,1.2,0.67,1.63 c0.42,0.43,0.99,0.67,1.63,0.67h108.04c0.64,0,1.2-0.25,1.63-0.67c0.43-0.43,0.67-0.99,0.67-1.63l0-67.51H117.97L117.97,23.29z M106.64,9.35c2.27,0,4.11,1.84,4.11,4.11c0,2.27-1.84,4.11-4.11,4.11c-2.27,0-4.11-1.84-4.11-4.11 C102.54,11.19,104.38,9.35,106.64,9.35L106.64,9.35z M78.8,9.35c2.27,0,4.11,1.84,4.11,4.11c0,2.27-1.84,4.11-4.11,4.11 c-2.27,0-4.11-1.84-4.11-4.11C74.69,11.19,76.53,9.35,78.8,9.35L78.8,9.35z M92.72,9.35c2.27,0,4.11,1.84,4.11,4.11 c0,2.27-1.84,4.11-4.11,4.11c-2.27,0-4.11-1.84-4.11-4.11C88.61,11.19,90.45,9.35,92.72,9.35L92.72,9.35z"}})])]),_vm._v(" "),_vm._t("default",null,{"linkText":_vm.$t('defaPageNotFound.back')})],2)};
var __vue_staticRenderFns__$12 = [];

  /* style */
  const __vue_inject_styles__$12 = function (inject) {
    if (!inject) return
    inject("data-v-7aa11a40_0", { source: ".page-not-found[data-v-7aa11a40]{display:flex;flex-direction:column;justify-content:center;gap:2rem;align-items:center;color:var(--text-color)}.page-not-found__icon[data-v-7aa11a40]{fill:var(--defa-oreon-color-primary);width:10rem}.page-not-found__icon .st0[data-v-7aa11a40]{fill-rule:evenodd;clip-rule:evenodd}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$12 = "data-v-7aa11a40";
  /* module identifier */
  const __vue_module_identifier__$12 = undefined;
  /* functional template */
  const __vue_is_functional_template__$12 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$12 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$12, staticRenderFns: __vue_staticRenderFns__$12 },
    __vue_inject_styles__$12,
    __vue_script__$12,
    __vue_scope_id__$12,
    __vue_is_functional_template__$12,
    __vue_module_identifier__$12,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$B(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$B(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$B() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Load an initial low quality image, to serve as a placeholder for a higher-res image
 * This tactic can only be used with imgix images
 */

var DefaBlurUpImage = /*#__PURE__*/function (_Vue) {
  _inherits(DefaBlurUpImage, _Vue);

  var _super = _createSuper$B(DefaBlurUpImage);

  function DefaBlurUpImage() {
    var _this;

    _classCallCheck(this, DefaBlurUpImage);

    _this = _super.apply(this, arguments);
    _this.imageLoaded = false;
    _this.imageBlurredLoaded = false;
    return _this;
  }

  _createClass(DefaBlurUpImage, [{
    key: "imageOnLoad",
    value: function imageOnLoad() {
      this.imageLoaded = true;
    }
  }, {
    key: "imageBlurredOnLoad",
    value: function imageBlurredOnLoad() {
      this.imageBlurredLoaded = true;
    } // For use in image carousel component

  }, {
    key: "onSrcChange",
    value: function onSrcChange() {
      this.imageLoaded = false;
      this.imageBlurredLoaded = false;
    }
  }, {
    key: "imageBlurredShown",
    get: function get() {
      return !this.imageLoaded && this.imageBlurredLoaded;
    }
  }, {
    key: "imagePlaceholderShown",
    get: function get() {
      return !this.imageBlurredLoaded;
    }
  }, {
    key: "cssProps",
    get: function get() {
      return {
        "--image-width": "".concat(this.imageWidth, "px"),
        "--image-height": "".concat(this.imageHeight, "px")
      };
    }
  }, {
    key: "blurredSource",
    get: function get() {
      var _context;

      return _concatInstanceProperty(_context = "".concat(this.src, "?auto=format&px=16&blur=200&")).call(_context, this.commonParams);
    }
  }, {
    key: "originalSource",
    get: function get() {
      var _context2;

      return _concatInstanceProperty(_context2 = "".concat(this.src, "?auto=compress,enhance&")).call(_context2, this.commonParams);
    }
  }, {
    key: "commonParams",
    get: function get() {
      var _context3, _context4, _context5;

      return _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = _concatInstanceProperty(_context5 = "w=".concat(this.imageWidth, "&h=")).call(_context5, this.imageHeight, "&orient=")).call(_context4, this.orientation, "&")).call(_context3, this.extraParams);
    }
  }]);

  return DefaBlurUpImage;
}(Vue$1);

__decorate([Prop({
  required: true,
  type: String
}), __metadata("design:type", String)], DefaBlurUpImage.prototype, "src", void 0);

__decorate([Prop({
  required: true,
  type: Number
}), __metadata("design:type", Number)], DefaBlurUpImage.prototype, "imageWidth", void 0);

__decorate([Prop({
  required: true,
  type: Number
}), __metadata("design:type", Number)], DefaBlurUpImage.prototype, "imageHeight", void 0);

__decorate([Prop({
  required: true,
  type: String
}), __metadata("design:type", String)], DefaBlurUpImage.prototype, "alt", void 0);

__decorate([Prop({
  default: 0,
  type: Number
}), __metadata("design:type", Number)], DefaBlurUpImage.prototype, "orientation", void 0);

__decorate([Prop({
  default: "",
  type: String
}), __metadata("design:type", String)], DefaBlurUpImage.prototype, "extraParams", void 0);

__decorate([Watch("src"), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], DefaBlurUpImage.prototype, "onSrcChange", null);

DefaBlurUpImage = __decorate([Component({
  name: "DefaBlurUpImage"
})], DefaBlurUpImage);
var script$11 = DefaBlurUpImage;

/* script */
const __vue_script__$11 = script$11;

/* template */
var __vue_render__$11 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"blur-up-image",style:(_vm.cssProps),attrs:{"href":_vm.src,"rel":"noopener","target":"_blank"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.imageLoaded),expression:"imageLoaded"}],staticClass:"image",attrs:{"alt":_vm.alt,"src":_vm.originalSource,"height":_vm.imageHeight,"width":_vm.imageWidth},on:{"load":_vm.imageOnLoad}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.imageBlurredShown),expression:"imageBlurredShown"}],staticClass:"image",attrs:{"src":_vm.blurredSource},on:{"load":_vm.imageBlurredOnLoad}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.imagePlaceholderShown),expression:"imagePlaceholderShown"}],staticClass:"blur-up-image__placeholder"})])};
var __vue_staticRenderFns__$11 = [];

  /* style */
  const __vue_inject_styles__$11 = function (inject) {
    if (!inject) return
    inject("data-v-5cdea446_0", { source: ".blur-up-image[data-v-5cdea446]{display:block;width:var(--image-width);height:var(--image-height)}.blur-up-image__placeholder[data-v-5cdea446]{height:100%;background-color:#eee}.image[data-v-5cdea446]::-moz-selection{background-color:transparent}.image[data-v-5cdea446]::selection{background-color:transparent}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$11 = "data-v-5cdea446";
  /* module identifier */
  const __vue_module_identifier__$11 = undefined;
  /* functional template */
  const __vue_is_functional_template__$11 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$11 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$11, staticRenderFns: __vue_staticRenderFns__$11 },
    __vue_inject_styles__$11,
    __vue_script__$11,
    __vue_scope_id__$11,
    __vue_is_functional_template__$11,
    __vue_module_identifier__$11,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$A(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$A(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$A() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaImageCarouselContainer = /*#__PURE__*/function (_Vue) {
  _inherits(DefaImageCarouselContainer, _Vue);

  var _super = _createSuper$A(DefaImageCarouselContainer);

  function DefaImageCarouselContainer() {
    var _this;

    _classCallCheck(this, DefaImageCarouselContainer);

    _this = _super.apply(this, arguments);
    _this.imageWidth = document.documentElement.clientWidth;
    _this.imageHeight = document.documentElement.clientHeight;
    return _this;
  }

  _createClass(DefaImageCarouselContainer, [{
    key: "styleTransform",
    get: function get() {
      return {
        transform: "translateX(-".concat(this.activeIndex * this.imageWidth, "px)")
      };
    }
  }]);

  return DefaImageCarouselContainer;
}(Vue$1);

__decorate([Prop({
  required: true,
  type: Array
}), __metadata("design:type", Array)], DefaImageCarouselContainer.prototype, "images", void 0);

__decorate([Prop({
  required: true,
  type: Number
}), __metadata("design:type", Number)], DefaImageCarouselContainer.prototype, "activeIndex", void 0);

__decorate([Prop({
  default: 0,
  type: Number
}), __metadata("design:type", Number)], DefaImageCarouselContainer.prototype, "orientation", void 0);

DefaImageCarouselContainer = __decorate([Component({
  components: {
    DefaBlurUpImage: __vue_component__$11
  },
  name: "DefaImageCarouselContainer"
})], DefaImageCarouselContainer);
var script$10 = DefaImageCarouselContainer;

/* script */
const __vue_script__$10 = script$10;

/* template */
var __vue_render__$10 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-carousel-container-wrapper",style:({
    '--height': (_vm.imageHeight + "px"),
    '--width': (_vm.imageWidth + "px"),
    '--image-amount': _vm.images.length,
  })},[_c('div',{staticClass:"image-carousel-container",style:(_vm.styleTransform)},_vm._l((_vm.images),function(image){return _c('DefaBlurUpImage',{key:image.id,attrs:{"alt":_vm.$t('defaImageCarousel.currentImage.alt'),"image-height":_vm.imageHeight,"image-width":_vm.imageWidth,"orientation":_vm.orientation,"src":image.url,"extra-params":"fit=fillmax&fill=blur"}})}),1)])};
var __vue_staticRenderFns__$10 = [];

  /* style */
  const __vue_inject_styles__$10 = function (inject) {
    if (!inject) return
    inject("data-v-19e65a26_0", { source: ".image-carousel-container-wrapper[data-v-19e65a26]{width:var(--width);height:var(--height);overflow:hidden}.image-carousel-container[data-v-19e65a26]{transform-style:preserve-3d;display:grid;grid-template-columns:repeat(var(--image-amount),auto);transition:transform .2s ease;transform:translateX(0)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$10 = "data-v-19e65a26";
  /* module identifier */
  const __vue_module_identifier__$10 = undefined;
  /* functional template */
  const __vue_is_functional_template__$10 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$10 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$10, staticRenderFns: __vue_staticRenderFns__$10 },
    __vue_inject_styles__$10,
    __vue_script__$10,
    __vue_scope_id__$10,
    __vue_is_functional_template__$10,
    __vue_module_identifier__$10,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$z(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$z(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$z() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaImageCarouselDots = /*#__PURE__*/function (_Vue) {
  _inherits(DefaImageCarouselDots, _Vue);

  var _super = _createSuper$z(DefaImageCarouselDots);

  function DefaImageCarouselDots() {
    _classCallCheck(this, DefaImageCarouselDots);

    return _super.apply(this, arguments);
  }

  _createClass(DefaImageCarouselDots, [{
    key: "isActive",
    value: function isActive(index) {
      return index === this.indexActive;
    }
  }, {
    key: "indices",
    get: function get() {
      var _context, _context2;

      return _mapInstanceProperty(_context = _fillInstanceProperty(_context2 = new Array(this.amount)).call(_context2, null)).call(_context, function (_, i) {
        return i;
      });
    }
  }]);

  return DefaImageCarouselDots;
}(Vue$1);

__decorate([Prop({
  required: true,
  type: Number
}), __metadata("design:type", Number)], DefaImageCarouselDots.prototype, "indexActive", void 0);

__decorate([Prop({
  required: true,
  type: Number
}), __metadata("design:type", Number)], DefaImageCarouselDots.prototype, "amount", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaImageCarouselDots.prototype, "darkMode", void 0);

DefaImageCarouselDots = __decorate([Component({
  name: "DefaImageCarouselDots"
})], DefaImageCarouselDots);
var script$$ = DefaImageCarouselDots;

/* script */
const __vue_script__$$ = script$$;

/* template */
var __vue_render__$$ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-carousel-dots"},_vm._l((_vm.indices),function(i){return _c('div',{key:i,staticClass:"image-carousel-dot",class:{
      'image-carousel-dot--active': _vm.isActive(i),
      'image-carousel-dot--dark': _vm.darkMode,
    },on:{"click":function($event){return _vm.$emit('click:dot', { index: i })}}})}),0)};
var __vue_staticRenderFns__$$ = [];

  /* style */
  const __vue_inject_styles__$$ = function (inject) {
    if (!inject) return
    inject("data-v-9ba9f728_0", { source: ".image-carousel-dots[data-v-9ba9f728]{display:flex;gap:.5rem}.image-carousel-dot[data-v-9ba9f728]{width:2rem;height:2rem;border-radius:50%;opacity:.4;transition:opacity .5s ease;background-color:var(--defa-oreon-color-gray-shade-1)}.image-carousel-dot--dark[data-v-9ba9f728]{background-color:var(--defa-oreon-color-gray-shade-5)}.image-carousel-dot--active[data-v-9ba9f728]{opacity:1}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$$ = "data-v-9ba9f728";
  /* module identifier */
  const __vue_module_identifier__$$ = undefined;
  /* functional template */
  const __vue_is_functional_template__$$ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$$ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$$, staticRenderFns: __vue_staticRenderFns__$$ },
    __vue_inject_styles__$$,
    __vue_script__$$,
    __vue_scope_id__$$,
    __vue_is_functional_template__$$,
    __vue_module_identifier__$$,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$y(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$y(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$y() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaImageCarousel = /*#__PURE__*/function (_Vue) {
  _inherits(DefaImageCarousel, _Vue);

  var _super = _createSuper$y(DefaImageCarousel);

  function DefaImageCarousel() {
    var _this;

    _classCallCheck(this, DefaImageCarousel);

    _this = _super.apply(this, arguments);
    _this.currentImage = null;
    _this.orientation = 0;
    _this.imageWidth = document.documentElement.clientWidth * 0.8;
    _this.imageHeight = document.documentElement.clientHeight * 0.8;
    return _this;
  }

  _createClass(DefaImageCarousel, [{
    key: "rotateLeft",
    value: function rotateLeft() {
      if (this.orientation === 0) {
        this.orientation = 270;
      } else {
        this.orientation -= 90;
      }
    }
  }, {
    key: "rotateRight",
    value: function rotateRight() {
      if (this.orientation === 270) {
        this.orientation = 0;
      } else {
        this.orientation += 90;
      }
    }
  }, {
    key: "hideImageCarousel",
    value: function hideImageCarousel() {
      this.orientation = 0;
      this.$emit("hide");
    }
  }, {
    key: "goToNextImage",
    value: function goToNextImage() {
      if (this.currentImageIndex === this.images.length - 1) {
        this.currentImage = this.images[0];
      } else {
        this.currentImage = this.images[this.currentImageIndex + 1];
      }

      this.orientation = 0;
    }
  }, {
    key: "goToPreviousImage",
    value: function goToPreviousImage() {
      if (this.currentImageIndex === 0) {
        this.currentImage = this.images[this.images.length - 1];
      } else {
        this.currentImage = this.images[this.currentImageIndex - 1];
      }

      this.orientation = 0;
    }
  }, {
    key: "onClickDot",
    value: function onClickDot(_ref) {
      var index = _ref.index;
      this.currentImage = this.images[index];
      this.orientation = 0;
    }
  }, {
    key: "onImageChange",
    value: function onImageChange() {
      if (this.image) {
        this.currentImage = this.image;
        document.body.addEventListener("keyup", this.handleKeyUp);
      } else {
        this.currentImage = null;
        document.body.removeEventListener("keyup", this.handleKeyUp);
      }
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(e) {
      if (e.key === "ArrowRight" || e.key === "ArrowDown") {
        this.goToNextImage();
      }

      if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
        this.goToPreviousImage();
      }

      if (e.key === "Escape") {
        this.hideImageCarousel();
      }
    }
  }, {
    key: "moreThanOneImage",
    get: function get() {
      return this.images.length > 1;
    }
  }, {
    key: "currentImageIndex",
    get: function get() {
      var _context,
          _this2 = this;

      return _findIndexInstanceProperty(_context = this.images).call(_context, function (image) {
        var _this2$currentImage;

        return ((_this2$currentImage = _this2.currentImage) === null || _this2$currentImage === void 0 ? void 0 : _this2$currentImage.id) === image.id;
      });
    }
  }]);

  return DefaImageCarousel;
}(Vue$1);

__decorate([Prop({
  required: true,
  type: Array
}), __metadata("design:type", Array)], DefaImageCarousel.prototype, "images", void 0);

__decorate([Prop({
  default: null,
  type: Object
}), __metadata("design:type", Object)], DefaImageCarousel.prototype, "image", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaImageCarousel.prototype, "darkModeDots", void 0);

__decorate([Watch("image"), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], DefaImageCarousel.prototype, "onImageChange", null);

DefaImageCarousel = __decorate([Component({
  components: {
    DefaImageCarouselContainer: __vue_component__$10,
    DefaTransitionFadeOutIn: __vue_component__$1f,
    DefaImageCarouselDots: __vue_component__$$,
    DefaBlurUpImage: __vue_component__$11
  },
  name: "DefaImageCarousel"
})], DefaImageCarousel);
var script$_ = DefaImageCarousel;

/* script */
const __vue_script__$_ = script$_;

/* template */
var __vue_render__$_ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaTransitionFadeOutIn',[(_vm.currentImage)?_c('div',{staticClass:"image-carousel-backdrop"},[_c('DefaImageCarouselContainer',{attrs:{"images":_vm.images,"active-index":_vm.currentImageIndex,"orientation":_vm.orientation}}),_vm._v(" "),_c('div',{staticClass:"image-carousel__icon image-carousel__icon--close",attrs:{"title":_vm.$t('defaImageCarousel.close.title')},on:{"click":_vm.hideImageCarousel}},[_vm._v("\n      ×\n    ")]),_vm._v(" "),(_vm.moreThanOneImage)?_c('div',{staticClass:"image-carousel__icon image-carousel__icon--previous",attrs:{"title":_vm.$t('defaImageCarousel.previous.title')},on:{"click":_vm.goToPreviousImage}},[_vm._v("\n      ❮\n    ")]):_vm._e(),_vm._v(" "),(_vm.moreThanOneImage)?_c('div',{staticClass:"image-carousel__icon image-carousel__icon--next",attrs:{"title":_vm.$t('defaImageCarousel.next.title')},on:{"click":_vm.goToNextImage}},[_vm._v("\n      ❯\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"image-carousel__icons-rotation"},[_c('div',{staticClass:"image-carousel__icon image-carousel__icon--rotate",attrs:{"title":_vm.$t('defaImageCarousel.rotateLeft.title')},on:{"click":_vm.rotateLeft}},[_vm._v("\n        ⟲\n      ")]),_vm._v(" "),_c('div',{staticClass:"image-carousel__icon image-carousel__icon--rotate",attrs:{"title":_vm.$t('defaImageCarousel.rotateRight.title')},on:{"click":_vm.rotateRight}},[_vm._v("\n        ⟳\n      ")])]),_vm._v(" "),_c('DefaImageCarouselDots',{staticClass:"image-carousel__dots",attrs:{"amount":_vm.images.length,"index-active":_vm.currentImageIndex,"dark-mode":_vm.darkModeDots},on:{"click:dot":_vm.onClickDot}})],1):_vm._e()])};
var __vue_staticRenderFns__$_ = [];

  /* style */
  const __vue_inject_styles__$_ = function (inject) {
    if (!inject) return
    inject("data-v-01c97f40_0", { source: ".image-carousel-backdrop[data-v-01c97f40]{position:fixed;z-index:1;top:0;left:0;right:0;bottom:0;display:flex;justify-content:center;align-items:center;background-color:rgba(0,0,0,.4);cursor:pointer}.image-carousel__icon[data-v-01c97f40]{transition:background-color .3s ease;background-color:rgba(0,0,0,.1);color:#fff;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.image-carousel__icon[data-v-01c97f40]:hover{background-color:rgba(0,0,0,.7)}.image-carousel__icon--rotate[data-v-01c97f40]{padding:calc(1em / 6) calc(1em / 4 * 3)}.image-carousel__icon--next[data-v-01c97f40]{position:absolute;font-size:3rem;right:0;top:50%;transform:translateY(-50%);padding:calc(1em / 3) calc(1em / 4)}.image-carousel__icon--previous[data-v-01c97f40]{position:absolute;font-size:3rem;left:0;top:50%;transform:translateY(-50%);padding:calc(1em / 3) calc(1em / 4)}.image-carousel__icon--close[data-v-01c97f40]{position:absolute;font-size:2rem;right:0;top:0;padding:calc(1em / 6) calc(1em / 4 * 3)}.image-carousel__icons-rotation[data-v-01c97f40]{display:flex;gap:1rem;position:absolute;font-size:2rem;top:0;left:50%;transform:translateX(-50%)}.image-carousel__dots[data-v-01c97f40]{position:absolute;bottom:2rem;left:50%;transform:translateX(-50%)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$_ = "data-v-01c97f40";
  /* module identifier */
  const __vue_module_identifier__$_ = undefined;
  /* functional template */
  const __vue_is_functional_template__$_ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$_ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$_, staticRenderFns: __vue_staticRenderFns__$_ },
    __vue_inject_styles__$_,
    __vue_script__$_,
    __vue_scope_id__$_,
    __vue_is_functional_template__$_,
    __vue_module_identifier__$_,
    false,
    createInjector,
    undefined,
    undefined
  );

var _context$1;
var TIME_DEFAULT = "00:00";
var DATE_FORMAT = "dd/MM/yyyy";
var TIME_FORMAT = "HH:mm";
var DATE_TIME_FORMAT = _concatInstanceProperty(_context$1 = "".concat(DATE_FORMAT, " ")).call(_context$1, TIME_FORMAT);
var formatDateString = function formatDateString(date) {
  var dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DATE_FORMAT;
  return format(parseISO(date), dateFormat);
};
var formatTimeString = function formatTimeString(time) {
  var timeFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TIME_FORMAT;
  return format(time, timeFormat);
};

function _createSuper$x(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$x(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$x() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaTrackingInformation = /*#__PURE__*/function (_Vue) {
  _inherits(DefaTrackingInformation, _Vue);

  var _super = _createSuper$x(DefaTrackingInformation);

  function DefaTrackingInformation() {
    _classCallCheck(this, DefaTrackingInformation);

    return _super.apply(this, arguments);
  }

  _createClass(DefaTrackingInformation, [{
    key: "expectedDeliveryDateFormatted",
    get: function get() {
      return function (trackingInfo) {
        return formatDateString(trackingInfo.expectedDeliveryDate);
      };
    }
  }]);

  return DefaTrackingInformation;
}(Vue$1);

__decorate([Prop({
  required: true,
  type: Array
}), __metadata("design:type", Array)], DefaTrackingInformation.prototype, "trackingInfoList", void 0);

DefaTrackingInformation = __decorate([Component({
  name: "DefaTrackingInformation"
})], DefaTrackingInformation);
var script$Z = DefaTrackingInformation;

/* script */
const __vue_script__$Z = script$Z;

/* template */
var __vue_render__$Z = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tracking-links"},_vm._l((_vm.trackingInfoList),function(trackingInfo,i){return _c('li',{key:i,staticClass:"tracking-links__item"},[_c('a',{staticClass:"tracking-links__uri",attrs:{"href":trackingInfo.trackingUri,"rel":"noopener","target":"_blank"}},[_vm._v("\n      "+_vm._s(trackingInfo.trackingUri)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"tracking-links__expected-delivery-date"},[_vm._v("\n      "+_vm._s(_vm.$t("defaTrackingInformation.expectedDeliveryDate", {
          date: _vm.expectedDeliveryDateFormatted(trackingInfo),
        }))+"\n    ")])])}),0)};
var __vue_staticRenderFns__$Z = [];

  /* style */
  const __vue_inject_styles__$Z = function (inject) {
    if (!inject) return
    inject("data-v-47ffd4c1_0", { source: ".tracking-links[data-v-47ffd4c1]{list-style-type:none;padding-left:0}.tracking-links__item[data-v-47ffd4c1]{margin:1rem 0}.tracking-links__uri[data-v-47ffd4c1]{text-decoration:none;color:var(--defa-oreon-color-primary)}.tracking-links__expected-delivery-date[data-v-47ffd4c1]{color:var(--defa-oreon-color-gray-shade-5);font-size:.9rem}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$Z = "data-v-47ffd4c1";
  /* module identifier */
  const __vue_module_identifier__$Z = undefined;
  /* functional template */
  const __vue_is_functional_template__$Z = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$Z = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$Z, staticRenderFns: __vue_staticRenderFns__$Z },
    __vue_inject_styles__$Z,
    __vue_script__$Z,
    __vue_scope_id__$Z,
    __vue_is_functional_template__$Z,
    __vue_module_identifier__$Z,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$w(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$w(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$w() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaLanguageSwitcher = /*#__PURE__*/function (_Vue) {
  _inherits(DefaLanguageSwitcher, _Vue);

  var _super = _createSuper$w(DefaLanguageSwitcher);

  function DefaLanguageSwitcher() {
    var _this;

    _classCallCheck(this, DefaLanguageSwitcher);

    _this = _super.apply(this, arguments);
    _this.currentLocale = getLocale();
    return _this;
  }

  _createClass(DefaLanguageSwitcher, [{
    key: "onChangeLocale",
    // We're only allowing this to be used locally or on test, so we don't have to account for prod environment
    value: function onChangeLocale(newLocale) {
      setLangInLocalStorage(newLocale);
      window.location.reload();
    }
  }, {
    key: "isEnabled",
    get: function get() {
      return isLanguageSwitcherEnabled();
    }
  }, {
    key: "supportedLocalesWithDisplayNames",
    get: function get() {
      var _context,
          _this2 = this;

      return _mapInstanceProperty(_context = supportedLocales()).call(_context, function (locale) {
        return {
          displayName: _this2.$t("defaLanguageSwitcher.languages.".concat(locale)),
          locale: locale
        };
      });
    }
  }]);

  return DefaLanguageSwitcher;
}(Vue$1);

DefaLanguageSwitcher = __decorate([Component({
  name: "DefaLanguageSwitcher"
})], DefaLanguageSwitcher);
var script$Y = DefaLanguageSwitcher;

/* script */
const __vue_script__$Y = script$Y;

/* template */
var __vue_render__$Y = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isEnabled)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentLocale),expression:"currentLocale"}],staticClass:"language-switcher",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentLocale=$event.target.multiple ? $$selectedVal : $$selectedVal[0];},function($event){return _vm.onChangeLocale($event.target.value)}]}},_vm._l((_vm.supportedLocalesWithDisplayNames),function(localeWithDisplayName){return _c('option',{key:localeWithDisplayName.locale,domProps:{"value":localeWithDisplayName.locale}},[_vm._v("\n    "+_vm._s(localeWithDisplayName.displayName)+"\n  ")])}),0):_vm._e()};
var __vue_staticRenderFns__$Y = [];

  /* style */
  const __vue_inject_styles__$Y = function (inject) {
    if (!inject) return
    inject("data-v-2a86df80_0", { source: ".language-switcher[data-v-2a86df80]{position:absolute;z-index:10000;top:4px;left:50%;transform:translateX(-50%);opacity:.03;transition:opacity .3s ease-in}.language-switcher[data-v-2a86df80]:hover{opacity:1}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$Y = "data-v-2a86df80";
  /* module identifier */
  const __vue_module_identifier__$Y = undefined;
  /* functional template */
  const __vue_is_functional_template__$Y = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$Y = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$Y, staticRenderFns: __vue_staticRenderFns__$Y },
    __vue_inject_styles__$Y,
    __vue_script__$Y,
    __vue_scope_id__$Y,
    __vue_is_functional_template__$Y,
    __vue_module_identifier__$Y,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$v(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$v(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$v() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaRetailerGroupLogo = /*#__PURE__*/function (_Vue) {
  _inherits(DefaRetailerGroupLogo, _Vue);

  var _super = _createSuper$v(DefaRetailerGroupLogo);

  function DefaRetailerGroupLogo() {
    _classCallCheck(this, DefaRetailerGroupLogo);

    return _super.apply(this, arguments);
  }

  _createClass(DefaRetailerGroupLogo, [{
    key: "retailerGroupLogoAlt",
    get: function get() {
      if (this.retailerGroupName) {
        return this.$t("defaRetailerGroup.alt.retailerLogo", {
          retailerGroup: this.retailerGroupName
        });
      }

      return this.$t("defaRetailerGroup.alt.retailerLogoDefault");
    }
  }, {
    key: "imageStyle",
    get: function get() {
      return {
        "--logo-height": "".concat(this.height, "px"),
        "--logo-width": "".concat(this.width, "px")
      };
    }
  }, {
    key: "retailerGroupLogoSrc",
    get: function get() {
      return retailerGroupLogoSrc(this.retailerGroupHandle, this.color);
    }
  }]);

  return DefaRetailerGroupLogo;
}(Vue$1);

__decorate([Prop({
  required: true,
  type: String
}), __metadata("design:type", String)], DefaRetailerGroupLogo.prototype, "height", void 0);

__decorate([Prop({
  required: true,
  type: String
}), __metadata("design:type", String)], DefaRetailerGroupLogo.prototype, "width", void 0);

__decorate([Prop({
  default: defaRetailerGroupHandle,
  type: String
}), __metadata("design:type", String)], DefaRetailerGroupLogo.prototype, "retailerGroupHandle", void 0);

__decorate([Prop({
  default: "DEFA",
  type: String
}), __metadata("design:type", String)], DefaRetailerGroupLogo.prototype, "retailerGroupName", void 0);

__decorate([Prop({
  default: "w",
  type: String
}), __metadata("design:type", String)], DefaRetailerGroupLogo.prototype, "color", void 0);

DefaRetailerGroupLogo = __decorate([Component({
  name: "DefaRetailerGroupLogo"
})], DefaRetailerGroupLogo);
var script$X = DefaRetailerGroupLogo;

/* script */
const __vue_script__$X = script$X;

/* template */
var __vue_render__$X = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"retailer-group-logo",style:(_vm.imageStyle)},[_c('img',{staticClass:"retailer-group-logo__img",attrs:{"alt":_vm.retailerGroupLogoAlt,"height":_vm.height,"src":_vm.retailerGroupLogoSrc,"width":_vm.width}})])};
var __vue_staticRenderFns__$X = [];

  /* style */
  const __vue_inject_styles__$X = function (inject) {
    if (!inject) return
    inject("data-v-5320ee97_0", { source: ".retailer-group-logo[data-v-5320ee97]{height:var(--logo-height);width:var(--logo-width);display:flex;justify-content:center;align-items:center}.retailer-group-logo__img[data-v-5320ee97]{height:auto;max-width:100%}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$X = "data-v-5320ee97";
  /* module identifier */
  const __vue_module_identifier__$X = undefined;
  /* functional template */
  const __vue_is_functional_template__$X = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$X = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$X, staticRenderFns: __vue_staticRenderFns__$X },
    __vue_inject_styles__$X,
    __vue_script__$X,
    __vue_scope_id__$X,
    __vue_is_functional_template__$X,
    __vue_module_identifier__$X,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$W = Vue.extend({
  name: "DefaIconEllipsis"
});

/* script */
const __vue_script__$W = script$W;

/* template */
var __vue_render__$W = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon-ellipsis",attrs:{"viewBox":"0 0 10 4"}},[_c('title',[_vm._v(_vm._s(_vm.$t("defaIconEllipsis.title")))]),_vm._v(" "),_c('circle',{attrs:{"cx":"2","cy":"2","r":"1"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"5","cy":"2","r":"1"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"8","cy":"2","r":"1"}})])};
var __vue_staticRenderFns__$W = [];

  /* style */
  const __vue_inject_styles__$W = function (inject) {
    if (!inject) return
    inject("data-v-4caee86f_0", { source: ".icon-ellipsis[data-v-4caee86f]{fill:var(--defa-oreon-color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$W = "data-v-4caee86f";
  /* module identifier */
  const __vue_module_identifier__$W = undefined;
  /* functional template */
  const __vue_is_functional_template__$W = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$W = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$W, staticRenderFns: __vue_staticRenderFns__$W },
    __vue_inject_styles__$W,
    __vue_script__$W,
    __vue_scope_id__$W,
    __vue_is_functional_template__$W,
    __vue_module_identifier__$W,
    false,
    createInjector,
    undefined,
    undefined
  );

var ANIMATION_DURATION_DOT = 0.4;
var ANIMATION_POSITION = "<".concat(ANIMATION_DURATION_DOT / 2);
var OPACITY_PERCENTAGE_DIVIDER = 5;
var script$V = Vue.extend({
  name: "DefaLoadingTextWithEllipsis",
  components: {
    DefaIconEllipsis: __vue_component__$W
  },
  data: function data() {
    return {
      tl: gsap.timeline({
        defaults: {
          ease: "linear.easeNone"
        },
        paused: true,
        repeat: -1
      })
    };
  },
  mounted: function mounted() {
    this.animateEllipsis();
  },
  methods: {
    animateEllipsis: function animateEllipsis() {
      var _context;

      var ellipsis = this.$refs.ellipsis;

      var dots = _filterInstanceProperty(_context = _toConsumableArray(ellipsis.$el.children)).call(_context, function (el) {
        return el.tagName === "circle";
      });

      for (var i = 0; i < dots.length; i++) {
        // Duration for first dot is 20% faster as it starts from 20% opacity
        var isFirstDot = i === 0;
        var duration = isFirstDot ? ANIMATION_DURATION_DOT - ANIMATION_DURATION_DOT / OPACITY_PERCENTAGE_DIVIDER : ANIMATION_DURATION_DOT;
        gsap.set(dots[i], {
          autoAlpha: isFirstDot ? 1 / OPACITY_PERCENTAGE_DIVIDER : 0
        });
        this.tl.to(dots[i], {
          duration: duration,
          autoAlpha: 1
        }, ANIMATION_POSITION);
      }

      this.tl.play();
    }
  }
});

/* script */
const __vue_script__$V = script$V;

/* template */
var __vue_render__$V = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-text-with-ellipsis"},[_vm._t("default"),_vm._v(" "),_c('DefaIconEllipsis',{ref:"ellipsis",staticClass:"loading-text-with-ellipsis__ellipsis"})],2)};
var __vue_staticRenderFns__$V = [];

  /* style */
  const __vue_inject_styles__$V = function (inject) {
    if (!inject) return
    inject("data-v-15401ce6_0", { source: ".loading-text-with-ellipsis[data-v-15401ce6]{display:flex;align-items:flex-end}.loading-text-with-ellipsis__ellipsis[data-v-15401ce6]{width:1.5rem}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$V = "data-v-15401ce6";
  /* module identifier */
  const __vue_module_identifier__$V = undefined;
  /* functional template */
  const __vue_is_functional_template__$V = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$V = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$V, staticRenderFns: __vue_staticRenderFns__$V },
    __vue_inject_styles__$V,
    __vue_script__$V,
    __vue_scope_id__$V,
    __vue_is_functional_template__$V,
    __vue_module_identifier__$V,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$u(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$u(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$u() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaPageError = /*#__PURE__*/function (_Vue) {
  _inherits(DefaPageError, _Vue);

  var _super = _createSuper$u(DefaPageError);

  function DefaPageError() {
    _classCallCheck(this, DefaPageError);

    return _super.apply(this, arguments);
  }

  _createClass(DefaPageError, [{
    key: "serviceDetails",
    get: function get() {
      return serviceDetails();
    }
  }]);

  return DefaPageError;
}(Vue$1);

DefaPageError = __decorate([Component({
  name: "DefaPageError"
})], DefaPageError);
var script$U = DefaPageError;

/* script */
const __vue_script__$U = script$U;

/* template */
var __vue_render__$U = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-error"},[_c('h2',[_c('i18n',{attrs:{"path":"defaPageError.text"},scopedSlots:_vm._u([{key:"defaMailLink",fn:function(){return [_c('a',{attrs:{"href":_vm.serviceDetails.emailLink}},[_vm._v(_vm._s(_vm.serviceDetails.email))])]},proxy:true},{key:"defaPhoneLink",fn:function(){return [_c('a',{attrs:{"href":_vm.serviceDetails.phoneLink}},[_vm._v(_vm._s(_vm.serviceDetails.phone))])]},proxy:true}])})],1),_vm._v(" "),_c('svg',{staticClass:"page-error__icon",attrs:{"viewBox":"0 0 122.88 98.31","x":"0px","y":"0px"}},[_c('g',[_c('path',{staticClass:"st0",attrs:{"d":"M8.32,0h106.24c4.58,0,8.32,3.74,8.32,8.32v81.68c0,4.57-3.74,8.32-8.32,8.32H8.32C3.74,98.31,0,94.57,0,89.99 V8.32C0,3.74,3.74,0,8.32,0L8.32,0z M63.1,40.11L86.2,76.38c0.7,1.09,1.3,3.33,0,3.33H36.68c-1.3,0-0.7-2.24,0-3.33l23.09-36.27 C60.47,39.02,62.41,39.02,63.1,40.11L63.1,40.11z M59.42,70.09h4.02v3.56h-4.02V70.09L59.42,70.09z M63.44,67.63h-4.02 c-0.4-4.88-1.24-7.98-1.24-12.86c0-1.8,1.46-3.26,3.26-3.26c1.8,0,3.26,1.46,3.26,3.26C64.7,59.64,63.85,62.75,63.44,67.63 L63.44,67.63L63.44,67.63z M117.97,23.29H5.29v67.51c0,0.64,0.25,1.2,0.67,1.63c0.42,0.43,0.99,0.67,1.63,0.67h108.04 c0.64,0,1.2-0.25,1.63-0.67c0.43-0.43,0.67-0.99,0.67-1.63V23.29H117.97L117.97,23.29z M106.64,9.35c2.27,0,4.11,1.84,4.11,4.11 c0,2.27-1.84,4.11-4.11,4.11c-2.27,0-4.11-1.84-4.11-4.11C102.54,11.19,104.38,9.35,106.64,9.35L106.64,9.35z M78.8,9.35 c2.27,0,4.11,1.84,4.11,4.11c0,2.27-1.84,4.11-4.11,4.11c-2.27,0-4.11-1.84-4.11-4.11C74.69,11.19,76.53,9.35,78.8,9.35L78.8,9.35z M92.72,9.35c2.27,0,4.11,1.84,4.11,4.11c0,2.27-1.84,4.11-4.11,4.11c-2.27,0-4.11-1.84-4.11-4.11 C88.61,11.19,90.45,9.35,92.72,9.35L92.72,9.35z"}})])])])};
var __vue_staticRenderFns__$U = [];

  /* style */
  const __vue_inject_styles__$U = function (inject) {
    if (!inject) return
    inject("data-v-08addeb6_0", { source: ".page-error{display:flex;flex-direction:column;gap:2rem;justify-content:center;align-items:center}.page-error__icon{fill:var(--defa-oreon-color-primary);width:10rem}.page-error__icon .st0{fill-rule:evenodd;clip-rule:evenodd}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$U = undefined;
  /* module identifier */
  const __vue_module_identifier__$U = undefined;
  /* functional template */
  const __vue_is_functional_template__$U = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$U = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$U, staticRenderFns: __vue_staticRenderFns__$U },
    __vue_inject_styles__$U,
    __vue_script__$U,
    __vue_scope_id__$U,
    __vue_is_functional_template__$U,
    __vue_module_identifier__$U,
    false,
    createInjector,
    undefined,
    undefined
  );

function ownKeys$2(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context8; _forEachInstanceProperty(_context8 = ownKeys$2(Object(source), true)).call(_context8, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context9; _forEachInstanceProperty(_context9 = ownKeys$2(Object(source))).call(_context9, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$t(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$t(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$t() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var defaults = {
  lineLength: 40,
  delayUpdate: 0
};

var DefaProgressBar = /*#__PURE__*/function (_Vue) {
  _inherits(DefaProgressBar, _Vue);

  var _super = _createSuper$t(DefaProgressBar);

  function DefaProgressBar() {
    var _this;

    _classCallCheck(this, DefaProgressBar);

    _this = _super.apply(this, arguments);
    _this.circleRadius = 2.5;
    _this.svgViewBoxLength = 190;
    _this.delayInitial = 0.5;
    _this.tlInactive = gsap.timeline({
      delay: _this.delayInitial,
      paused: true
    });
    _this.tlActive = gsap.timeline({
      delay: _this.delayInitial,
      paused: true
    });
    return _this;
  }

  _createClass(DefaProgressBar, [{
    key: "created",
    value: function created() {
      if (this.svgFreeSpace <= 0) {
        console.warn("[DefaProgressBar]: There's not enough space to draw the entire progress bar.\n" + "Consider adjusting 'lineLength' based on the amount of items in the progress bar");
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _context,
          _this2 = this;

      _forEachInstanceProperty(_context = this.progressItems).call(_context, function (progressItem, i) {
        var _this2$progressItemEl = _slicedToArray(_this2.progressItemEls[i].children, 3),
            circleG = _this2$progressItemEl[0],
            textG = _this2$progressItemEl[1],
            lineG = _this2$progressItemEl[2];

        var _circleG$children = _slicedToArray(circleG.children, 2),
            inactiveCircle = _circleG$children[0],
            activeCircle = _circleG$children[1];

        var _textG$children = _slicedToArray(textG.children, 2),
            inactiveText = _textG$children[0],
            activeText = _textG$children[1];

        var inactiveLine = null;
        var activeLine = null;

        if (i !== 0) {
          var _lineG$children = _slicedToArray(lineG.children, 2);

          inactiveLine = _lineG$children[0];
          activeLine = _lineG$children[1];
        }

        _this2.tlInactive.add(_this2.constructTimeline("inactive", _objectSpread$2(_objectSpread$2({}, inactiveLine ? {
          line: inactiveLine
        } : null), {}, {
          circle: inactiveCircle,
          text: inactiveText
        })));

        _this2.tlActive.addLabel(_this2.labelSubTlActive(i));

        _this2.tlActive.add(_this2.constructTimeline("active", _objectSpread$2(_objectSpread$2({}, activeLine ? {
          line: activeLine
        } : null), {}, {
          circle: activeCircle,
          text: activeText
        })));
      }); // Don't even play timeline if it's not supposed to start as a pause at '0' won't be respected


      if (this.progressItemsActive.length) {
        this.addPauseAndRemoveOnComplete(this.labelSubTlActive(this.progressItemsActive.length)).play();
      }

      this.tlInactive.play();
    }
  }, {
    key: "onActiveProgressLabelsChange",
    value: function onActiveProgressLabelsChange(progressItemsActiveNew, progressItemsOld) {
      var _this3 = this;

      if (progressItemsActiveNew.length !== progressItemsOld.length) {
        this.addPauseAndRemoveOnComplete(this.labelSubTlActive(progressItemsActiveNew.length)).timeScale(0.5); // Can't use 'delay' on 'tlActive' as that only sets a delay at the start of the timeline

        _setTimeout(function () {
          if (progressItemsActiveNew.length < progressItemsOld.length) {
            var _context2;

            _reverseInstanceProperty(_context2 = _this3.tlActive).call(_context2);

            return;
          }

          _this3.tlActive.resume();
        }, this.delayUpdate * 1000);
      }
    }
  }, {
    key: "addPauseAndRemoveOnComplete",
    value: function addPauseAndRemoveOnComplete(label) {
      var _this4 = this;

      return this.tlActive.addPause(label, function () {
        _this4.tlActive.removePause(label);
      });
    }
  }, {
    key: "circleCX",
    value: function circleCX(index) {
      if (index === 0) {
        return this.circleRadius + this.svgInitialCircleOffset;
      }

      return this.circleCX(index - 1) + this.svgCircleWidth + this.lineLength;
    }
  }, {
    key: "lineStart",
    value: function lineStart(index) {
      return this.circleCX(index - 1) + this.circleRadius;
    }
  }, {
    key: "lineEnd",
    value: function lineEnd(index) {
      return this.lineStart(index) + this.lineLength;
    }
  }, {
    key: "constructTimeline",
    value: function constructTimeline(timelineType, elements) {
      var tl = gsap.timeline({
        defaults: {
          duration: 0.4,
          ease: "none"
        }
      });

      if (elements.line) {
        tl.to(elements.line, {
          strokeDashoffset: 0
        });
      }

      return tl.to(elements.circle, {
        attr: {
          r: this.circleRadius
        },
        ease: timelineType === "active" ? "back.out" : "power1.out"
      }).to(elements.text, {
        autoAlpha: 1
      }, "<");
    }
  }, {
    key: "getTitle",
    get: function get() {
      return this.title || this.$t("defaProgressBar.defaults.title");
    }
  }, {
    key: "labelSubTlActive",
    get: function get() {
      return function (i) {
        return "active-pre-".concat(i);
      };
    }
  }, {
    key: "progressItemsActive",
    get: function get() {
      var _context3;

      return _filterInstanceProperty(_context3 = this.progressItems).call(_context3, function (progressItem) {
        return progressItem.active;
      });
    }
  }, {
    key: "svgViewBox",
    get: function get() {
      var _context4;

      return _concatInstanceProperty(_context4 = "0 0 ".concat(this.svgViewBoxLength, " ")).call(_context4, this.svgViewBoxLength / 10);
    }
  }, {
    key: "svgFreeSpace",
    get: function get() {
      return this.svgViewBoxLength - this.svgTotalLength;
    }
  }, {
    key: "svgInitialCircleOffset",
    get: function get() {
      return this.svgFreeSpace / 2;
    }
  }, {
    key: "svgCircleWidth",
    get: function get() {
      return this.circleRadius * 2;
    }
  }, {
    key: "svgTotalLength",
    get: function get() {
      var _context5,
          _context6,
          _context7,
          _this5 = this;

      return _reduceInstanceProperty(_context5 = _filterInstanceProperty(_context6 = _fillInstanceProperty(_context7 = new Array(this.progressItems.length)).call(_context7, null)).call(_context6, function (_, i) {
        return i !== 0;
      })).call(_context5, function (totalLength) {
        return totalLength + _this5.lineLength + _this5.svgCircleWidth;
      }, this.svgCircleWidth);
    }
  }]);

  return DefaProgressBar;
}(Vue$1);

__decorate([Prop({
  required: true,
  type: Array
}), __metadata("design:type", Array)], DefaProgressBar.prototype, "progressItems", void 0);

__decorate([Prop({
  default: "",
  type: String
}), __metadata("design:type", String)], DefaProgressBar.prototype, "title", void 0);

__decorate([Prop({
  default: defaults.lineLength,
  type: Number
}), __metadata("design:type", Number)], DefaProgressBar.prototype, "lineLength", void 0);

__decorate([Prop({
  default: defaults.delayUpdate,
  type: Number
}), __metadata("design:type", Number)], DefaProgressBar.prototype, "delayUpdate", void 0);

__decorate([Ref(), __metadata("design:type", Array)], DefaProgressBar.prototype, "progressItemEls", void 0);

__decorate([Watch("progressItemsActive"), __metadata("design:type", Function), __metadata("design:paramtypes", [Array, Array]), __metadata("design:returntype", void 0)], DefaProgressBar.prototype, "onActiveProgressLabelsChange", null);

DefaProgressBar = __decorate([Component({
  name: "DefaProgressBar"
})], DefaProgressBar);
var script$T = DefaProgressBar;

/* script */
const __vue_script__$T = script$T;

/* template */
var __vue_render__$T = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"progress-bar"},[_c('svg',{staticClass:"progress-circles",attrs:{"viewBox":_vm.svgViewBox}},[_c('title',[_vm._v(_vm._s(_vm.$t("defaProgressBar.title")))]),_vm._v(" "),_vm._l((_vm.progressItems),function(progressItem,i){return _c('g',{key:progressItem.id || i,ref:"progressItemEls",refInFor:true},[_c('g',{attrs:{"transform":"translate(0, 5)"}},[_c('circle',{attrs:{"cx":_vm.circleCX(i),"fill":"var(--defa-oreon-color-gray-shade-1)","r":"0"}}),_vm._v(" "),_c('circle',{attrs:{"cx":_vm.circleCX(i),"fill":"var(--defa-oreon-color-primary)","r":"0"}})]),_vm._v(" "),_c('g',{attrs:{"font-size":"5","text-anchor":"middle","transform":"translate(0, 16)"}},[_c('text',{attrs:{"fill":"var(--defa-oreon-color-gray-shade-1)","x":_vm.circleCX(i),"opacity":"0","visibility":"hidden"}},[_vm._v("\n          "+_vm._s(progressItem.label)+"\n        ")]),_vm._v(" "),_c('text',{attrs:{"fill":"var(--defa-oreon-color-primary)","x":_vm.circleCX(i),"opacity":"0","visibility":"hidden"}},[_vm._v("\n          "+_vm._s(progressItem.label)+"\n        ")])]),_vm._v(" "),(i !== 0)?_c('g',{attrs:{"stroke-dasharray":_vm.lineLength,"stroke-dashoffset":_vm.lineLength,"transform":"translate(0, 5)"}},[_c('line',{attrs:{"stroke":"var(--defa-oreon-color-gray-shade-1)","x1":_vm.lineStart(i),"x2":_vm.lineEnd(i)}}),_vm._v(" "),_c('line',{attrs:{"stroke":"var(--defa-oreon-color-primary)","x1":_vm.lineStart(i),"x2":_vm.lineEnd(i)}})]):_vm._e()])})],2)])};
var __vue_staticRenderFns__$T = [];

  /* style */
  const __vue_inject_styles__$T = function (inject) {
    if (!inject) return
    inject("data-v-9128cf7a_0", { source: ".progress-bar[data-v-9128cf7a]{display:flex;justify-content:center;align-items:center}.progress-circles[data-v-9128cf7a]{width:min(700px,100%)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$T = "data-v-9128cf7a";
  /* module identifier */
  const __vue_module_identifier__$T = undefined;
  /* functional template */
  const __vue_is_functional_template__$T = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$T = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$T, staticRenderFns: __vue_staticRenderFns__$T },
    __vue_inject_styles__$T,
    __vue_script__$T,
    __vue_scope_id__$T,
    __vue_is_functional_template__$T,
    __vue_module_identifier__$T,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$S = Vue.extend({
  name: "DefaLoaderCircle",
  props: {
    colorPrimary: {
      type: String,
      default: "var(--defa-oreon-color-primary)"
    }
  },
  computed: {
    cssProps: function cssProps() {
      return {
        "--color-primary": this.colorPrimary
      };
    },
    title: function title() {
      // This component is used in the DefaFullPageLoader component
      // That component is shown while retrieving i18n messages, so DefaLoaderCircle will need its translations included in the application bundle
      switch (getLocale()) {
        case "nb":
          return "Laster inn..";

        case "sv":
          return "Läser in..";

        case "da":
          return "Indlæser..";

        case "fi":
          return "Ladataan..";

        default:
          throw new Error("Locale ".concat(getLocale(), " is unknown"));
      }
    }
  }
});

/* script */
const __vue_script__$S = script$S;

/* template */
var __vue_render__$S = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"defa-loader-circle-container",style:(_vm.cssProps),attrs:{"viewBox":"0 0 100 100"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('circle',{staticClass:"defa-loader-circle",attrs:{"cx":"50","cy":"50","r":"50"}})])};
var __vue_staticRenderFns__$S = [];

  /* style */
  const __vue_inject_styles__$S = function (inject) {
    if (!inject) return
    inject("data-v-6b15d9fc_0", { source: ".defa-loader-circle-container{-webkit-animation:2s linear infinite svg-animation;animation:2s linear infinite svg-animation;max-width:3rem}@-webkit-keyframes svg-animation{0%{transform:rotateZ(0)}100%{transform:rotateZ(360deg)}}@keyframes svg-animation{0%{transform:rotateZ(0)}100%{transform:rotateZ(360deg)}}.defa-loader-circle{-webkit-animation:1.4s ease-in-out infinite both circle-animation;animation:1.4s ease-in-out infinite both circle-animation;display:block;fill:transparent;stroke:var(--color-primary);stroke-linecap:round;stroke-dasharray:283;stroke-dashoffset:280;stroke-width:10px;transform-origin:50% 50%}@-webkit-keyframes circle-animation{0%,25%{stroke-dashoffset:280;transform:rotate(0)}50%,75%{stroke-dashoffset:75;transform:rotate(45deg)}100%{stroke-dashoffset:280;transform:rotate(360deg)}}@keyframes circle-animation{0%,25%{stroke-dashoffset:280;transform:rotate(0)}50%,75%{stroke-dashoffset:75;transform:rotate(45deg)}100%{stroke-dashoffset:280;transform:rotate(360deg)}}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$S = undefined;
  /* module identifier */
  const __vue_module_identifier__$S = undefined;
  /* functional template */
  const __vue_is_functional_template__$S = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$S = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$S, staticRenderFns: __vue_staticRenderFns__$S },
    __vue_inject_styles__$S,
    __vue_script__$S,
    __vue_scope_id__$S,
    __vue_is_functional_template__$S,
    __vue_module_identifier__$S,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$s(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$s(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$s() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaConfirmationResend = /*#__PURE__*/function (_Vue) {
  _inherits(DefaConfirmationResend, _Vue);

  var _super = _createSuper$s(DefaConfirmationResend);

  function DefaConfirmationResend() {
    var _this;

    _classCallCheck(this, DefaConfirmationResend);

    _this = _super.apply(this, arguments);
    _this.confirmation = {
      loading: false,
      resentComplete: false
    };
    return _this;
  }

  _createClass(DefaConfirmationResend, [{
    key: "resendConfirmation",
    value: function () {
      var _resendConfirmation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                this.confirmation.loading = true;
                _context.next = 4;
                return resendConfirmationEmail(this.axiosInstance, {
                  email: this.email,
                  confirmationPath: this.confirmationPath
                });

              case 4:
                this.confirmation.resentComplete = true;

              case 5:
                _context.prev = 5;
                this.confirmation.loading = false;
                return _context.finish(5);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0,, 5, 8]]);
      }));

      function resendConfirmation() {
        return _resendConfirmation.apply(this, arguments);
      }

      return resendConfirmation;
    }()
  }]);

  return DefaConfirmationResend;
}(Vue$1);

__decorate([Prop({
  required: true
}), __metadata("design:type", String)], DefaConfirmationResend.prototype, "email", void 0);

__decorate([Prop({
  required: true
}), __metadata("design:type", String)], DefaConfirmationResend.prototype, "confirmationPath", void 0);

__decorate([Prop({
  required: true
}), __metadata("design:type", Function)], DefaConfirmationResend.prototype, "axiosInstance", void 0);

DefaConfirmationResend = __decorate([Component({
  components: {
    DefaTransitionFadeOutIn: __vue_component__$1f,
    DefaLoaderCircle: __vue_component__$S
  },
  name: "DefaConfirmationResend"
})], DefaConfirmationResend);
var script$R = DefaConfirmationResend;

/* script */
const __vue_script__$R = script$R;

/* template */
var __vue_render__$R = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaTransitionFadeOutIn',[(_vm.confirmation.loading)?_c('DefaLoaderCircle',{staticClass:"defa-confirmation-resend-loader-circle"}):(_vm.confirmation.resentComplete)?_c('p',[_vm._v("\n    "+_vm._s(_vm.$t("defaConfirmationResend.activationSent"))+"\n  ")]):_c('i18n',{staticClass:"defa-confirmation-resend-error",attrs:{"tag":"p","path":"defaConfirmationResend.activationError.content"},scopedSlots:_vm._u([{key:"resendConfirmationAction",fn:function(){return [_c('span',{staticClass:"defa-confirmation-resend-action",on:{"click":_vm.resendConfirmation}},[_vm._v(_vm._s(_vm.$t("defaConfirmationResend.activationError.confirmationAction")))])]},proxy:true}])})],1)};
var __vue_staticRenderFns__$R = [];

  /* style */
  const __vue_inject_styles__$R = function (inject) {
    if (!inject) return
    inject("data-v-b4c5715c_0", { source: ".defa-confirmation-resend-loader-circle[data-v-b4c5715c]{display:block;margin:0 auto}.defa-confirmation-resend-action[data-v-b4c5715c]{cursor:pointer;color:var(--defa-oreon-color-primary)}.defa-confirmation-resend-error[data-v-b4c5715c]{color:var(--defa-oreon-color-error);font-weight:700}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$R = "data-v-b4c5715c";
  /* module identifier */
  const __vue_module_identifier__$R = undefined;
  /* functional template */
  const __vue_is_functional_template__$R = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$R = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$R, staticRenderFns: __vue_staticRenderFns__$R },
    __vue_inject_styles__$R,
    __vue_script__$R,
    __vue_scope_id__$R,
    __vue_is_functional_template__$R,
    __vue_module_identifier__$R,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$r(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$r(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$r() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * This component can be used both for confirming a user after registration,
 * or confirming the recovery of their password
 */

var DefaConfirmation = /*#__PURE__*/function (_Vue) {
  _inherits(DefaConfirmation, _Vue);

  var _super = _createSuper$r(DefaConfirmation);

  function DefaConfirmation() {
    var _this;

    _classCallCheck(this, DefaConfirmation);

    _this = _super.apply(this, arguments);
    _this.error = null;
    _this.loading = false;
    return _this;
  }

  _createClass(DefaConfirmation, [{
    key: "created",
    value: function () {
      var _created = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                this.loading = true;
                _context.next = 4;
                return confirmRegistrationOrPasswordRecovery(this.axiosInstance, this.confirmationUrl, {
                  approvalUrl: this.approvalUrl,
                  denialUrl: this.denialUrl
                });

              case 4:
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                this.error = _context.t0;

              case 9:
                _context.prev = 9;
                this.loading = false;
                return _context.finish(9);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6, 9, 12]]);
      }));

      function created() {
        return _created.apply(this, arguments);
      }

      return created;
    }()
  }, {
    key: "serviceDetails",
    get: function get() {
      return serviceDetails();
    }
  }, {
    key: "isWrongLinkError",
    get: function get() {
      var _this$error, _this$error$response;

      return ((_this$error = this.error) === null || _this$error === void 0 ? void 0 : (_this$error$response = _this$error.response) === null || _this$error$response === void 0 ? void 0 : _this$error$response.status) === 404;
    }
  }, {
    key: "isExpiredLinkError",
    get: function get() {
      var _this$error2, _this$error2$response;

      return ((_this$error2 = this.error) === null || _this$error2 === void 0 ? void 0 : (_this$error2$response = _this$error2.response) === null || _this$error2$response === void 0 ? void 0 : _this$error2$response.status) === 403;
    }
  }]);

  return DefaConfirmation;
}(Vue$1);

__decorate([Prop({
  required: true,
  type: Function
}), __metadata("design:type", Function)], DefaConfirmation.prototype, "axiosInstance", void 0);

__decorate([Prop({
  required: true,
  type: Object
}), __metadata("design:type", Object)], DefaConfirmation.prototype, "loginRoute", void 0);

__decorate([Prop({
  required: true,
  type: String
}), __metadata("design:type", String)], DefaConfirmation.prototype, "confirmationUrl", void 0);

__decorate([Prop({
  default: "",
  type: String
}), __metadata("design:type", String)], DefaConfirmation.prototype, "approvalUrl", void 0);

__decorate([Prop({
  default: "",
  type: String
}), __metadata("design:type", String)], DefaConfirmation.prototype, "denialUrl", void 0);

DefaConfirmation = __decorate([Component({
  components: {
    DefaLoadingTextWithEllipsis: __vue_component__$V,
    DefaTransitionFadeOutIn: __vue_component__$1f
  },
  name: "DefaConfirmation"
})], DefaConfirmation);
var script$Q = DefaConfirmation;

/* script */
const __vue_script__$Q = script$Q;

/* template */
var __vue_render__$Q = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DefaTransitionFadeOutIn',[(_vm.loading)?_c('DefaLoadingTextWithEllipsis',[_c('span',{staticClass:"confirmation-loading-text"},[_vm._v("\n        "+_vm._s(_vm.$t("defaConfirmation.loading"))+"\n      ")])]):(_vm.error)?_c('div',[(_vm.isWrongLinkError)?_c('span',{staticClass:"confirmation-error"},[_vm._v("\n        "+_vm._s(_vm.$t("defaConfirmation.verificationError.wrongLink"))+"\n      ")]):(_vm.isExpiredLinkError)?_c('span',{staticClass:"confirmation-error"},[_vm._v("\n        "+_vm._s(_vm.$t("defaConfirmation.verificationError.expired"))+"\n      ")]):_c('i18n',{staticClass:"confirmation-error",attrs:{"path":"defaConfirmation.verificationError.other"},scopedSlots:_vm._u([{key:"defaMailLink",fn:function(){return [_c('a',{attrs:{"href":_vm.serviceDetails.emailLink}},[_vm._v("\n            "+_vm._s(_vm.serviceDetails.email)+"\n          ")])]},proxy:true},{key:"defaPhoneLink",fn:function(){return [_c('a',{attrs:{"href":_vm.serviceDetails.phoneLink}},[_vm._v("\n            "+_vm._s(_vm.serviceDetails.phone)+"\n          ")])]},proxy:true}])}),_vm._v(" "),_c('RouterLink',{staticClass:"back-to-login",attrs:{"replace":"","to":_vm.loginRoute}},[_vm._v("\n        "+_vm._s(_vm.$t("defaConfirmation.verificationError.backToLogin"))+"\n      ")])],1):_vm._t("default",function(){return [_c('i18n',{attrs:{"path":"defaConfirmation.verificationSuccess.message","tag":"p"},scopedSlots:_vm._u([{key:"loginLink",fn:function(){return [_c('RouterLink',{attrs:{"replace":"","to":_vm.loginRoute}},[_vm._v("\n            "+_vm._s(_vm.$t("defaConfirmation.verificationSuccess.loginLinkText"))+"\n          ")])]},proxy:true}])})]})],2)],1)};
var __vue_staticRenderFns__$Q = [];

  /* style */
  const __vue_inject_styles__$Q = function (inject) {
    if (!inject) return
    inject("data-v-766e81ea_0", { source: ".confirmation-error[data-v-766e81ea]{color:var(--defa-oreon-color-error)}.confirmation-loading-text[data-v-766e81ea]{font-size:1.5rem;color:var(--defa-oreon-color-primary)}.back-to-login[data-v-766e81ea]{display:block;margin-top:1rem;text-align:center}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$Q = "data-v-766e81ea";
  /* module identifier */
  const __vue_module_identifier__$Q = undefined;
  /* functional template */
  const __vue_is_functional_template__$Q = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$Q = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$Q, staticRenderFns: __vue_staticRenderFns__$Q },
    __vue_inject_styles__$Q,
    __vue_script__$Q,
    __vue_scope_id__$Q,
    __vue_is_functional_template__$Q,
    __vue_module_identifier__$Q,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$q(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$q(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$q() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaBaseButton = /*#__PURE__*/function (_Vue) {
  _inherits(DefaBaseButton, _Vue);

  var _super = _createSuper$q(DefaBaseButton);

  function DefaBaseButton() {
    var _this;

    _classCallCheck(this, DefaBaseButton);

    _this = _super.apply(this, arguments);
    _this.offsetWidth = 0;
    return _this;
  }

  _createClass(DefaBaseButton, [{
    key: "mounted",
    value: function mounted() {
      this.offsetWidth = this.$el.getBoundingClientRect().width;
    }
  }, {
    key: "onLoadingChange",
    value: function () {
      var _onLoadingChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.loading) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return this.$nextTick();

              case 3:
                // waiting for rendering
                this.offsetWidth = this.$el.getBoundingClientRect().width;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onLoadingChange() {
        return _onLoadingChange.apply(this, arguments);
      }

      return onLoadingChange;
    }()
  }, {
    key: "colorPrimaryLoaderCircle",
    get: function get() {
      return this.secondary ? "var(--defa-oreon-color-primary)" : "white";
    }
  }, {
    key: "cssProps",
    get: function get() {
      return {
        "--offset-width": "".concat(this.offsetWidth, "px")
      };
    }
  }]);

  return DefaBaseButton;
}(Vue$1);

__decorate([Prop({
  default: "submit",
  type: String
}), __metadata("design:type", String)], DefaBaseButton.prototype, "type", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseButton.prototype, "disabled", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseButton.prototype, "secondary", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseButton.prototype, "loading", void 0);

__decorate([Watch("loading"), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", _Promise)], DefaBaseButton.prototype, "onLoadingChange", null);

DefaBaseButton = __decorate([Component({
  components: {
    DefaLoaderCircle: __vue_component__$S
  },
  name: "DefaBaseButton"
})], DefaBaseButton);
var script$P = DefaBaseButton;

/* script */
const __vue_script__$P = script$P;

/* template */
var __vue_render__$P = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"base-button",class:{
    'base-button--secondary': _vm.secondary,
    'base-button--loading': _vm.loading,
  },style:(_vm.cssProps),attrs:{"disabled":_vm.disabled,"type":_vm.type},on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.loading)?_c('DefaLoaderCircle',{staticClass:"base-button__loader",attrs:{"color-primary":_vm.colorPrimaryLoaderCircle}}):_vm._t("default")],2)};
var __vue_staticRenderFns__$P = [];

  /* style */
  const __vue_inject_styles__$P = function (inject) {
    if (!inject) return
    inject("data-v-268fb06c_0", { source: ".base-button[data-v-268fb06c]{font-weight:700;padding:.75rem;color:#fff;background-color:var(--defa-oreon-color-primary);border:3px solid transparent;cursor:pointer;outline:3px solid transparent;outline-offset:-3px;transition:outline-offset .4s ease,outline-color .4s ease}.base-button--secondary[data-v-268fb06c]{color:var(--defa-oreon-color-primary);background-color:transparent;border-color:var(--defa-oreon-color-primary)}.base-button--loading[data-v-268fb06c]{width:var(--offset-width)}.base-button[data-v-268fb06c]:active:enabled,.base-button[data-v-268fb06c]:hover:enabled{outline-offset:calc(-.5rem - 3px)}.base-button[data-v-268fb06c]:active:enabled,.base-button[data-v-268fb06c]:hover:enabled{outline-color:#fff}.base-button:active:enabled.base-button--secondary[data-v-268fb06c],.base-button:hover:enabled.base-button--secondary[data-v-268fb06c]{outline-color:var(--defa-oreon-color-primary)}.base-button[data-v-268fb06c]:focus:enabled{border-color:#86a8df}.base-button[data-v-268fb06c]:disabled{background-color:var(--defa-oreon-color-gray-shade-3);cursor:not-allowed}.base-button--secondary[data-v-268fb06c]:disabled{background-color:#fff;color:var(--defa-oreon-color-gray-shade-3);outline-color:var(--defa-oreon-color-gray-shade-3)}.base-button__loader[data-v-268fb06c]{width:1rem}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$P = "data-v-268fb06c";
  /* module identifier */
  const __vue_module_identifier__$P = undefined;
  /* functional template */
  const __vue_is_functional_template__$P = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$P = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$P, staticRenderFns: __vue_staticRenderFns__$P },
    __vue_inject_styles__$P,
    __vue_script__$P,
    __vue_scope_id__$P,
    __vue_is_functional_template__$P,
    __vue_module_identifier__$P,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$p(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$p(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$p() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaModalAlert = /*#__PURE__*/function (_Vue) {
  _inherits(DefaModalAlert, _Vue);

  var _super = _createSuper$p(DefaModalAlert);

  function DefaModalAlert() {
    _classCallCheck(this, DefaModalAlert);

    return _super.apply(this, arguments);
  }

  return DefaModalAlert;
}(Vue$1);

__decorate([Prop({
  required: true
}), __metadata("design:type", Boolean)], DefaModalAlert.prototype, "show", void 0);

DefaModalAlert = __decorate([Component({
  components: {
    DefaCircleWrapper: __vue_component__$19,
    DefaModal: __vue_component__$16,
    DefaBaseButton: __vue_component__$P
  },
  name: "DefaModalAlert"
})], DefaModalAlert);
var script$O = DefaModalAlert;

/* script */
const __vue_script__$O = script$O;

/* template */
var __vue_render__$O = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaModal',{attrs:{"show":_vm.show},on:{"close":function($event){return _vm.$emit('close')}}},[_c('DefaCircleWrapper',{staticClass:"modal-alert__icon-exclamation"},[_vm._v("\n    !\n  ")]),_vm._v(" "),_vm._t("content"),_vm._v(" "),_vm._t("actions",function(){return [_c('DefaBaseButton',{on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("\n      "+_vm._s(_vm.$t("defaModalAlert.okButton"))+"\n    ")])]})],2)};
var __vue_staticRenderFns__$O = [];

  /* style */
  const __vue_inject_styles__$O = function (inject) {
    if (!inject) return
    inject("data-v-18aa1235_0", { source: ".modal-alert__icon-exclamation[data-v-18aa1235]{margin:0 auto;color:#fff;font-size:1.5rem;background-color:var(--defa-oreon-color-error);border-color:var(--defa-oreon-color-error);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$O = "data-v-18aa1235";
  /* module identifier */
  const __vue_module_identifier__$O = undefined;
  /* functional template */
  const __vue_is_functional_template__$O = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$O = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$O, staticRenderFns: __vue_staticRenderFns__$O },
    __vue_inject_styles__$O,
    __vue_script__$O,
    __vue_scope_id__$O,
    __vue_is_functional_template__$O,
    __vue_module_identifier__$O,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$o(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$o(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$o() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaModalConfirmCancel = /*#__PURE__*/function (_Vue) {
  _inherits(DefaModalConfirmCancel, _Vue);

  var _super = _createSuper$o(DefaModalConfirmCancel);

  function DefaModalConfirmCancel() {
    _classCallCheck(this, DefaModalConfirmCancel);

    return _super.apply(this, arguments);
  }

  _createClass(DefaModalConfirmCancel, [{
    key: "getContentLabel",
    get: function get() {
      return this.contentLabel || this.$t("defaModalConfirmCancel.defaults.content");
    }
  }, {
    key: "getButtonLabelPrimary",
    get: function get() {
      return this.buttonLabelPrimary || this.$t("defaModalConfirmCancel.defaults.buttonPrimary.label");
    }
  }, {
    key: "getButtonLabelSecondary",
    get: function get() {
      return this.buttonLabelSecondary || this.$t("defaModalConfirmCancel.defaults.buttonSecondary.label");
    }
  }]);

  return DefaModalConfirmCancel;
}(Vue$1);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaModalConfirmCancel.prototype, "show", void 0);

__decorate([Prop({
  default: "",
  type: String
}), __metadata("design:type", String)], DefaModalConfirmCancel.prototype, "contentLabel", void 0);

__decorate([Prop({
  default: "",
  type: String
}), __metadata("design:type", String)], DefaModalConfirmCancel.prototype, "buttonLabelPrimary", void 0);

__decorate([Prop({
  default: "",
  type: String
}), __metadata("design:type", String)], DefaModalConfirmCancel.prototype, "buttonLabelSecondary", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaModalConfirmCancel.prototype, "loading", void 0);

DefaModalConfirmCancel = __decorate([Component({
  components: {
    DefaBaseButton: __vue_component__$P,
    DefaModal: __vue_component__$16
  },
  name: "DefaModalConfirmCancel"
})], DefaModalConfirmCancel);
var script$N = DefaModalConfirmCancel;

/* script */
const __vue_script__$N = script$N;

/* template */
var __vue_render__$N = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaModal',{attrs:{"show":_vm.show},on:{"close":function($event){return _vm.$emit('close')}}},[_c('div',[_vm._v(_vm._s(_vm.getContentLabel))]),_vm._v(" "),_c('div',{staticClass:"modal-confirm-cancel__action-buttons"},[_c('DefaBaseButton',{attrs:{"secondary":""},on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v("\n      "+_vm._s(_vm.getButtonLabelSecondary)+"\n    ")]),_vm._v(" "),_c('DefaBaseButton',{attrs:{"loading":_vm.loading},on:{"click":function($event){return _vm.$emit('confirm')}}},[_vm._v("\n      "+_vm._s(_vm.getButtonLabelPrimary)+"\n    ")])],1)])};
var __vue_staticRenderFns__$N = [];

  /* style */
  const __vue_inject_styles__$N = function (inject) {
    if (!inject) return
    inject("data-v-f200b76e_0", { source: ".modal-confirm-cancel__action-buttons[data-v-f200b76e]{display:flex;justify-content:flex-end;margin-top:2rem;gap:1rem}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$N = "data-v-f200b76e";
  /* module identifier */
  const __vue_module_identifier__$N = undefined;
  /* functional template */
  const __vue_is_functional_template__$N = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$N = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$N, staticRenderFns: __vue_staticRenderFns__$N },
    __vue_inject_styles__$N,
    __vue_script__$N,
    __vue_scope_id__$N,
    __vue_is_functional_template__$N,
    __vue_module_identifier__$N,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$n(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$n(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$n() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaBackendErrorMessages = /*#__PURE__*/function (_Vue) {
  _inherits(DefaBackendErrorMessages, _Vue);

  var _super = _createSuper$n(DefaBackendErrorMessages);

  function DefaBackendErrorMessages() {
    _classCallCheck(this, DefaBackendErrorMessages);

    return _super.apply(this, arguments);
  }

  _createClass(DefaBackendErrorMessages, [{
    key: "errorMessages",
    get: function get() {
      var _this$error$response, _this$error$response$, _this$error$response$2, _this$error$response$3;

      var errorMessages = (_this$error$response = this.error.response) === null || _this$error$response === void 0 ? void 0 : (_this$error$response$ = _this$error$response.data) === null || _this$error$response$ === void 0 ? void 0 : (_this$error$response$2 = _this$error$response$.error) === null || _this$error$response$2 === void 0 ? void 0 : (_this$error$response$3 = _this$error$response$2.details) === null || _this$error$response$3 === void 0 ? void 0 : _this$error$response$3.errors;

      if (errorMessages) {
        var _context;

        return _flatInstanceProperty(_context = _Object$values(errorMessages)).call(_context);
      }

      return null;
    }
  }]);

  return DefaBackendErrorMessages;
}(Vue$1);

__decorate([Prop({
  required: true,
  type: Error
}), __metadata("design:type", Object)], DefaBackendErrorMessages.prototype, "error", void 0);

DefaBackendErrorMessages = __decorate([Component], DefaBackendErrorMessages);
var script$M = DefaBackendErrorMessages;

/* script */
const __vue_script__$M = script$M;

/* template */
var __vue_render__$M = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"defa-backend-error-messages"},_vm._l((_vm.errorMessages),function(errorMessage,i){return _c('div',{key:i},[_vm._v("\n    "+_vm._s(errorMessage)+"\n  ")])}),0)};
var __vue_staticRenderFns__$M = [];

  /* style */
  const __vue_inject_styles__$M = function (inject) {
    if (!inject) return
    inject("data-v-0f490160_0", { source: ".defa-backend-error-messages{color:var(--defa-oreon-color-error)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$M = undefined;
  /* module identifier */
  const __vue_module_identifier__$M = undefined;
  /* functional template */
  const __vue_is_functional_template__$M = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$M = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$M, staticRenderFns: __vue_staticRenderFns__$M },
    __vue_inject_styles__$M,
    __vue_script__$M,
    __vue_scope_id__$M,
    __vue_is_functional_template__$M,
    __vue_module_identifier__$M,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$L = Vue.extend({
  name: "DefaFullPageLoader",
  components: {
    DefaLoaderCircle: __vue_component__$S
  },
  props: {
    // set to `true` if this component should not have fixed positioning (in embedded applications for example)
    noFixed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classFullPageLoader: function classFullPageLoader() {
      return "full-page-loader--".concat(this.noFixed ? "no-fixed" : "fixed");
    }
  }
});

/* script */
const __vue_script__$L = script$L;

/* template */
var __vue_render__$L = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-page-loader",class:_vm.classFullPageLoader},[_c('DefaLoaderCircle',{staticClass:"full-page-loader__loading-circle"})],1)};
var __vue_staticRenderFns__$L = [];

  /* style */
  const __vue_inject_styles__$L = function (inject) {
    if (!inject) return
    inject("data-v-0fb88677_0", { source: ".full-page-loader[data-v-0fb88677]{display:grid;place-content:center}.full-page-loader--fixed[data-v-0fb88677]{position:fixed;top:0;bottom:0;left:0;right:0}.full-page-loader--no-fixed[data-v-0fb88677]{height:min(20rem,50vh)}.full-page-loader__loading-circle[data-v-0fb88677]{width:3rem}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$L = "data-v-0fb88677";
  /* module identifier */
  const __vue_module_identifier__$L = undefined;
  /* functional template */
  const __vue_is_functional_template__$L = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$L = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$L, staticRenderFns: __vue_staticRenderFns__$L },
    __vue_inject_styles__$L,
    __vue_script__$L,
    __vue_scope_id__$L,
    __vue_is_functional_template__$L,
    __vue_module_identifier__$L,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$m(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$m(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$m() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaFooter = /*#__PURE__*/function (_Vue) {
  _inherits(DefaFooter, _Vue);

  var _super = _createSuper$m(DefaFooter);

  function DefaFooter() {
    var _this;

    _classCallCheck(this, DefaFooter);

    _this = _super.apply(this, arguments);
    _this.bubbleHelpVisible = false;
    return _this;
  }

  _createClass(DefaFooter, [{
    key: "toggleBubbleHelp",
    value: function toggleBubbleHelp() {
      this.bubbleHelpVisible = !this.bubbleHelpVisible;
    }
  }, {
    key: "onCloseBubbleHelp",
    value: function onCloseBubbleHelp() {
      this.bubbleHelpVisible = false;
    }
  }, {
    key: "includeRetailerGroupLogo",
    get: function get() {
      return Boolean(this.retailerGroupName && this.retailerGroupHandle);
    }
  }, {
    key: "isNotRetailerGroupAdmin",
    get: function get() {
      return this.retailerGroupHandle !== defaRetailerGroupHandle;
    }
  }, {
    key: "releaseVersion",
    get: function get() {
      return this.$t("defaFooter.releaseVersion", {
        version: RELEASE_VERSION,
        appName: fromUrlToApplicationDisplayName()
      });
    }
  }]);

  return DefaFooter;
}(Vue$1);

__decorate([Prop({
  default: "",
  type: String
}), __metadata("design:type", Object)], DefaFooter.prototype, "retailerGroupName", void 0);

__decorate([Prop({
  default: "",
  type: String
}), __metadata("design:type", Object)], DefaFooter.prototype, "retailerGroupHandle", void 0);

__decorate([Prop({
  default: "w",
  type: String
}), __metadata("design:type", String)], DefaFooter.prototype, "retailerGroupLogoColor", void 0);

DefaFooter = __decorate([Component({
  name: "DefaFooter",
  components: {
    DefaRetailerGroupLogo: __vue_component__$X,
    DefaTransitionFadeSlide: __vue_component__$1b,
    DefaInfoBubble: __vue_component__$15
  }
})], DefaFooter);
var script$K = DefaFooter;

/* script */
const __vue_script__$K = script$K;

/* template */
var __vue_render__$K = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"defa-footer"},[_c('div',{staticClass:"defa-footer__help",on:{"click":_vm.toggleBubbleHelp}},[_c('span',[_vm._v(_vm._s(_vm.$t("defaFooter.help")))]),_vm._v(" "),_c('DefaTransitionFadeSlide',[_c('DefaInfoBubble',{directives:[{name:"show",rawName:"v-show",value:(_vm.bubbleHelpVisible),expression:"bubbleHelpVisible"}],staticClass:"defa-footer__info-bubble",on:{"close":_vm.onCloseBubbleHelp},nativeOn:{"click":function($event){$event.stopPropagation();}}})],1)],1),_vm._v(" "),(_vm.includeRetailerGroupLogo)?_c('DefaRetailerGroupLogo',{attrs:{"retailer-group-name":_vm.retailerGroupName,"retailer-group-handle":_vm.retailerGroupHandle,"color":_vm.retailerGroupLogoColor,"height":"56","width":"56"}}):_vm._e(),_vm._v(" "),(_vm.isNotRetailerGroupAdmin)?_c('DefaRetailerGroupLogo',{attrs:{"color":_vm.retailerGroupLogoColor,"height":"56","width":"56"}}):_vm._e(),_vm._v(" "),_c('small',{staticClass:"defa-footer__version"},[_vm._v("\n    "+_vm._s(_vm.releaseVersion)+"\n  ")])],1)};
var __vue_staticRenderFns__$K = [];

  /* style */
  const __vue_inject_styles__$K = function (inject) {
    if (!inject) return
    inject("data-v-9bf54dc2_0", { source: ".defa-footer[data-v-9bf54dc2]{display:flex;justify-content:center;align-items:center;-moz-column-gap:1rem;column-gap:1rem;flex-wrap:wrap;padding:1rem 0}.defa-footer__help[data-v-9bf54dc2]{cursor:pointer;color:#fff;background-color:var(--defa-oreon-color-primary);padding:.5rem;border-radius:.5rem;font-weight:700;position:relative}.defa-footer__info-bubble[data-v-9bf54dc2]{color:#000;position:absolute;bottom:170%;left:-50%}.defa-footer__version[data-v-9bf54dc2]{text-align:center;flex-basis:100%}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$K = "data-v-9bf54dc2";
  /* module identifier */
  const __vue_module_identifier__$K = undefined;
  /* functional template */
  const __vue_is_functional_template__$K = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$K = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$K, staticRenderFns: __vue_staticRenderFns__$K },
    __vue_inject_styles__$K,
    __vue_script__$K,
    __vue_scope_id__$K,
    __vue_is_functional_template__$K,
    __vue_module_identifier__$K,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$l(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$l(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$l() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaComment = /*#__PURE__*/function (_Vue) {
  _inherits(DefaComment, _Vue);

  var _super = _createSuper$l(DefaComment);

  function DefaComment() {
    var _this;

    _classCallCheck(this, DefaComment);

    _this = _super.apply(this, arguments);
    _this.permaLinkCopied = false;
    return _this;
  }

  _createClass(DefaComment, [{
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      if (this.isCommentFromOtherApplicationAndUnread) {
        var observer = new IntersectionObserver(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 1),
              _ref2$ = _ref2[0],
              isIntersecting = _ref2$.isIntersecting,
              target = _ref2$.target;

          if (isIntersecting) {
            _this2.$emit("read");

            observer.unobserve(target);
          }
        }, {
          threshold: 0.5
        });
        observer.observe(this.$el);
      }
    }
  }, {
    key: "copyPermalink",
    value: function copyPermalink() {
      var _context,
          _context2,
          _this3 = this;

      var link = _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "".concat(window.location.origin)).call(_context2, window.location.pathname, "#")).call(_context, this.id);

      navigator.clipboard.writeText(link);
      this.permaLinkCopied = true;

      _setTimeout(function () {
        return _this3.permaLinkCopied = false;
      }, 3000);
    }
  }, {
    key: "isCommentFromOtherApplicationAndUnread",
    get: function get() {
      return !this.isCommentFromCurrentApplication && !this.comment.timestampRead;
    }
  }, {
    key: "isCommentFromCurrentApplicationAndRead",
    get: function get() {
      return this.isCommentFromCurrentApplication && this.comment.timestampRead;
    }
  }, {
    key: "isCommentFromCurrentApplication",
    get: function get() {
      return this.comment.sourceApp === this.currentApp;
    }
  }, {
    key: "sourceAppLowerCase",
    get: function get() {
      return this.comment.sourceApp.toLowerCase();
    }
  }, {
    key: "hasAuthor",
    get: function get() {
      return this.comment.author;
    }
  }, {
    key: "authorEmail",
    get: function get() {
      var _this$comment$author;

      return (_this$comment$author = this.comment.author) === null || _this$comment$author === void 0 ? void 0 : _this$comment$author.email;
    }
  }, {
    key: "authorEmailLink",
    get: function get() {
      return "mailto:".concat(this.authorEmail);
    }
  }, {
    key: "emailLinkStyle",
    get: function get() {
      return {
        color: "var(--defa-oreon-color-".concat(this.sourceAppLowerCase, ")")
      };
    }
  }, {
    key: "timestampFormatted",
    get: function get() {
      return formatDatetimeShortWithSeconds(this.comment.timestamp);
    }
  }, {
    key: "classComment",
    get: function get() {
      return ["defa-comment--".concat(this.sourceAppLowerCase), this.isCommentFromCurrentApplication ? "defa-comment--source" : ""];
    }
  }]);

  return DefaComment;
}(Vue$1);

__decorate([Prop({
  required: true,
  type: Object
}), __metadata("design:type", Object)], DefaComment.prototype, "comment", void 0);

__decorate([Prop({
  required: true,
  type: String
}), __metadata("design:type", String)], DefaComment.prototype, "currentApp", void 0);

__decorate([Prop({
  required: true,
  type: String
}), __metadata("design:type", String)], DefaComment.prototype, "id", void 0);

DefaComment = __decorate([Component({
  name: "DefaComment",
  components: {
    DefaTransitionFadeOutIn: __vue_component__$1f
  }
})], DefaComment);
var script$J = DefaComment;

/* script */
const __vue_script__$J = script$J;

/* template */
var __vue_render__$J = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"defa-comment",class:_vm.classComment,attrs:{"id":_vm.id}},[_c('div',[_vm._v("\n    "+_vm._s(_vm.comment.content)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"defa-comment__details"},[(_vm.hasAuthor)?_c('div',[(_vm.comment.author.fullName)?_c('span',[_vm._v(_vm._s(_vm.comment.author.fullName)+" |\n      ")]):_vm._e(),_vm._v(" "),_c('a',{style:(_vm.emailLinkStyle),attrs:{"href":_vm.authorEmailLink}},[_vm._v("\n        "+_vm._s(_vm.authorEmail))])]):_c('span',[_vm._v("\n      "+_vm._s(_vm.$t("defaComment.anonymous"))+"\n    ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.timestampFormatted))])]),_vm._v(" "),(_vm.isCommentFromCurrentApplicationAndRead)?_c('div',{staticClass:"defa-comment__read"},[_c('span',[_vm._v(_vm._s(_vm.$t("defaComment.read")))]),_vm._v(" "),_c('span',{staticClass:"unicode-icon defa-comment__read__icon"},[_vm._v("✓")])]):_vm._e()])};
var __vue_staticRenderFns__$J = [];

  /* style */
  const __vue_inject_styles__$J = function (inject) {
    if (!inject) return
    inject("data-v-65ed750e_0", { source: ".defa-comment{position:relative;padding:1.5rem 1rem 1rem 1rem;border-width:4px;border-style:solid;border-radius:8px;width:min(90%,500px)}.defa-comment__link{position:absolute;cursor:pointer;font-size:.8rem;right:.3rem;top:.3rem}.defa-comment__link__dialog{position:absolute;right:110%;top:50%;transform:translateY(-50%);padding:.25rem;font-size:.9rem;color:#fff;background-color:var(--defa-oreon-color-black);content:var(--perma-link-copied-text);white-space:nowrap}.defa-comment--ep{border-color:var(--defa-oreon-color-ep)}.defa-comment--ipv{border-color:var(--defa-oreon-color-ipv)}.defa-comment--source{align-self:flex-end}.defa-comment__details{display:flex;justify-content:space-between;flex-wrap:wrap;margin-top:1rem;color:var(--defa-oreon-color-gray-shade-3)}.defa-comment__read{font-size:.9rem;font-weight:700;margin-top:.5rem;text-align:right}.defa-comment__read__icon{color:var(--defa-oreon-color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$J = undefined;
  /* module identifier */
  const __vue_module_identifier__$J = undefined;
  /* functional template */
  const __vue_is_functional_template__$J = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$J = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$J, staticRenderFns: __vue_staticRenderFns__$J },
    __vue_inject_styles__$J,
    __vue_script__$J,
    __vue_scope_id__$J,
    __vue_is_functional_template__$J,
    __vue_module_identifier__$J,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$k(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$k(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$k() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaBaseChatInput = /*#__PURE__*/function (_Vue) {
  _inherits(DefaBaseChatInput, _Vue);

  var _super = _createSuper$k(DefaBaseChatInput);

  function DefaBaseChatInput() {
    var _this;

    _classCallCheck(this, DefaBaseChatInput);

    _this = _super.apply(this, arguments);
    _this.model = {
      value: ""
    };
    return _this;
  }

  _createClass(DefaBaseChatInput, [{
    key: "send",
    value: function send() {
      if (this.hasValue && !this.loading) {
        this.$emit("send", this.model.value);
        this.model.value = "";
      }
    }
  }, {
    key: "onEnter",
    value: function onEnter(event) {
      if (!event.shiftKey) {
        event.preventDefault();
        this.send();
      }
    }
  }, {
    key: "onModelValueChange",
    value: function onModelValueChange() {
      // auto-resize textarea, based on https://stackoverflow.com/questions/2803880/is-there-a-way-to-get-a-textarea-to-stretch-to-fit-its-content-without-using-php#answer-48460773
      this.input.style.height = "";
      this.input.style.height = "".concat(this.input.scrollHeight + 4, "px");
    }
  }, {
    key: "hasValue",
    get: function get() {
      return Boolean(this.model.value);
    }
  }]);

  return DefaBaseChatInput;
}(Vue$1);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseChatInput.prototype, "loading", void 0);

__decorate([Ref(), __metadata("design:type", HTMLElement)], DefaBaseChatInput.prototype, "input", void 0);

__decorate([Watch("model.value"), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], DefaBaseChatInput.prototype, "onModelValueChange", null);

DefaBaseChatInput = __decorate([Component({
  components: {
    DefaTransitionFadeOutIn: __vue_component__$1f,
    DefaLoaderCircle: __vue_component__$S
  },
  inheritAttrs: false
})], DefaBaseChatInput);
var script$I = DefaBaseChatInput;

/* script */
const __vue_script__$I = script$I;

/* template */
var __vue_render__$I = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"defa-base-chat-input"},[_c('textarea',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.model.value),expression:"model.value"}],ref:"input",staticClass:"defa-base-chat-input__input",attrs:{"rows":"1"},domProps:{"value":(_vm.model.value)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onEnter.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "value", $event.target.value);}}},'textarea',_vm.$attrs,false)),_vm._v(" "),(_vm.loading)?_c('DefaLoaderCircle',{staticClass:"defa-base-chat-input__loader"}):_c('div',{staticClass:"defa-base-chat-input__icon-send",class:{ 'defa-base-chat-input__icon-send--enabled': _vm.hasValue },on:{"click":_vm.send}},[_vm._v("\n    ➤\n  ")])],1)};
var __vue_staticRenderFns__$I = [];

  /* style */
  const __vue_inject_styles__$I = function (inject) {
    if (!inject) return
    inject("data-v-776e8964_0", { source: ".defa-base-chat-input[data-v-776e8964]{display:flex;gap:.2rem;align-items:center}.defa-base-chat-input__input[data-v-776e8964]{line-height:1.15;flex-grow:1;outline:0;border:2px solid currentColor;border-radius:21px;padding:.5em .75em;max-height:calc((.5em * 2) + (4rem * 1.15 + 4px));resize:none}.defa-base-chat-input__input[data-v-776e8964]:focus{border-color:var(--defa-oreon-color-primary)}.defa-base-chat-input__loader[data-v-776e8964]{width:2rem}.defa-base-chat-input__icon-send[data-v-776e8964]{font-size:2rem;line-height:1;transition:color .3s ease;color:var(--defa-oreon-color-gray-shade-1);cursor:not-allowed;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.defa-base-chat-input__icon-send--enabled[data-v-776e8964]{cursor:pointer;color:currentColor}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$I = "data-v-776e8964";
  /* module identifier */
  const __vue_module_identifier__$I = undefined;
  /* functional template */
  const __vue_is_functional_template__$I = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$I = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$I, staticRenderFns: __vue_staticRenderFns__$I },
    __vue_inject_styles__$I,
    __vue_script__$I,
    __vue_scope_id__$I,
    __vue_is_functional_template__$I,
    __vue_module_identifier__$I,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$j(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$j(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$j() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaComments = /*#__PURE__*/function (_Vue) {
  _inherits(DefaComments, _Vue);

  var _super = _createSuper$j(DefaComments);

  function DefaComments() {
    var _this;

    _classCallCheck(this, DefaComments);

    _this = _super.apply(this, arguments);
    _this.captchaVerified = false;
    return _this;
  }

  _createClass(DefaComments, [{
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      if (this.commentAnchorToScrollTo) {
        var _this$commentEls$find, _context;

        var commentEl = (_this$commentEls$find = _findInstanceProperty(_context = this.commentEls).call(_context, function (comment) {
          var _context2;

          return comment.$el.id === _sliceInstanceProperty(_context2 = _this2.commentAnchorToScrollTo).call(_context2, 1);
        })) === null || _this$commentEls$find === void 0 ? void 0 : _this$commentEls$find.$el;

        if (commentEl) {
          return commentEl.scrollIntoView({
            behavior: "smooth"
          });
        }
      }

      if (this.commentListEl && (this.firstUnreadCommentElOtherApplication || this.allCommentsOtherApplicationAreRead)) {
        var observer = new IntersectionObserver(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 1),
              _ref2$ = _ref2[0],
              target = _ref2$.target,
              isIntersecting = _ref2$.isIntersecting;

          if (isIntersecting) {
            if (_this2.firstUnreadCommentElOtherApplication) {
              _this2.scrollCommentListElToComment(_this2.firstUnreadCommentElOtherApplication, target);
            } else if (_this2.allCommentsOtherApplicationAreRead) {
              _this2.scrollCommentListElToComment(_this2.lastCommentEl, target);
            }

            observer.unobserve(target);
          }
        }, {
          threshold: 0.5
        });
        observer.observe(this.commentListEl);
      }
    }
  }, {
    key: "onSend",
    value: function onSend(message) {
      this.$emit("send", message);
    }
  }, {
    key: "onRead",
    value: function onRead(comment) {
      this.$emit("read", {
        comment: comment
      });
    }
  }, {
    key: "onVerify",
    value: function onVerify() {
      this.captchaVerified = true;
    }
  }, {
    key: "scrollCommentListElToComment",
    value: function scrollCommentListElToComment(commentEl) {
      var commentListEl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.commentListEl;
      var targetOffsetTop = commentListEl.offsetTop;
      var firstUnreadCommentOffsetTop = commentEl.offsetTop;
      var offsetFromParent = firstUnreadCommentOffsetTop - targetOffsetTop;
      commentListEl.scrollTo({
        top: offsetFromParent,
        behavior: "smooth"
      });
    }
  }, {
    key: "onCommentsChange",
    value: function () {
      var _onCommentsChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(newCommentsLength, oldCommentsLength) {
        return _regeneratorRuntime.wrap(function _callee$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(newCommentsLength > oldCommentsLength)) {
                  _context3.next = 4;
                  break;
                }

                _context3.next = 3;
                return this.$nextTick();

              case 3:
                // wait for new comment element to be rendered
                this.scrollCommentListElToComment(this.lastCommentEl);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee, this);
      }));

      function onCommentsChange(_x, _x2) {
        return _onCommentsChange.apply(this, arguments);
      }

      return onCommentsChange;
    }()
  }, {
    key: "allCommentsOtherApplicationAreRead",
    get: function get() {
      return this.unreadCommentsOtherApplication.length === 0;
    }
  }, {
    key: "isCaptchaVisible",
    get: function get() {
      return this.recaptchaSiteKey && !this.captchaVerified;
    }
  }, {
    key: "placeholder",
    get: function get() {
      return this.disabled ? null : this.$t("defaComments.inputPlaceholder");
    }
  }, {
    key: "commentElId",
    get: function get() {
      return function (id) {
        return "comment-".concat(id);
      };
    }
  }, {
    key: "unreadCommentsOtherApplication",
    get: function get() {
      var _context4,
          _context5,
          _this3 = this;

      return _filterInstanceProperty(_context4 = _filterInstanceProperty(_context5 = this.commentsSortedByDate).call(_context5, function (comment) {
        return comment.sourceApp !== _this3.currentApp;
      })).call(_context4, function (comment) {
        return !comment.timestampRead;
      });
    }
  }, {
    key: "firstUnreadCommentElOtherApplication",
    get: function get() {
      var _this$unreadCommentsO,
          _this$commentEls$find2,
          _context6,
          _this4 = this;

      var comment = (_this$unreadCommentsO = this.unreadCommentsOtherApplication) === null || _this$unreadCommentsO === void 0 ? void 0 : _this$unreadCommentsO[0];
      return comment ? (_this$commentEls$find2 = _findInstanceProperty(_context6 = this.commentEls).call(_context6, function (commentEl) {
        return commentEl.$el.id === _this4.commentElId(comment === null || comment === void 0 ? void 0 : comment.id);
      })) === null || _this$commentEls$find2 === void 0 ? void 0 : _this$commentEls$find2.$el : null;
    }
  }, {
    key: "hasComments",
    get: function get() {
      return Boolean(this.comments.length);
    }
  }, {
    key: "commentsSortedByDate",
    get: function get() {
      var _context7;

      return _sortInstanceProperty(_context7 = _toConsumableArray(this.comments)).call(_context7, function (commentOne, commentTwo) {
        return isBefore(commentOne.timestamp, commentTwo.timestamp) ? -1 : 1;
      });
    }
  }, {
    key: "lastCommentEl",
    get: function get() {
      return this.commentEls[this.commentEls.length - 1].$el;
    }
  }]);

  return DefaComments;
}(Vue$1);

__decorate([Prop({
  required: true,
  type: Array
}), __metadata("design:type", Array)], DefaComments.prototype, "comments", void 0);

__decorate([Prop({
  default: "EP",
  type: String
}), __metadata("design:type", String)], DefaComments.prototype, "currentApp", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", String)], DefaComments.prototype, "loading", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaComments.prototype, "disabled", void 0);

__decorate([Prop({
  default: "",
  type: String
}), __metadata("design:type", String)], DefaComments.prototype, "commentAnchorToScrollTo", void 0);

__decorate([Prop({
  default: "",
  type: String
}), __metadata("design:type", String)], DefaComments.prototype, "recaptchaSiteKey", void 0);

__decorate([Prop({
  default: "",
  type: String
}), __metadata("design:type", String)], DefaComments.prototype, "chatInputTitle", void 0);

__decorate([Ref(), __metadata("design:type", Array)], DefaComments.prototype, "commentEls", void 0);

__decorate([Ref(), __metadata("design:type", HTMLElement)], DefaComments.prototype, "commentListEl", void 0);

__decorate([Watch("comments.length"), __metadata("design:type", Function), __metadata("design:paramtypes", [Number, Number]), __metadata("design:returntype", _Promise)], DefaComments.prototype, "onCommentsChange", null);

DefaComments = __decorate([Component({
  components: {
    VueRecaptcha: VueRecaptcha,
    ValidationObserver: ValidationObserver,
    DefaComment: __vue_component__$J,
    DefaBaseChatInput: __vue_component__$I,
    DefaTransitionFadeOutIn: __vue_component__$1f
  },
  name: "DefaComments"
})], DefaComments);
var script$H = DefaComments;

/* script */
const __vue_script__$H = script$H;

/* template */
var __vue_render__$H = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"defa-comments"},[(_vm.hasComments)?_c('ul',{ref:"commentListEl",staticClass:"defa-comments__list"},_vm._l((_vm.commentsSortedByDate),function(comment){return _c('DefaComment',{key:comment.id,ref:"commentEls",refInFor:true,attrs:{"id":_vm.commentElId(comment.id),"current-app":_vm.currentApp,"comment":comment},on:{"read":function($event){return _vm.onRead(comment)}}})}),1):_c('div',{staticClass:"defa-comments__no-comments"},[_vm._v("\n    "+_vm._s(_vm.$t("defaComments.noComments"))+"\n  ")]),_vm._v(" "),_c('form',{staticClass:"defa-comments__form"},[_c('DefaTransitionFadeOutIn',[(_vm.isCaptchaVisible)?_c('VueRecaptcha',{staticClass:"defa-comments__recaptcha",attrs:{"sitekey":_vm.recaptchaSiteKey,"load-recaptcha-script":""},on:{"verify":_vm.onVerify}}):_c('DefaBaseChatInput',{staticClass:"defa-comments__form__chat-input",attrs:{"title":_vm.chatInputTitle,"loading":_vm.loading,"placeholder":_vm.placeholder,"disabled":_vm.disabled},on:{"send":_vm.onSend}})],1)],1)])};
var __vue_staticRenderFns__$H = [];

  /* style */
  const __vue_inject_styles__$H = function (inject) {
    if (!inject) return
    inject("data-v-53d7fe07_0", { source: ".defa-comments{padding:1rem}.defa-comments__recaptcha{display:flex;justify-content:center}.defa-comments__list{list-style-type:none;display:flex;flex-direction:column;align-items:flex-start;gap:1rem;margin-bottom:3rem;max-height:430px;overflow-y:auto}.defa-comments__no-comments{display:flex;justify-content:center;padding:1rem}.defa-comments__form__chat-input{width:min(90ch,90%);margin:0 auto}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$H = undefined;
  /* module identifier */
  const __vue_module_identifier__$H = undefined;
  /* functional template */
  const __vue_is_functional_template__$H = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$H = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$H, staticRenderFns: __vue_staticRenderFns__$H },
    __vue_inject_styles__$H,
    __vue_script__$H,
    __vue_scope_id__$H,
    __vue_is_functional_template__$H,
    __vue_module_identifier__$H,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$G = Vue.extend({
  name: "DefaLoaderBar",
  mounted: function mounted() {
    gsap.fromTo(this.$el, {
      width: 0
    }, {
      duration: 1.5,
      width: "100%",
      repeat: -1,
      repeatDelay: 0.3,
      delay: 0.3
    });
  },
  destroyed: function destroyed() {
    gsap.to(this.$el, {
      autoAlpha: 0,
      duration: 0.3
    });
  }
});

/* script */
const __vue_script__$G = script$G;

/* template */
var __vue_render__$G = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-bar",style:(_vm.cssProps),attrs:{"aria-valuetext":_vm.$t('defaLoaderBar.updating'),"aria-busy":"true","aria-valuemax":"100","aria-valuemin":"0","role":"progressbar"}})};
var __vue_staticRenderFns__$G = [];

  /* style */
  const __vue_inject_styles__$G = function (inject) {
    if (!inject) return
    inject("data-v-5dd0d3fa_0", { source: ".loader-bar[data-v-5dd0d3fa]{position:fixed;top:0;left:0;height:.4rem;border-bottom-right-radius:2rem;border-top-right-radius:2rem;background-color:var(--defa-oreon-color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$G = "data-v-5dd0d3fa";
  /* module identifier */
  const __vue_module_identifier__$G = undefined;
  /* functional template */
  const __vue_is_functional_template__$G = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$G = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$G, staticRenderFns: __vue_staticRenderFns__$G },
    __vue_inject_styles__$G,
    __vue_script__$G,
    __vue_scope_id__$G,
    __vue_is_functional_template__$G,
    __vue_module_identifier__$G,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$i(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$i(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$i() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaBaseInputErrorMessage = /*#__PURE__*/function (_Vue) {
  _inherits(DefaBaseInputErrorMessage, _Vue);

  var _super = _createSuper$i(DefaBaseInputErrorMessage);

  function DefaBaseInputErrorMessage() {
    _classCallCheck(this, DefaBaseInputErrorMessage);

    return _super.apply(this, arguments);
  }

  _createClass(DefaBaseInputErrorMessage, [{
    key: "classPosition",
    get: function get() {
      return "base-input-error-message--".concat(this.position);
    }
  }]);

  return DefaBaseInputErrorMessage;
}(Vue$1);

__decorate([Prop({
  default: "top",
  type: String
}), __metadata("design:type", String)], DefaBaseInputErrorMessage.prototype, "position", void 0);

DefaBaseInputErrorMessage = __decorate([Component({
  name: "DefaBaseInputErrorMessage",
  components: {
    DefaTransitionFadeOutIn: __vue_component__$1f,
    DefaCircleWrapper: __vue_component__$19
  }
})], DefaBaseInputErrorMessage);
var script$F = DefaBaseInputErrorMessage;

/* script */
const __vue_script__$F = script$F;

/* template */
var __vue_render__$F = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-input-error-message",class:_vm.classPosition},[_c('div',{staticClass:"base-input-error-message__exclamation-mark"},[_vm._v("!")]),_vm._v(" "),_vm._t("default")],2)};
var __vue_staticRenderFns__$F = [];

  /* style */
  const __vue_inject_styles__$F = function (inject) {
    if (!inject) return
    inject("data-v-f4500e88_0", { source: ".base-input-error-message[data-v-f4500e88]{display:flex;gap:1rem;align-items:center;position:absolute;opacity:0;z-index:-1;left:0;border:2px solid var(--defa-oreon-color-error);color:#000;background-color:#fff;padding:.25rem .5rem;transition:opacity 350ms ease-in-out}.base-input-error-message--top[data-v-f4500e88]{bottom:calc(100% + .5rem)}.base-input-error-message--bottom[data-v-f4500e88]{top:calc(100% + .5rem)}.base-input-error-message__exclamation-mark[data-v-f4500e88]{font-size:1.5rem;font-weight:700;color:var(--defa-oreon-color-error)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$F = "data-v-f4500e88";
  /* module identifier */
  const __vue_module_identifier__$F = undefined;
  /* functional template */
  const __vue_is_functional_template__$F = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$F = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$F, staticRenderFns: __vue_staticRenderFns__$F },
    __vue_inject_styles__$F,
    __vue_script__$F,
    __vue_scope_id__$F,
    __vue_is_functional_template__$F,
    __vue_module_identifier__$F,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$h(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$h(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$h() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaBaseCheckbox = /*#__PURE__*/function (_Vue) {
  _inherits(DefaBaseCheckbox, _Vue);

  var _super = _createSuper$h(DefaBaseCheckbox);

  function DefaBaseCheckbox() {
    _classCallCheck(this, DefaBaseCheckbox);

    return _super.apply(this, arguments);
  }

  _createClass(DefaBaseCheckbox, [{
    key: "getRules",
    get: function get() {
      return getRules(this.rules, this.disabled);
    }
  }, {
    key: "hasRequiredRule",
    get: function get() {
      return hasRequiredRule(this.rules);
    }
  }, {
    key: "value",
    get: function get() {
      return this.modelValue;
    },
    set: function set(checked) {
      this.$emit("change", checked);
    }
  }]);

  return DefaBaseCheckbox;
}(Vue$1);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseCheckbox.prototype, "modelValue", void 0);

__decorate([Prop({
  default: null,
  type: String
}), __metadata("design:type", Object)], DefaBaseCheckbox.prototype, "name", void 0);

__decorate([Prop({
  default: "",
  type: String
}), __metadata("design:type", String)], DefaBaseCheckbox.prototype, "label", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseCheckbox.prototype, "disabled", void 0);

__decorate([Prop({
  default: null,
  type: [Object, String]
}), __metadata("design:type", Object)], DefaBaseCheckbox.prototype, "rules", void 0);

__decorate([Prop({
  default: null,
  type: Object
}), __metadata("design:type", Object)], DefaBaseCheckbox.prototype, "customMessages", void 0);

__decorate([Prop({
  default: "top",
  type: String
}), __metadata("design:type", String)], DefaBaseCheckbox.prototype, "errorMessagePosition", void 0);

DefaBaseCheckbox = __decorate([Component({
  components: {
    ValidationProvider: ValidationProvider,
    DefaBaseInputErrorMessage: __vue_component__$F
  },
  inheritAttrs: false,
  model: {
    prop: "modelValue",
    event: "change"
  },
  name: "DefaBaseCheckbox"
})], DefaBaseCheckbox);
var script$E = DefaBaseCheckbox;

/* script */
const __vue_script__$E = script$E;

/* template */
var __vue_render__$E = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"rules":_vm.getRules,"custom-messages":_vm.customMessages,"tag":"div"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var failed = ref.failed;
var ariaInput = ref.ariaInput;
var errors = ref.errors;
var ariaMsg = ref.ariaMsg;
return [_c('label',{staticClass:"base-checkbox__label",class:{
      'base-checkbox__label--has-error': failed,
      'base-checkbox__label--disabled': _vm.disabled,
    },attrs:{"for":_vm.name}},[_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"base-checkbox__input",class:{ 'base-checkbox__checkbox--has-error': failed },attrs:{"id":_vm.name,"disabled":_vm.disabled,"name":_vm.name,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.value)?_vm._i(_vm.value,null)>-1:(_vm.value)},on:{"change":function($event){var $$a=_vm.value,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.value=$$a.concat([$$v]));}else {$$i>-1&&(_vm.value=$$a.slice(0,$$i).concat($$a.slice($$i+1)));}}else {_vm.value=$$c;}}}},'input',Object.assign({}, ariaInput,
        _vm.$attrs),false)),_vm._v(" "),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]},null,{ hasRequiredRule: _vm.hasRequiredRule })],2),_vm._v(" "),_c('DefaBaseInputErrorMessage',_vm._b({directives:[{name:"show",rawName:"v-show",value:(failed),expression:"failed"}],attrs:{"position":_vm.errorMessagePosition}},'DefaBaseInputErrorMessage',ariaMsg,false),[_vm._v("\n    "+_vm._s(errors[0])+"\n  ")])]}}],null,true)})};
var __vue_staticRenderFns__$E = [];

  /* style */
  const __vue_inject_styles__$E = function (inject) {
    if (!inject) return
    inject("data-v-07578a75_0", { source: "@charset \"UTF-8\";.base-checkbox__input[data-v-07578a75]{position:relative;-moz-appearance:none;appearance:none;-webkit-appearance:none;border:3px solid var(--defa-oreon-color-primary);flex-basis:2em;height:2em;margin-right:8px;cursor:pointer;flex-shrink:0}.base-checkbox__input.base-checkbox__input--has-error[data-v-07578a75]{border-color:var(--defa-oreon-color-error)}.base-checkbox__input[data-v-07578a75]:checked{background-color:var(--defa-oreon-color-primary)}.base-checkbox__input[data-v-07578a75]:checked::after{content:\"✔\";color:#fff;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);font-size:1.5rem}.base-checkbox__input[data-v-07578a75]:disabled{border-color:var(--defa-oreon-color-gray-shade-3);cursor:not-allowed}.base-checkbox__input[data-v-07578a75]:disabled:checked{background-color:var(--defa-oreon-color-gray-shade-3)}.base-checkbox__label[data-v-07578a75]{cursor:pointer;display:flex;align-items:center}.base-checkbox__label.base-checkbox__label--has-error[data-v-07578a75]{color:var(--defa-oreon-color-error)}.base-checkbox__label:focus-within~.base-input-error-message[data-v-07578a75],.base-checkbox__label:focus~.base-input-error-message[data-v-07578a75],.base-checkbox__label:hover~.base-input-error-message[data-v-07578a75]{opacity:1;z-index:0}.base-checkbox__label--disabled[data-v-07578a75]{color:var(--defa-oreon-color-gray-shade-3);cursor:not-allowed}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$E = "data-v-07578a75";
  /* module identifier */
  const __vue_module_identifier__$E = undefined;
  /* functional template */
  const __vue_is_functional_template__$E = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$E = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$E, staticRenderFns: __vue_staticRenderFns__$E },
    __vue_inject_styles__$E,
    __vue_script__$E,
    __vue_scope_id__$E,
    __vue_is_functional_template__$E,
    __vue_module_identifier__$E,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$D = Vue.extend({
  name: "DefaIconImagePlaceholder"
});

/* script */
const __vue_script__$D = script$D;

/* template */
var __vue_render__$D = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"80","viewBox":"0 0 10 10","width":"80"}},[_c('title',[_vm._v(_vm._s(_vm.$t("defaIconImagePlaceholder.title")))]),_vm._v(" "),_c('defs',[_c('linearGradient',{attrs:{"id":"grayGradient","gradientTransform":"rotate(45)"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#ccc"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"50%","stop-color":"#999"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#333"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"fill":"url(#grayGradient)","height":"10","width":"10"}})])};
var __vue_staticRenderFns__$D = [];

  /* style */
  const __vue_inject_styles__$D = undefined;
  /* scoped */
  const __vue_scope_id__$D = undefined;
  /* module identifier */
  const __vue_module_identifier__$D = undefined;
  /* functional template */
  const __vue_is_functional_template__$D = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$D = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$D, staticRenderFns: __vue_staticRenderFns__$D },
    __vue_inject_styles__$D,
    __vue_script__$D,
    __vue_scope_id__$D,
    __vue_is_functional_template__$D,
    __vue_module_identifier__$D,
    false,
    undefined,
    undefined,
    undefined
  );

function _createSuper$g(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$g(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$g() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaBaseOrderLine = /*#__PURE__*/function (_Vue) {
  _inherits(DefaBaseOrderLine, _Vue);

  var _super = _createSuper$g(DefaBaseOrderLine);

  function DefaBaseOrderLine() {
    var _this;

    _classCallCheck(this, DefaBaseOrderLine);

    _this = _super.apply(this, arguments);
    _this.imageUrlFails = false;
    return _this;
  }

  _createClass(DefaBaseOrderLine, [{
    key: "errorLoadingImage",
    value: function errorLoadingImage() {
      this.imageUrlFails = true;
    }
  }, {
    key: "imgProps",
    get: function get() {
      return {
        "--image-height": "".concat(this.imageDimensions.height, "px"),
        "--image-width": "".concat(this.imageDimensions.width, "px")
      };
    }
  }, {
    key: "imageDimensions",
    get: function get() {
      return {
        height: 80,
        width: 80
      };
    }
  }, {
    key: "isElliOrder",
    get: function get() {
      return isElliOrder(this.retailerName);
    }
  }, {
    key: "skuOrArticleNumberPath",
    get: function get() {
      if (this.isElliOrder) {
        return "defaBaseOrderLine.sku";
      }

      return "defaBaseOrderLine.articleNumber";
    }
  }, {
    key: "hasSkuOrArticleNumber",
    get: function get() {
      if (this.isElliOrder) {
        return Boolean(this.orderLine.sku);
      }

      return Boolean(this.orderLine.axNumber);
    }
  }, {
    key: "skuOrArticleNumber",
    get: function get() {
      if (this.isElliOrder) {
        return this.orderLine.sku;
      }

      return this.orderLine.axNumber;
    }
  }, {
    key: "modelOrMissingModelText",
    get: function get() {
      return this.orderLine.model || this.$t("defaBaseOrderLine.missingModel");
    }
  }, {
    key: "hasSerialNumber",
    get: function get() {
      return this.orderLine.serialNumberConsigned || this.serialNumberInstalled;
    }
  }, {
    key: "differingInstallationNumbers",
    get: function get() {
      return this.orderLine.serialNumberConsigned !== this.serialNumberInstalled;
    }
  }, {
    key: "isMissingImage",
    get: function get() {
      return !this.orderLine.imageUrl || this.imageUrlFails;
    }
  }]);

  return DefaBaseOrderLine;
}(Vue$1);

__decorate([Prop({
  required: true,
  type: Object
}), __metadata("design:type", Object)], DefaBaseOrderLine.prototype, "orderLine", void 0);

__decorate([Prop({
  default: "",
  type: String
}), __metadata("design:type", String)], DefaBaseOrderLine.prototype, "serialNumberInstalled", void 0);

__decorate([Prop({
  default: "",
  type: String
}), __metadata("design:type", String)], DefaBaseOrderLine.prototype, "retailerName", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseOrderLine.prototype, "includeName", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseOrderLine.prototype, "removeBorders", void 0);

DefaBaseOrderLine = __decorate([Component({
  components: {
    DefaIconImagePlaceholder: __vue_component__$D
  },
  name: "DefaBaseOrderLine"
})], DefaBaseOrderLine);
var script$C = DefaBaseOrderLine;

/* script */
const __vue_script__$C = script$C;

/* template */
var __vue_render__$C = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.includeName)?_c('h2',[_vm._v("\n    "+_vm._s(_vm.orderLine.name)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"order-line",class:{ 'order-line--no-borders': _vm.removeBorders }},[(_vm.isMissingImage)?_c('DefaIconImagePlaceholder',{staticClass:"order-line__image"}):_c('img',{staticClass:"order-line__image",style:(_vm.imgProps),attrs:{"alt":_vm.modelOrMissingModelText,"height":_vm.imageDimensions.height,"src":_vm.orderLine.imageUrl,"width":_vm.imageDimensions.width},on:{"error":_vm.errorLoadingImage}}),_vm._v(" "),_c('div',{staticClass:"order-line__info"},[_c('div',{staticClass:"order-line__info__model"},[_vm._v("\n        "+_vm._s(_vm.modelOrMissingModelText)+"\n      ")]),_vm._v(" "),(_vm.orderLine.elNumber)?_c('i18n',{staticClass:"order-line__info__number-container",attrs:{"path":"defaBaseOrderLine.elNumber","tag":"div"},scopedSlots:_vm._u([{key:"number",fn:function(){return [_c('span',{staticClass:"order-line__info__number"},[_vm._v(_vm._s(_vm.orderLine.elNumber))])]},proxy:true}],null,false,2166415050)}):_vm._e(),_vm._v(" "),(_vm.hasSkuOrArticleNumber)?_c('i18n',{staticClass:"order-line__info__number-container",attrs:{"path":_vm.skuOrArticleNumberPath,"tag":"div"},scopedSlots:_vm._u([{key:"number",fn:function(){return [_c('span',{staticClass:"order-line__info__number"},[_vm._v(_vm._s(_vm.skuOrArticleNumber))])]},proxy:true}],null,false,1003186105)}):_vm._e(),_vm._v(" "),(_vm.hasSerialNumber)?_c('i18n',{staticClass:"order-line__info__number-container",attrs:{"path":"defaBaseOrderLine.serialNumber"},scopedSlots:_vm._u([(_vm.orderLine.serialNumberConsigned)?{key:"snrConsigned",fn:function(){return [_c('span',{staticClass:"order-line__info__number",class:{
              'order-line__info__number--overwritten': _vm.differingInstallationNumbers,
            }},[_vm._v("\n            "+_vm._s(_vm.orderLine.serialNumberConsigned)+"\n          ")])]},proxy:true}:null,{key:"snrInstalled",fn:function(){return [(_vm.differingInstallationNumbers)?_c('span',{staticClass:"order-line__info__number"},[_vm._v("\n            "+_vm._s(_vm.serialNumberInstalled)+"\n          ")]):_vm._e()]},proxy:true}],null,true)}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"order-line__price"},[_vm._t("price")],2)],1)])};
var __vue_staticRenderFns__$C = [];

  /* style */
  const __vue_inject_styles__$C = function (inject) {
    if (!inject) return
    inject("data-v-eb71bc58_0", { source: ".order-line[data-v-eb71bc58]{display:flex;padding:1rem 0;gap:1rem;justify-content:space-between;align-items:center;border-bottom:1px solid var(--defa-oreon-color-gray-shade-1)}.order-line--no-borders[data-v-eb71bc58]{border-bottom:none}.order-line__image[data-v-eb71bc58]{width:var(--image-height);height:var(--image-width)}.order-line__info[data-v-eb71bc58]{flex-grow:1;align-self:flex-start;line-height:1.6}.order-line__price[data-v-eb71bc58]{font-weight:700;color:var(--defa-oreon-color-gray-shade-5);text-align:right;font-size:1.1rem}.order-line__info__model[data-v-eb71bc58]{font-weight:700;margin-bottom:.5rem}.order-line__info__number-container[data-v-eb71bc58]{font-weight:700;font-size:.9rem}.order-line__info__number[data-v-eb71bc58]{font-weight:400}.order-line__info__number--overwritten[data-v-eb71bc58]{-webkit-text-decoration-line:line-through;text-decoration-line:line-through}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$C = "data-v-eb71bc58";
  /* module identifier */
  const __vue_module_identifier__$C = undefined;
  /* functional template */
  const __vue_is_functional_template__$C = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$C = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$C, staticRenderFns: __vue_staticRenderFns__$C },
    __vue_inject_styles__$C,
    __vue_script__$C,
    __vue_scope_id__$C,
    __vue_is_functional_template__$C,
    __vue_module_identifier__$C,
    false,
    createInjector,
    undefined,
    undefined
  );

function ownKeys$1(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys$1(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys$1(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$f(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$f(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$f() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaBaseInput = /*#__PURE__*/function (_Vue) {
  _inherits(DefaBaseInput, _Vue);

  var _super = _createSuper$f(DefaBaseInput);

  function DefaBaseInput() {
    var _this;

    _classCallCheck(this, DefaBaseInput);

    _this = _super.apply(this, arguments);
    _this.debouncedInput = debounce(function (input) {
      this.onInput(input, "input:debounced");
    }, 300);
    return _this;
  }

  _createClass(DefaBaseInput, [{
    key: "onInput",
    value: function onInput(event) {
      var eventName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "input";

      if (event.target) {
        var inputElement = event.target;

        if (this.type === "number") {
          this.$emit(eventName, inputElement.valueAsNumber);
          return;
        }

        this.$emit(eventName, inputElement.value);
      }
    }
  }, {
    key: "cssProps",
    get: function get() {
      return {
        "--color": this.color,
        "--label-background-color": this.labelBackgroundColor
      };
    }
  }, {
    key: "getRules",
    get: function get() {
      return getRules(this.rules, this.disabled);
    }
  }, {
    key: "hasRequiredRule",
    get: function get() {
      return hasRequiredRule(this.rules);
    }
  }, {
    key: "hasRequiredRuleHasLabelAndIsNotDisabled",
    get: function get() {
      if (this.disabled) {
        return false;
      }

      return this.hasRequiredRule && Boolean(this.label);
    }
  }, {
    key: "inputListeners",
    get: function get() {
      var _this2 = this;

      return _objectSpread$1(_objectSpread$1({}, this.$listeners), {}, {
        input: function input(event) {
          _this2.debouncedInput(event);

          _this2.onInput(event);
        }
      });
    }
  }]);

  return DefaBaseInput;
}(Vue$1);

__decorate([Prop({
  default: null,
  type: [String, Number]
}), __metadata("design:type", Object)], DefaBaseInput.prototype, "modelValue", void 0);

__decorate([Prop({
  default: null,
  type: String
}), __metadata("design:type", Object)], DefaBaseInput.prototype, "name", void 0);

__decorate([Prop({
  default: null,
  type: String
}), __metadata("design:type", Object)], DefaBaseInput.prototype, "label", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseInput.prototype, "hideLabel", void 0);

__decorate([Prop({
  default: "text",
  type: String
}), __metadata("design:type", String)], DefaBaseInput.prototype, "type", void 0);

__decorate([Prop({
  default: null,
  type: [Object, String]
}), __metadata("design:type", Object)], DefaBaseInput.prototype, "rules", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseInput.prototype, "disabled", void 0);

__decorate([Prop({
  default: null,
  type: Object
}), __metadata("design:type", Object)], DefaBaseInput.prototype, "customMessages", void 0);

__decorate([Prop({
  default: null,
  type: Object
}), __metadata("design:type", Object)], DefaBaseInput.prototype, "inputStyle", void 0);

__decorate([Prop({
  default: "var(--defa-oreon-color-black)",
  type: String
}), __metadata("design:type", String)], DefaBaseInput.prototype, "color", void 0);

__decorate([Prop({
  default: "white",
  type: String
}), __metadata("design:type", String)], DefaBaseInput.prototype, "labelBackgroundColor", void 0);

__decorate([Prop({
  default: "top",
  type: String
}), __metadata("design:type", String)], DefaBaseInput.prototype, "errorMessagePosition", void 0);

DefaBaseInput = __decorate([Component({
  components: {
    DefaBaseInputErrorMessage: __vue_component__$F,
    DefaTransitionFadeOutIn: __vue_component__$1f,
    ValidationProvider: ValidationProvider
  },
  inheritAttrs: false,
  model: {
    prop: "modelValue"
  },
  name: "DefaBaseInput"
})], DefaBaseInput);
var script$B = DefaBaseInput;

/* script */
const __vue_script__$B = script$B;

/* template */
var __vue_render__$B = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{style:(_vm.cssProps),attrs:{"tag":"div","custom-messages":_vm.customMessages,"name":_vm.name,"rules":_vm.getRules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var failed = ref.failed;
var errors = ref.errors;
var ariaMsg = ref.ariaMsg;
var ariaInput = ref.ariaInput;
return [_c('div',{staticClass:"base-input"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hideLabel),expression:"!hideLabel"}],staticClass:"base-input__label",class:{
        'base-input__label--disabled': _vm.disabled,
        'base-input__label--required': _vm.hasRequiredRuleHasLabelAndIsNotDisabled,
        'base-input__label--has-error': failed,
      },attrs:{"for":_vm.name}},[_vm._t("label",function(){return [_vm._v("\n        "+_vm._s(_vm.label)+"\n      ")]},null,{ hasRequiredRule: _vm.hasRequiredRule })],2),_vm._v(" "),_c('input',_vm._g(_vm._b({staticClass:"base-input__input",class:{
        'base-input__input--with-label': !_vm.hideLabel,
        'base-input__input--has-error': failed,
      },style:(_vm.inputStyle),attrs:{"id":_vm.name,"name":_vm.name,"disabled":_vm.disabled,"type":_vm.type,"data-test":_vm.name},domProps:{"value":_vm.modelValue}},'input',Object.assign({}, ariaInput,
        _vm.$attrs),false),_vm.inputListeners)),_vm._v(" "),_c('div',{staticClass:"base-input__addon-right"},[_vm._t("addon-right")],2),_vm._v(" "),_c('DefaBaseInputErrorMessage',_vm._b({directives:[{name:"show",rawName:"v-show",value:(failed),expression:"failed"}],attrs:{"position":_vm.errorMessagePosition}},'DefaBaseInputErrorMessage',ariaMsg,false),[_vm._v("\n      "+_vm._s(errors[0])+"\n    ")])],1)]}}],null,true)})};
var __vue_staticRenderFns__$B = [];

  /* style */
  const __vue_inject_styles__$B = function (inject) {
    if (!inject) return
    inject("data-v-eb09064a_0", { source: ".base-input[data-v-eb09064a]{position:relative;color:var(--color)}.base-input__label[data-v-eb09064a]{padding:0 1em;font-weight:700;display:flex;align-items:center;gap:.5em;position:absolute;bottom:100%;transform:translateY(50%);left:2em;background-color:var(--label-background-color)}.base-input__label--required[data-v-eb09064a]::after{content:\"*\"}.base-input__label--disabled[data-v-eb09064a]{color:var(--defa-oreon-color-gray-shade-3)}.base-input:focus-within .base-input__label[data-v-eb09064a]{color:var(--defa-oreon-color-primary)}.base-input__label.base-input__label--has-error[data-v-eb09064a]{color:var(--defa-oreon-color-error)}.base-input__input[data-v-eb09064a]{width:100%;color:inherit;outline:0;background-color:transparent;transition:border-color .3s ease-in-out}.base-input__input.base-input__input--has-error[data-v-eb09064a]{border-color:var(--defa-oreon-color-error)}.base-input__input:focus-within~.base-input-error-message[data-v-eb09064a],.base-input__input:focus~.base-input-error-message[data-v-eb09064a],.base-input__input:hover~.base-input-error-message[data-v-eb09064a]{opacity:1;z-index:0}.base-input__input--with-label[data-v-eb09064a]{padding:.75em;border:1px solid var(--defa-oreon-color-gray-shade-3)}.base-input__input[data-v-eb09064a]:focus{border-color:var(--defa-oreon-color-primary)}.base-input__input[type=search][data-v-eb09064a]::-webkit-search-cancel-button{display:none}.base-input__input[data-v-eb09064a]:disabled{color:var(--defa-oreon-color-gray-shade-3)}.base-input__addon-right[data-v-eb09064a]{position:absolute;right:1rem;top:50%;transform:translateY(-50%)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$B = "data-v-eb09064a";
  /* module identifier */
  const __vue_module_identifier__$B = undefined;
  /* functional template */
  const __vue_is_functional_template__$B = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$B = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$B, staticRenderFns: __vue_staticRenderFns__$B },
    __vue_inject_styles__$B,
    __vue_script__$B,
    __vue_scope_id__$B,
    __vue_is_functional_template__$B,
    __vue_module_identifier__$B,
    false,
    createInjector,
    undefined,
    undefined
  );

var CssPropsMixin = Vue.extend({
  props: {
    colorPrimary: {
      type: String,
      default: "black"
    }
  },
  computed: {
    cssProps: function cssProps() {
      return {
        "--color-primary": this.colorPrimary
      };
    }
  }
});

var script$A = Vue.extend({
  name: "DefaIconCalendar",
  mixins: [CssPropsMixin]
});

/* script */
const __vue_script__$A = script$A;

/* template */
var __vue_render__$A = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon-calendar",style:(_vm.cssProps),attrs:{"viewBox":"0 0 100 100"}},[_c('title',[_vm._v(_vm._s(_vm.$t("defaIconCalendar.title")))]),_vm._v(" "),_c('path',{attrs:{"d":"M82.26,12h-10V7.1a4.12,4.12,0,1,0-8.23,0h0V12h-28V7.1A4.14,4.14,0,0,0,31.93,3a4.08,4.08,0,0,0-4.12,4v5H18A15.58,15.58,0,0,0,2.4,27.59V80.93A15.57,15.57,0,0,0,18,96.5H82.26A15.57,15.57,0,0,0,97.83,80.93V27.59A15.64,15.64,0,0,0,82.26,12ZM18,20.16h9.94v4.92A4.14,4.14,0,0,0,32,29.2a4.08,4.08,0,0,0,4.12-4v-5H64.28v4.92a4.12,4.12,0,1,0,8.23,0V20.16h9.75a7.42,7.42,0,0,1,7.42,7.41v9.56H10.53V27.59a7.42,7.42,0,0,1,7.4-7.43ZM82.26,88.37H18A7.42,7.42,0,0,1,10.53,81V45.38H89.68V80.93a7.42,7.42,0,0,1-7.4,7.44Z"}})])};
var __vue_staticRenderFns__$A = [];

  /* style */
  const __vue_inject_styles__$A = function (inject) {
    if (!inject) return
    inject("data-v-77463ff0_0", { source: ".icon-calendar[data-v-77463ff0]{fill:var(--color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$A = "data-v-77463ff0";
  /* module identifier */
  const __vue_module_identifier__$A = undefined;
  /* functional template */
  const __vue_is_functional_template__$A = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$A = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$A, staticRenderFns: __vue_staticRenderFns__$A },
    __vue_inject_styles__$A,
    __vue_script__$A,
    __vue_scope_id__$A,
    __vue_is_functional_template__$A,
    __vue_module_identifier__$A,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$z = Vue.extend({
  name: "DefaIconUser",
  props: {
    width: {
      type: String,
      required: true
    },
    profilePic: {
      type: String,
      default: ""
    },
    colorPrimary: {
      type: String,
      default: "black"
    }
  },
  computed: {
    cssProps: function cssProps() {
      return {
        "--color-primary": this.colorPrimary,
        "--icon-width": "".concat(this.width, "px"),
        "--icon-height": "".concat(this.width, "px")
      };
    }
  }
});

/* script */
const __vue_script__$z = script$z;

/* template */
var __vue_render__$z = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.cssProps)},[(_vm.profilePic)?_c('img',{staticClass:"icon-user",attrs:{"alt":_vm.$t('defaIconUser.title'),"height":_vm.width,"src":_vm.profilePic,"width":_vm.width}}):_c('svg',{staticClass:"icon-user icon-user--svg",attrs:{"viewBox":"0 0 100 100"}},[_c('title',[_vm._v(_vm._s(_vm.$t("defaIconUser.title")))]),_vm._v(" "),_c('path',{attrs:{"d":"M49.42,31.63a7.88,7.88,0,1,0,7.88,7.88A7.89,7.89,0,0,0,49.42,31.63Z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M63.3,62.64c-3.48,2.57-9,5.69-14.52,5.67-5.08.28-10.51-2.94-14-5.54C28,67,25.92,76,25.29,81.16a39.6,39.6,0,0,0,47.5,1.43C72.29,77.22,70.39,66.28,63.3,62.64Z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M50,10.19A39.75,39.75,0,0,0,20,76c1.5-6.85,5.1-15.75,13.85-19.7l1.72-.77,1.58,1.28c3.39,2.73,8.11,5.54,11.39,5.34h.32c3.11.09,7.67-1.88,12-5.31l1.34-1.07,1.77.45c9.66,3.28,13.18,14.1,14.47,21.66A39.78,39.78,0,0,0,50,10.19Zm-.58,43.32a14,14,0,1,1,14-14A14,14,0,0,1,49.42,53.51Z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M50,1A49,49,0,1,0,99,50,49.05,49.05,0,0,0,50,1ZM25.29,81.16C25.92,76,28,67,34.76,62.77c3.51,2.6,8.94,5.82,14,5.54,5.48,0,11-3.1,14.52-5.67,7.09,3.64,9,14.58,9.49,20a39.6,39.6,0,0,1-47.5-1.43Zm53.06-3.25c-1.29-7.56-4.81-18.38-14.47-21.66l-1.77-.45-1.34,1.07c-4.28,3.43-8.84,5.4-12,5.31H48.5c-3.28.2-8-2.61-11.39-5.34l-1.58-1.28-1.72.77C25.06,60.29,21.46,69.19,20,76a39.79,39.79,0,1,1,58.39,1.87Z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M49.42,25.5a14,14,0,1,0,14,14A14,14,0,0,0,49.42,25.5Zm0,21.88a7.88,7.88,0,1,1,7.88-7.87A7.89,7.89,0,0,1,49.42,47.38Z"}})])])};
var __vue_staticRenderFns__$z = [];

  /* style */
  const __vue_inject_styles__$z = function (inject) {
    if (!inject) return
    inject("data-v-b5ffe0b0_0", { source: ".icon-user[data-v-b5ffe0b0]{width:var(--icon-width);height:var(--icon-height)}.icon-user--svg[data-v-b5ffe0b0]{fill:var(--color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$z = "data-v-b5ffe0b0";
  /* module identifier */
  const __vue_module_identifier__$z = undefined;
  /* functional template */
  const __vue_is_functional_template__$z = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$z = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$z, staticRenderFns: __vue_staticRenderFns__$z },
    __vue_inject_styles__$z,
    __vue_script__$z,
    __vue_scope_id__$z,
    __vue_is_functional_template__$z,
    __vue_module_identifier__$z,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$y = Vue.extend({
  name: "DefaIconList",
  mixins: [CssPropsMixin]
});

/* script */
const __vue_script__$y = script$y;

/* template */
var __vue_render__$y = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon-list",style:(_vm.cssProps),attrs:{"viewBox":"0 0 100 100"}},[_c('title',[_vm._v(_vm._s(_vm.$t("defaIconList.title")))]),_vm._v(" "),_c('path',{attrs:{"d":"M50,1A48.5,48.5,0,1,0,98.5,49.5,48.55,48.55,0,0,0,50,1Zm0,6.47a42,42,0,1,1-42,42A42,42,0,0,1,50,7.47ZM31.68,32.26A4.31,4.31,0,1,0,36,36.57,4.31,4.31,0,0,0,31.68,32.26Zm10.44,1.07a3.24,3.24,0,1,0,.34,6.47H69.4a3.24,3.24,0,1,0,.09-6.47H42.12ZM31.68,45.19A4.31,4.31,0,1,0,36,49.5,4.31,4.31,0,0,0,31.68,45.19Zm10.44,1.08a3.23,3.23,0,1,0,.34,6.46H69.4a3.23,3.23,0,1,0,.09-6.46h-27A1.93,1.93,0,0,0,42.12,46.27ZM31.68,58.12A4.31,4.31,0,1,0,36,62.43,4.31,4.31,0,0,0,31.68,58.12ZM42.12,59.2a3.24,3.24,0,1,0,.34,6.47H69.4a3.24,3.24,0,1,0,.09-6.47h-27A1.93,1.93,0,0,0,42.12,59.2Z"}})])};
var __vue_staticRenderFns__$y = [];

  /* style */
  const __vue_inject_styles__$y = function (inject) {
    if (!inject) return
    inject("data-v-7da14bb4_0", { source: ".icon-list[data-v-7da14bb4]{fill:var(--color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$y = "data-v-7da14bb4";
  /* module identifier */
  const __vue_module_identifier__$y = undefined;
  /* functional template */
  const __vue_is_functional_template__$y = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$y = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$y, staticRenderFns: __vue_staticRenderFns__$y },
    __vue_inject_styles__$y,
    __vue_script__$y,
    __vue_scope_id__$y,
    __vue_is_functional_template__$y,
    __vue_module_identifier__$y,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$x = Vue.extend({
  name: "DefaIconUpload"
});

/* script */
const __vue_script__$x = script$x;

/* template */
var __vue_render__$x = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon-upload",attrs:{"height":"67.046","viewBox":"0 0 80.291 67.046","width":"80.291"}},[_c('title',[_vm._v(_vm._s(_vm.$t("defaIconUpload.title")))]),_vm._v(" "),_c('g',{attrs:{"transform":"translate(40 27.211)"}},[_c('g',{attrs:{"transform":"translate(-40 -27.211)"}},[_c('path',{staticClass:"a",attrs:{"d":"M82.3,42.29A21.148,21.148,0,0,1,61.482,58.5h-6.93V52.552h6.9A15.229,15.229,0,0,0,76.5,41.041,14.982,14.982,0,0,0,61.988,22.808a13.712,13.712,0,0,0-2.5.208l-3.242.595-.268-3.3a13.355,13.355,0,0,0-26.2-2.558l-.684,2.528L26.5,19.833a15.765,15.765,0,0,0-1.7,0,16.508,16.508,0,0,0-12.255,5.5A16.33,16.33,0,0,0,8.566,38.245c1.071,8.685,8.923,14.307,20.375,14.307h1.814V58.5H28.941c-14.307,0-24.956-7.853-26.264-19.542a22.279,22.279,0,0,1,22.13-25.075,19.334,19.334,0,0,1,36.645,2.974A20.821,20.821,0,0,1,82.273,42.29Zm-25.64,2.2-14.01-13.98-14.01,13.98,4.224,4.224,6.812-6.841V69.053h5.949V41.874l6.812,6.841Z","transform":"translate(-2.501 -2.007)"}})])])])};
var __vue_staticRenderFns__$x = [];

  /* style */
  const __vue_inject_styles__$x = function (inject) {
    if (!inject) return
    inject("data-v-2eaa9cc4_0", { source: ".icon-upload[data-v-2eaa9cc4]{fill:var(--defa-oreon-color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$x = "data-v-2eaa9cc4";
  /* module identifier */
  const __vue_module_identifier__$x = undefined;
  /* functional template */
  const __vue_is_functional_template__$x = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$x = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$x, staticRenderFns: __vue_staticRenderFns__$x },
    __vue_inject_styles__$x,
    __vue_script__$x,
    __vue_scope_id__$x,
    __vue_is_functional_template__$x,
    __vue_module_identifier__$x,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$w = Vue.extend({
  name: "DefaIconCar",
  mixins: [CssPropsMixin]
});

/* script */
const __vue_script__$w = script$w;

/* template */
var __vue_render__$w = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon-car",style:(_vm.cssProps),attrs:{"viewBox":"0 0 100 100"}},[_c('title',[_vm._v(_vm._s(_vm.$t("defaIconCar.title")))]),_vm._v(" "),_c('path',{attrs:{"d":"M25,69.88a8.67,8.67,0,0,0,8.58-7.55h0a8.32,8.32,0,0,0,.08-1.12,8.86,8.86,0,0,0-.19-1.8h0a8.66,8.66,0,0,0-16.95,0h0a8.86,8.86,0,0,0-.19,1.8,8.77,8.77,0,0,0,.09,1.15h0A8.68,8.68,0,0,0,25,69.88Zm0-14.5a5.83,5.83,0,1,1-5.84,5.83A5.84,5.84,0,0,1,25,55.38Z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M88.28,44.54a21.38,21.38,0,0,0-3.47-.62L72.7,42.14l-3.12-.46L61.2,33.3C60.11,32.21,59.07,31,57.89,30a8.18,8.18,0,0,0-5.2-1.9H31.31A8.07,8.07,0,0,0,25,30.73L16,39.8H13.22a7.73,7.73,0,0,0-4.56,1A6.36,6.36,0,0,0,5.8,46.1V56.67A9.42,9.42,0,0,0,6,59.21a4.42,4.42,0,0,0,4.42,3.15h3.14a10.93,10.93,0,0,1-.06-1.15,11.92,11.92,0,0,1,.16-1.8H10a1.06,1.06,0,0,1-.19,0,2.22,2.22,0,0,1-.32-.1l-.31-.2-.14-.15a.86.86,0,0,1-.1-.16s-.09-.18-.11-.21a2.58,2.58,0,0,1-.08-.26c-.08-.24,0-.08,0,0a1.22,1.22,0,0,1,0-.27v-.25c0-3.9,0-7.79,0-11.69a5.44,5.44,0,0,1,0-.57l.08-.38A2.25,2.25,0,0,1,9,44.89L9,44.73v0c.09-.17.17-.34.27-.5s.13-.19.13-.2l.09-.11c.14-.15.3-.29.45-.44l0,0,.05,0,.31-.21.38-.2.57-.18.25-.06h1.64c1.09,0,2.18,0,3.28,0a2.41,2.41,0,0,0,1.71-1l9-9,.24-.24.34-.31.09-.07a5.11,5.11,0,0,1,.62-.41,4.05,4.05,0,0,1,1.35-.53A4,4,0,0,1,31,31.06H52.55a5.17,5.17,0,0,1,2.72.66A6.94,6.94,0,0,1,56.8,33l1.8,1.8,9.1,9.11a1.93,1.93,0,0,0,1.09.59l1.95.28,7.05,1,6.75,1,1.55.22a9.19,9.19,0,0,1,1.38.31l.35.12.14,0,.64.31a5.73,5.73,0,0,1,.62.38l.25.16.08.06.08.08a7,7,0,0,1,2.45,5.2s0,0,0,0v4.46c0,.12-.07.25-.09.38s0,.06,0,0l-.19.33c-.13.23-.05,0,0,0l-.24.24-.14.09-.22.11-.13,0-.22,0h-5.2a11.92,11.92,0,0,1,.15,1.8c0,.37,0,.73-.05,1.08h3.68a6.3,6.3,0,0,0,3.44-.62,4.35,4.35,0,0,0,2-2.8,8,8,0,0,0,.1-1.62V54.1a1.87,1.87,0,0,0,0-.25v-.14A9.79,9.79,0,0,0,88.28,44.54Z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M74.25,52.54a8.69,8.69,0,0,0-8.48,6.87h0a8.21,8.21,0,0,0-.19,1.8,10.36,10.36,0,0,0,.07,1.12h0a8.66,8.66,0,0,0,17.18,0h0a9.48,9.48,0,0,0,.07-1.08,8.21,8.21,0,0,0-.19-1.8h0A8.69,8.69,0,0,0,74.25,52.54Zm0,14.5a5.83,5.83,0,1,1,5.83-5.83A5.83,5.83,0,0,1,74.25,67Z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M36.39,59.41a11.92,11.92,0,0,1,.16,1.8,10.37,10.37,0,0,1-.06,1.12H62.77a10.37,10.37,0,0,1-.06-1.12,11.92,11.92,0,0,1,.15-1.8Z"}})])};
var __vue_staticRenderFns__$w = [];

  /* style */
  const __vue_inject_styles__$w = function (inject) {
    if (!inject) return
    inject("data-v-3240e5b9_0", { source: ".icon-car[data-v-3240e5b9]{fill:var(--color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$w = "data-v-3240e5b9";
  /* module identifier */
  const __vue_module_identifier__$w = undefined;
  /* functional template */
  const __vue_is_functional_template__$w = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$w = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$w, staticRenderFns: __vue_staticRenderFns__$w },
    __vue_inject_styles__$w,
    __vue_script__$w,
    __vue_scope_id__$w,
    __vue_is_functional_template__$w,
    __vue_module_identifier__$w,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$v = Vue.extend({
  name: "DefaIconId",
  mixins: [CssPropsMixin]
});

/* script */
const __vue_script__$v = script$v;

/* template */
var __vue_render__$v = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon-id",style:(_vm.cssProps),attrs:{"image-rendering":"optimizeQuality","shape-rendering":"geometricPrecision","text-rendering":"geometricPrecision","viewBox":"0 0 3333 2536"}},[_c('title',[_vm._v(_vm._s(_vm.$t("defaIconId.title")))]),_vm._v(" "),_c('path',{attrs:{"d":"M229 146c-22 0-43 9-58 24s-24 36-24 58v2088c0 16 10 31 25 44 22 18 51 29 76 29h260v-204c0-40 33-73 73-73h392c40 0 73 33 73 73v204h1289v-204c0-40 33-73 73-73h389c40 0 73 33 73 73v204h245c19 0 37-9 51-22 14-14 22-32 22-51V520c0-20-8-38-21-52-13-13-31-21-52-21H1761c-40 0-73-33-73-73 0-58 0-127-18-173-12-32-38-56-90-56H229zm1632 1435h1067v142H1861v-142zm0-741h1067v142H1861V840zm0 371h1067v142H1861v-142zM716 757v122c-62 16-59 184 10 184 21 0 119 141 133 165 28 46 0 63 0 94-299 68-386 98-386 401h1046c0-303-86-333-386-401 0-37-25-53 0-94 28-46 79-110 131-165 72 1 74-168 11-184V757c0-294-560-294-560 0zM67 68c41-41 99-67 161-67h1351c128 0 193 64 226 151 18 48 24 101 27 152h1282c61 0 115 25 155 64 40 40 64 94 64 155v1796c0 60-25 114-65 154s-95 65-154 65h-318c-40 0-73-33-73-73v-204h-243v204c0 40-33 73-73 73H972c-40 0-73-33-73-73v-204H653v204c0 40-33 73-73 73H247c-58 0-122-24-170-63-46-38-78-92-78-156V231c0-63 26-120 67-161z","fill-rule":"nonzero"}})])};
var __vue_staticRenderFns__$v = [];

  /* style */
  const __vue_inject_styles__$v = function (inject) {
    if (!inject) return
    inject("data-v-e7a7f9cc_0", { source: ".icon-id[data-v-e7a7f9cc]{fill:var(--color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$v = "data-v-e7a7f9cc";
  /* module identifier */
  const __vue_module_identifier__$v = undefined;
  /* functional template */
  const __vue_is_functional_template__$v = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$v = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$v, staticRenderFns: __vue_staticRenderFns__$v },
    __vue_inject_styles__$v,
    __vue_script__$v,
    __vue_scope_id__$v,
    __vue_is_functional_template__$v,
    __vue_module_identifier__$v,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$u = Vue.extend({
  name: "DefaIconEnveloppe",
  mixins: [CssPropsMixin]
});

/* script */
const __vue_script__$u = script$u;

/* template */
var __vue_render__$u = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon-envelope",attrs:{"image-rendering":"optimizeQuality","shape-rendering":"geometricPrecision","text-rendering":"geometricPrecision","viewBox":"0 0 3333 2410"}},[_c('title',[_vm._v(_vm._s(_vm.$t("defaIconEnvelope.title")))]),_vm._v(" "),_c('path',{attrs:{"d":"M191 0h2951c53 0 100 22 135 56 35 35 56 83 56 135v2028c0 40-12 77-33 107-4 10-10 19-18 27-5 5-11 9-18 13-33 28-76 45-122 45H191c-53 0-100-22-135-56-35-35-56-82-56-135V192C0 139 21 92 56 57S138 1 191 1zm-45 2139l1034-1037L146 259v1880zm1148-944L228 2264h2867L2076 1195l-336 286c-26 23-66 24-94 1l-353-287zm894-95l998 1047V250l-998 850zM240 147l1452 1184L3081 147H240z","fill-rule":"nonzero"}})])};
var __vue_staticRenderFns__$u = [];

  /* style */
  const __vue_inject_styles__$u = function (inject) {
    if (!inject) return
    inject("data-v-1ba64f9d_0", { source: ".icon-envelope[data-v-1ba64f9d]{stroke:var(--color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$u = "data-v-1ba64f9d";
  /* module identifier */
  const __vue_module_identifier__$u = undefined;
  /* functional template */
  const __vue_is_functional_template__$u = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$u = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$u, staticRenderFns: __vue_staticRenderFns__$u },
    __vue_inject_styles__$u,
    __vue_script__$u,
    __vue_scope_id__$u,
    __vue_is_functional_template__$u,
    __vue_module_identifier__$u,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$t = Vue.extend({
  name: "DefaIconMapPointer",
  mixins: [CssPropsMixin]
});

/* script */
const __vue_script__$t = script$t;

/* template */
var __vue_render__$t = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon-map-pointer",style:(_vm.cssProps),attrs:{"image-rendering":"optimizeQuality","shape-rendering":"geometricPrecision","text-rendering":"geometricPrecision","viewBox":"0 0 4066 5416"}},[_c('title',[_vm._v(_vm._s(_vm.$t("defaIconMapPointer.title")))]),_vm._v(" "),_c('path',{attrs:{"d":"M2094 5150c278-177 528-391 746-630 473-518 792-1151 920-1772 127-613 67-1214-214-1678-80-133-180-255-299-364-341-311-732-459-1125-463-413-3-832 152-1202 447-158 126-288 271-389 431-260 409-339 917-253 1448 87 539 343 1103 751 1614 284 356 641 687 1066 966zm-60-4218c311 0 593 126 796 330 204 204 330 485 330 796s-126 593-330 796c-204 204-485 330-796 330s-593-126-796-330c-204-204-330-485-330-796s126-593 330-796c204-204 485-330 796-330zm634 492c-162-162-387-263-634-263-248 0-472 100-634 263-162 162-263 387-263 634 0 248 100 472 263 634 162 162 387 263 634 263 248 0 472-100 634-263 162-162 263-387 263-634 0-248-100-472-263-634zm353 3260c-247 270-533 512-856 708-39 29-94 33-138 5-476-303-875-667-1190-1062-433-544-707-1147-800-1728-95-589-6-1155 287-1617 116-182 263-348 444-491C1181 170 1654-4 2124-1c453 4 900 172 1288 526 136 124 250 264 343 418 315 519 383 1182 245 1852-137 663-476 1337-978 1887z","fill-rule":"nonzero"}})])};
var __vue_staticRenderFns__$t = [];

  /* style */
  const __vue_inject_styles__$t = function (inject) {
    if (!inject) return
    inject("data-v-7f283cba_0", { source: ".icon-map-pointer[data-v-7f283cba]{fill:var(--color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$t = "data-v-7f283cba";
  /* module identifier */
  const __vue_module_identifier__$t = undefined;
  /* functional template */
  const __vue_is_functional_template__$t = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$t = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$t, staticRenderFns: __vue_staticRenderFns__$t },
    __vue_inject_styles__$t,
    __vue_script__$t,
    __vue_scope_id__$t,
    __vue_is_functional_template__$t,
    __vue_module_identifier__$t,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$s = Vue.extend({
  name: "DefaIconPhone",
  mixins: [CssPropsMixin]
});

/* script */
const __vue_script__$s = script$s;

/* template */
var __vue_render__$s = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon-phone",style:(_vm.cssProps),attrs:{"clip-rule":"evenodd","fill-rule":"evenodd","image-rendering":"optimizeQuality","viewBox":"0 0 3333 3317"}},[_c('title',[_vm._v(_vm._s(_vm.$t("defaIconPhone.title")))]),_vm._v(" "),_c('path',{attrs:{"d":"M917 1364c112 202 241 396 409 573 168 178 377 340 648 478 20 10 39 10 56 3 26-10 52-31 78-57 20-20 45-52 71-87 104-137 233-307 415-222 4 2 7 4 11 6l607 349c2 1 4 3 6 4 80 55 113 140 114 236 0 98-36 208-89 301-70 123-173 204-292 258-113 52-239 80-360 98-190 28-368 10-550-46-178-55-357-146-553-267l-14-9c-90-56-187-116-282-187-349-263-704-643-935-1061C63 1383-43 1004 15 643c32-198 117-378 265-497C409 42 583-15 808 5c26 2 49 17 61 39l389 658c57 74 64 147 33 220-26 60-78 115-149 167-21 18-46 36-72 55-87 63-186 136-152 222zm294 682c-179-189-316-394-433-606-2-3-4-7-5-11-86-202 68-315 203-414 23-17 45-33 65-50 1-1 2-2 4-3 50-37 86-72 100-104 8-18 5-39-13-61-3-4-6-7-8-11L754 159c-159-7-283 36-374 110-115 93-182 238-208 399-52 323 47 667 225 990 219 397 558 759 891 1010 92 69 184 126 269 179l14 9c185 115 353 200 517 251 159 49 316 65 481 40 109-16 220-40 317-85 91-42 169-103 221-193 41-72 69-153 68-223 0-44-13-82-44-104l-604-347c-67-29-153 84-222 175-30 39-58 76-86 104-40 40-85 74-135 93-58 22-119 23-183-10-288-146-510-319-691-510z"}})])};
var __vue_staticRenderFns__$s = [];

  /* style */
  const __vue_inject_styles__$s = function (inject) {
    if (!inject) return
    inject("data-v-7da628d2_0", { source: ".icon-phone[data-v-7da628d2]{fill:var(--color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$s = "data-v-7da628d2";
  /* module identifier */
  const __vue_module_identifier__$s = undefined;
  /* functional template */
  const __vue_is_functional_template__$s = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$s = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$s, staticRenderFns: __vue_staticRenderFns__$s },
    __vue_inject_styles__$s,
    __vue_script__$s,
    __vue_scope_id__$s,
    __vue_is_functional_template__$s,
    __vue_module_identifier__$s,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$r = Vue.extend({
  name: "DefaIconStats",
  mixins: [CssPropsMixin]
});

/* script */
const __vue_script__$r = script$r;

/* template */
var __vue_render__$r = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{style:(_vm.cssProps),attrs:{"height":"32","viewBox":"0 0 32 32","width":"32"}},[_c('title',[_vm._v(_vm._s(_vm.$t("defaIconStats.title")))]),_vm._v(" "),_c('g',{attrs:{"transform":"translate(-1275 -257)"}},[_c('g',{staticClass:"circles",attrs:{"stroke-width":"3","transform":"translate(1275 257)"}},[_c('circle',{attrs:{"cx":"16","cy":"16","r":"16","stroke":"none"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"16","cy":"16","fill":"none","r":"14.5"}})]),_vm._v(" "),_c('g',{staticClass:"rects"},[_c('rect',{attrs:{"height":"7","transform":"translate(1283 272)","width":"3"}}),_vm._v(" "),_c('rect',{attrs:{"height":"9","transform":"translate(1289 270)","width":"3"}}),_vm._v(" "),_c('rect',{attrs:{"height":"13","transform":"translate(1295 266)","width":"3"}})])])])};
var __vue_staticRenderFns__$r = [];

  /* style */
  const __vue_inject_styles__$r = function (inject) {
    if (!inject) return
    inject("data-v-4ab7933c_0", { source: ".circles[data-v-4ab7933c]{fill:none;stroke:var(--color-primary)}.rects[data-v-4ab7933c]{fill:var(--color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$r = "data-v-4ab7933c";
  /* module identifier */
  const __vue_module_identifier__$r = undefined;
  /* functional template */
  const __vue_is_functional_template__$r = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$r = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$r, staticRenderFns: __vue_staticRenderFns__$r },
    __vue_inject_styles__$r,
    __vue_script__$r,
    __vue_scope_id__$r,
    __vue_is_functional_template__$r,
    __vue_module_identifier__$r,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$q = Vue.extend({
  name: "DefaIconPlus",
  mixins: [CssPropsMixin]
});

/* script */
const __vue_script__$q = script$q;

/* template */
var __vue_render__$q = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon-plus",style:(_vm.cssProps),attrs:{"stroke-width":"10","viewBox":"0 0 100 100"}},[_c('title',[_vm._v(_vm._s(_vm.$t("defaIconPlus.title")))]),_vm._v(" "),_c('circle',{attrs:{"cx":"50","cy":"50","fill":"none","r":"45"}}),_vm._v(" "),_c('line',{attrs:{"x1":"25","x2":"75","y1":"50","y2":"50"}}),_vm._v(" "),_c('line',{attrs:{"x1":"50","x2":"50","y1":"25","y2":"75"}})])};
var __vue_staticRenderFns__$q = [];

  /* style */
  const __vue_inject_styles__$q = function (inject) {
    if (!inject) return
    inject("data-v-c31dc1b4_0", { source: ".icon-plus[data-v-c31dc1b4]{stroke:var(--color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$q = "data-v-c31dc1b4";
  /* module identifier */
  const __vue_module_identifier__$q = undefined;
  /* functional template */
  const __vue_is_functional_template__$q = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$q = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$q, staticRenderFns: __vue_staticRenderFns__$q },
    __vue_inject_styles__$q,
    __vue_script__$q,
    __vue_scope_id__$q,
    __vue_is_functional_template__$q,
    __vue_module_identifier__$q,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$p = Vue.extend({
  name: "DefaIconCaret",
  mixins: [CssPropsMixin],
  props: {
    direction: {
      default: "down",
      type: String
    }
  },
  computed: {
    caretDirectionClass: function caretDirectionClass() {
      return "icon-caret--".concat(this.direction);
    }
  }
});

/* script */
const __vue_script__$p = script$p;

/* template */
var __vue_render__$p = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon-caret",class:_vm.caretDirectionClass,style:(_vm.cssProps),attrs:{"viewBox":"0 0 100 100"}},[_c('title',[_vm._v(_vm._s(_vm.$t("defaIconCaret.title")))]),_vm._v(" "),_c('polygon',{attrs:{"points":"49.43 85.02 2.06 37.64 12.08 27.62 49.43 64.98 87.42 26.99 97.44 37.01 49.43 85.02"}})])};
var __vue_staticRenderFns__$p = [];

  /* style */
  const __vue_inject_styles__$p = function (inject) {
    if (!inject) return
    inject("data-v-7a4bc53d_0", { source: ".icon-caret[data-v-7a4bc53d]{fill:var(--color-primary);transition:.2s transform ease;transform:rotate(0)}.icon-caret--left[data-v-7a4bc53d]{transform:rotate(90deg)}.icon-caret--up[data-v-7a4bc53d]{transform:rotate(180deg)}.icon-caret--right[data-v-7a4bc53d]{transform:rotate(270deg)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$p = "data-v-7a4bc53d";
  /* module identifier */
  const __vue_module_identifier__$p = undefined;
  /* functional template */
  const __vue_is_functional_template__$p = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$p = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$p, staticRenderFns: __vue_staticRenderFns__$p },
    __vue_inject_styles__$p,
    __vue_script__$p,
    __vue_scope_id__$p,
    __vue_is_functional_template__$p,
    __vue_module_identifier__$p,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$o = Vue.extend({
  name: "DefaIconHouseOwnerApproved",
  mixins: [CssPropsMixin]
});

/* script */
const __vue_script__$o = script$o;

/* template */
var __vue_render__$o = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon-house-owner-approved",attrs:{"viewBox":"0 0 100 100"}},[_c('title',[_vm._v(_vm._s(_vm.$t("defaIconHouseOwnerApproved.title")))]),_vm._v(" "),_c('rect',{attrs:{"height":"8.06","width":"8.06","x":"22.74","y":"31.33"}}),_vm._v(" "),_c('rect',{attrs:{"height":"8.06","width":"8.06","x":"22.74","y":"47.45"}}),_vm._v(" "),_c('rect',{attrs:{"height":"8.06","width":"8.06","x":"22.74","y":"63.58"}}),_vm._v(" "),_c('rect',{attrs:{"height":"8.06","width":"8.06","x":"38.87","y":"31.33"}}),_vm._v(" "),_c('path',{attrs:{"d":"M67.08,38.27A25.31,25.31,0,1,0,92.4,63.58,25.31,25.31,0,0,0,67.08,38.27ZM62.9,73.41l-8.74-8.75L57,61.81l5.89,5.9L75.77,54.83l2.85,2.85Z","fill":"#00b27c"}}),_vm._v(" "),_c('path',{attrs:{"d":"M42.25,80.45H13.91V27.67L36.4,15.77,58.63,27.66v6.83a28.55,28.55,0,0,1,4-.85V25.25l-26.24-14-26.54,14V84.49H45.62A30.33,30.33,0,0,1,42.25,80.45Z"}})])};
var __vue_staticRenderFns__$o = [];

  /* style */
  const __vue_inject_styles__$o = function (inject) {
    if (!inject) return
    inject("data-v-c903b6a2_0", { source: ".icon-house-owner-approved[data-v-c903b6a2]{fill:var(--color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$o = "data-v-c903b6a2";
  /* module identifier */
  const __vue_module_identifier__$o = undefined;
  /* functional template */
  const __vue_is_functional_template__$o = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$o = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$o, staticRenderFns: __vue_staticRenderFns__$o },
    __vue_inject_styles__$o,
    __vue_script__$o,
    __vue_scope_id__$o,
    __vue_is_functional_template__$o,
    __vue_module_identifier__$o,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$n = Vue.extend({
  name: "DefaIconHouseOwnerNA",
  mixins: [CssPropsMixin]
});

/* script */
const __vue_script__$n = script$n;

/* template */
var __vue_render__$n = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon-house-owner-na",style:(_vm.cssProps),attrs:{"viewBox":"0 0 100 100"}},[_c('title',[_vm._v(_vm._s(_vm.$t("defaIconHouseOwnerNA.title")))]),_vm._v(" "),_c('rect',{attrs:{"fill":"#ddd","height":"8.06","width":"8.06","x":"22.74","y":"31.33"}}),_vm._v(" "),_c('rect',{attrs:{"fill":"#ddd","height":"8.06","width":"8.06","x":"22.74","y":"47.45"}}),_vm._v(" "),_c('rect',{attrs:{"fill":"#ddd","height":"8.06","width":"8.06","x":"22.74","y":"63.58"}}),_vm._v(" "),_c('rect',{attrs:{"fill":"#ddd","height":"8.06","width":"8.06","x":"38.87","y":"31.33"}}),_vm._v(" "),_c('path',{attrs:{"d":"M13.91,80.45V27.67L36.4,15.77,58.63,27.66v6.83a28.55,28.55,0,0,1,4-.85V25.25l-26.24-14-26.54,14V84.49H45.62a30.33,30.33,0,0,1-3.37-4Z","fill":"#ddd"}}),_vm._v(" "),_c('path',{attrs:{"d":"M67.53,37.75A25.3,25.3,0,0,0,47.75,78.84L83.31,43.28A25.18,25.18,0,0,0,67.53,37.75Z","fill":"#ddd"}}),_vm._v(" "),_c('path',{attrs:{"d":"M87.32,47.28,51.75,82.85A25.31,25.31,0,0,0,87.32,47.28Z","fill":"#ddd"}})])};
var __vue_staticRenderFns__$n = [];

  /* style */
  const __vue_inject_styles__$n = function (inject) {
    if (!inject) return
    inject("data-v-cef67256_0", { source: ".icon-house-owner-na[data-v-cef67256]{fill:var(--color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$n = "data-v-cef67256";
  /* module identifier */
  const __vue_module_identifier__$n = undefined;
  /* functional template */
  const __vue_is_functional_template__$n = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$n = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$n, staticRenderFns: __vue_staticRenderFns__$n },
    __vue_inject_styles__$n,
    __vue_script__$n,
    __vue_scope_id__$n,
    __vue_is_functional_template__$n,
    __vue_module_identifier__$n,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$m = Vue.extend({
  name: "DefaIconHouseOwnerRejected",
  mixins: [CssPropsMixin]
});

/* script */
const __vue_script__$m = script$m;

/* template */
var __vue_render__$m = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon-house-owner-rejected",style:(_vm.cssProps),attrs:{"viewBox":"0 0 100 100"}},[_c('title',[_vm._v(_vm._s(_vm.$t("defaIconHouseOwnerRejected.title")))]),_vm._v(" "),_c('rect',{attrs:{"height":"8.06","width":"8.06","x":"22.74","y":"31.33"}}),_vm._v(" "),_c('rect',{attrs:{"height":"8.06","width":"8.06","x":"22.74","y":"47.45"}}),_vm._v(" "),_c('rect',{attrs:{"height":"8.06","width":"8.06","x":"22.74","y":"63.58"}}),_vm._v(" "),_c('rect',{attrs:{"height":"8.06","width":"8.06","x":"38.87","y":"31.33"}}),_vm._v(" "),_c('path',{attrs:{"d":"M42.25,80.45H13.91V27.67L36.4,15.77,58.63,27.66v6.83a28.55,28.55,0,0,1,4-.85V25.25l-26.24-14-26.54,14V84.49H45.62A30.33,30.33,0,0,1,42.25,80.45Z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M67.11,37.62A25.31,25.31,0,1,0,92.42,62.93,25.31,25.31,0,0,0,67.11,37.62Zm7.71,35.92L67,65.75l-7.71,7.71-2.74-2.74L64.29,63,56.5,55.22l2.9-2.89,7.79,7.79L74.9,52.4l2.74,2.74-7.71,7.72,7.78,7.79Z","fill":"#ed595c"}})])};
var __vue_staticRenderFns__$m = [];

  /* style */
  const __vue_inject_styles__$m = function (inject) {
    if (!inject) return
    inject("data-v-2348f599_0", { source: ".icon-house-owner-rejected[data-v-2348f599]{fill:var(--color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$m = "data-v-2348f599";
  /* module identifier */
  const __vue_module_identifier__$m = undefined;
  /* functional template */
  const __vue_is_functional_template__$m = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$m = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$m, staticRenderFns: __vue_staticRenderFns__$m },
    __vue_inject_styles__$m,
    __vue_script__$m,
    __vue_scope_id__$m,
    __vue_is_functional_template__$m,
    __vue_module_identifier__$m,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$l = Vue.extend({
  name: "DefaIconCompany",
  mixins: [CssPropsMixin]
});

/* script */
const __vue_script__$l = script$l;

/* template */
var __vue_render__$l = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon-company",style:(_vm.cssProps),attrs:{"x":"0px","y":"0px","viewBox":"0 0 122.88 115.49"}},[_c('title',[_vm._v(_vm._s(_vm.$t("defaIconCompany.title")))]),_vm._v(" "),_c('g',[_c('path',{attrs:{"d":"M36,68.78c0,0.8-0.65,1.44-1.44,1.44c-0.8,0-1.44-0.65-1.44-1.44V33.51H2.88v71.08h4.99c0.8,0,1.44,0.65,1.44,1.44 c0,0.8-0.65,1.44-1.44,1.44H1.44c-0.8,0-1.44-0.65-1.44-1.44V32.74c0-0.58,0.24-1.11,0.62-1.5c0.38-0.38,0.91-0.62,1.5-0.62h31 V2.53c0-0.69,0.28-1.33,0.74-1.78V0.74C34.32,0.28,34.95,0,35.65,0H87c0.7,0,1.33,0.28,1.79,0.74l0.11,0.12 c0.39,0.45,0.64,1.03,0.64,1.67v28.09h31.22c0.58,0,1.11,0.24,1.49,0.62l0.01,0.01c0.38,0.38,0.62,0.91,0.62,1.49v73.29 c0,0.8-0.65,1.44-1.44,1.44h-9.14c-0.8,0-1.44-0.65-1.44-1.44c0-0.8,0.65-1.44,1.44-1.44H120V33.51H89.53v34.85 c0,0.8-0.65,1.44-1.44,1.44c-0.8,0-1.44-0.65-1.44-1.44V2.88H36V68.78L36,68.78z M97.15,68.54h15.9c0.13,0,0.24,0.08,0.24,0.17v4.7 c0,0.1-0.11,0.18-0.24,0.18h-15.9c-0.13,0-0.24-0.08-0.24-0.18v-4.7C96.91,68.62,97.02,68.54,97.15,68.54L97.15,68.54z M9.71,68.54 h15.9c0.13,0,0.24,0.08,0.24,0.17v4.7c0,0.1-0.11,0.18-0.24,0.18H9.71c-0.13,0-0.24-0.08-0.24-0.18v-4.7 C9.47,68.62,9.58,68.54,9.71,68.54L9.71,68.54z M42.46,8.47H80.2c0.63,0,1.15,0.52,1.15,1.15v12.31c0,0.63-0.52,1.15-1.15,1.15 H42.46c-0.63,0-1.15-0.52-1.15-1.15V9.62C41.3,8.99,41.82,8.47,42.46,8.47L42.46,8.47z M97.4,105.02c-1.05-2.11-2.38-3.9-3.94-5.58 c2.92,1.13,5.91,2.25,8.12,3.64c4.02,2.52,4.32,5.57,4.65,9.95H86.3c0-0.03,0-0.07,0-0.1l-0.37-3.13l1.43,1.24l7-6.09L97.4,105.02 L97.4,105.02L97.4,105.02z M26.08,100.08l2.53,7.44l1.27-4.42l-0.62-0.68c-0.28-0.41-0.34-0.77-0.19-1.08 c0.34-0.67,1.04-0.54,1.69-0.54c0.68,0,1.53-0.13,1.74,0.73c0.07,0.29-0.02,0.59-0.22,0.9l-0.62,0.68l1.27,4.42l2.29-7.44 c0.33,0.3,0.8,0.55,1.34,0.77c-0.19,0.4-0.36,0.81-0.51,1.25c-0.39,1.13-0.64,2.38-0.75,3.77l0.01,0c0,0.03,0,0.07-0.01,0.1 l-0.55,7.06H16.44c-1.1-0.08-1.66-0.65-1.75-1.63l0.38-3.9c0.11-1.39,0.5-2.48,1.13-3.32c0.42-0.55,0.94-0.96,1.51-1.28 C19.53,101.86,24.43,101.57,26.08,100.08L26.08,100.08L26.08,100.08z M24.84,89.53c-0.25,0.02-0.43,0.08-0.57,0.16 c-0.08,0.05-0.13,0.12-0.17,0.2c-0.04,0.09-0.06,0.21-0.06,0.34c0.01,0.41,0.23,0.96,0.66,1.59l0.01,0.01l1.41,2.25 c0.56,0.9,1.16,1.81,1.88,2.48c0.69,0.63,1.54,1.06,2.65,1.07c1.21,0,2.09-0.44,2.81-1.11c0.75-0.7,1.35-1.68,1.94-2.65l1.59-2.62 c0.32-0.73,0.42-1.17,0.32-1.38c-0.06-0.13-0.33-0.16-0.76-0.13c-0.28,0.06-0.56,0.01-0.87-0.15l0.79-2.38 c-2.91-0.04-4.91-0.54-7.26-2.05c-0.77-0.49-1.01-1.06-1.78-1.01c-0.59,0.11-1.08,0.38-1.47,0.8c-0.38,0.4-0.66,0.95-0.84,1.66 l0.47,2.86C25.34,89.62,25.09,89.63,24.84,89.53L24.84,89.53L24.84,89.53z M37.45,88.82c0.34,0.1,0.59,0.3,0.75,0.6 c0.24,0.49,0.15,1.21-0.3,2.23l0,0c-0.01,0.02-0.02,0.04-0.03,0.06l-1.61,2.65c-0.62,1.03-1.26,2.06-2.11,2.86 c-0.89,0.83-1.98,1.38-3.48,1.38c-1.4,0-2.45-0.54-3.31-1.33c-0.83-0.76-1.46-1.73-2.05-2.68l-1.41-2.25 c-0.53-0.79-0.8-1.51-0.82-2.1c-0.01-0.29,0.04-0.55,0.15-0.78c0.11-0.24,0.29-0.45,0.52-0.6c0.11-0.08,0.24-0.14,0.39-0.19 c-0.09-1.2-0.12-2.69-0.06-3.95c0.03-0.31,0.09-0.61,0.17-0.92c0.36-1.29,1.27-2.33,2.39-3.04c0.4-0.25,0.83-0.46,1.29-0.63 c2.72-0.98,6.32-0.45,8.25,1.64c0.79,0.85,1.28,1.98,1.38,3.47L37.45,88.82L37.45,88.82L37.45,88.82z M51.68,78.86 c-0.32,0.04-0.56,0.12-0.74,0.23c-0.12,0.08-0.2,0.18-0.25,0.29c-0.06,0.14-0.09,0.31-0.09,0.5c0.02,0.61,0.35,1.43,0.98,2.37 l0.01,0.02l0,0l2.11,3.36c0.84,1.34,1.72,2.7,2.81,3.7c1.04,0.95,2.29,1.59,3.95,1.59c1.8,0,3.12-0.66,4.18-1.66 c1.12-1.05,2.02-2.5,2.89-3.95l2.37-3.9c0.48-1.09,0.62-1.75,0.47-2.05c-0.1-0.2-0.51-0.25-1.21-0.18c-0.05,0-0.11,0-0.16,0 c-0.29,0-0.6-0.07-0.95-0.23l1.07-3.56c-4.35-0.05-7.32-0.81-10.84-3.06c-1.16-0.74-1.5-1.58-2.66-1.5 c-0.87,0.17-1.61,0.56-2.19,1.19c-0.56,0.6-0.98,1.42-1.26,2.48l0.75,4.31C52.49,79.01,52.07,79.03,51.68,78.86L51.68,78.86 L51.68,78.86z M53.64,94.59l3.78,11.11l1.9-6.59l-0.93-1.02c-0.42-0.61-0.51-1.15-0.28-1.61c0.5-1,1.55-0.81,2.52-0.81 c1.02,0,2.28-0.19,2.6,1.08c0.11,0.43-0.03,0.87-0.33,1.34l-0.93,1.02l1.9,6.59l3.42-11.11c2.47,2.22,8.82,2.67,11.54,4.18 c0.74,0.41,1.41,0.92,1.98,1.57c0.01-0.07,0.03-0.15,0.07-0.21c0.3-0.59,0.92-0.48,1.5-0.48c0.61,0,1.36-0.11,1.55,0.65 c0.06,0.25-0.02,0.52-0.19,0.8l-0.55,0.61l1.13,3.92l-1.45,1.15l0.48,6.29c-0.14,1.47-0.97,2.31-2.61,2.44H40.2 c-1.64-0.13-2.47-0.97-2.61-2.44l0.57-7.41c0.16-2.07,0.74-3.71,1.69-4.96c0.62-0.82,1.4-1.43,2.26-1.91 C44.82,97.26,51.17,96.81,53.64,94.59L53.64,94.59L53.64,94.59z M70.6,77.79c0.51,0.15,0.89,0.44,1.12,0.9 c0.36,0.73,0.22,1.8-0.45,3.33l0,0c-0.01,0.03-0.03,0.06-0.04,0.09l-2.41,3.96c-0.93,1.54-1.88,3.07-3.15,4.26 c-1.33,1.24-2.96,2.07-5.19,2.06c-2.09,0-3.66-0.8-4.95-1.98c-1.24-1.13-2.17-2.58-3.07-4l-2.11-3.36 c-0.79-1.17-1.19-2.25-1.22-3.14c-0.01-0.43,0.06-0.82,0.22-1.16c0.17-0.36,0.43-0.67,0.78-0.9c0.17-0.12,0.37-0.21,0.58-0.29 c-0.13-1.8-0.17-4.02-0.09-5.89c0.05-0.46,0.13-0.91,0.26-1.37c0.54-1.93,1.89-3.48,3.57-4.54c0.59-0.38,1.24-0.69,1.92-0.93 c4.05-1.47,9.43-0.67,12.31,2.45c1.17,1.27,1.91,2.95,2.07,5.17L70.6,77.79L70.6,77.79L70.6,77.79z M77.93,96.13l1.86-0.05 l1.55-0.04c-1.8-5.55-1.2-10.65,3.14-14.99c0.74,2.38,2.39,4.35,5.2,5.8c1.34,1,2.64,2.2,3.9,3.59c0.22-0.92-0.63-2.03-1.66-3.18 c0.95,0.47,1.83,1.13,2.45,2.4c0.72,1.47,0.71,2.71,0.47,4.31c-0.11,0.74-0.29,1.44-0.55,2.07h2.57c2.71-5.8,0.99-14.41-4.55-18.06 c-1.7-1.12-2.92-1.08-4.92-1.08c-2.28,0-3.45,0.07-5.41,1.37c-2.88,1.91-4.66,5.21-5.4,9.79C76.43,90.35,76.33,94.3,77.93,96.13 L77.93,96.13L77.93,96.13z M97.15,58.27h15.9c0.13,0,0.24,0.08,0.24,0.18v4.7c0,0.1-0.11,0.18-0.24,0.18h-15.9 c-0.13,0-0.24-0.08-0.24-0.18v-4.7C96.91,58.35,97.02,58.27,97.15,58.27L97.15,58.27z M97.15,47.99h15.9 c0.13,0,0.24,0.08,0.24,0.18v4.7c0,0.1-0.11,0.18-0.24,0.18h-15.9c-0.13,0-0.24-0.08-0.24-0.18v-4.7 C96.91,48.07,97.02,47.99,97.15,47.99L97.15,47.99z M9.71,58.27h15.9c0.13,0,0.24,0.08,0.24,0.18v4.7c0,0.1-0.11,0.18-0.24,0.18 H9.71c-0.13,0-0.24-0.08-0.24-0.18v-4.7C9.47,58.35,9.58,58.27,9.71,58.27L9.71,58.27z M9.71,47.99h15.9 c0.13,0,0.24,0.08,0.24,0.18v4.7c0,0.1-0.11,0.18-0.24,0.18H9.71c-0.13,0-0.24-0.08-0.24-0.18v-4.7 C9.47,48.07,9.58,47.99,9.71,47.99L9.71,47.99z M71.67,49.08h8.49c0.13,0,0.24,0.11,0.24,0.24v8.49c0,0.13-0.11,0.24-0.24,0.24 h-8.49c-0.13,0-0.24-0.11-0.24-0.24v-8.49C71.43,49.19,71.54,49.08,71.67,49.08L71.67,49.08z M57.08,49.08h8.49 c0.13,0,0.24,0.11,0.24,0.24v8.49c0,0.13-0.11,0.24-0.24,0.24h-8.49c-0.13,0-0.24-0.11-0.24-0.24v-8.49 C56.84,49.19,56.95,49.08,57.08,49.08L57.08,49.08z M42.49,49.08h8.49c0.13,0,0.24,0.11,0.24,0.24v8.49c0,0.13-0.11,0.24-0.24,0.24 h-8.49c-0.13,0-0.24-0.11-0.24-0.24v-8.49C42.25,49.19,42.36,49.08,42.49,49.08L42.49,49.08z M71.67,32.61h8.49 c0.13,0,0.24,0.11,0.24,0.24v8.49c0,0.13-0.11,0.24-0.24,0.24h-8.49c-0.13,0-0.24-0.11-0.24-0.24v-8.49 C71.43,32.71,71.54,32.61,71.67,32.61L71.67,32.61z M57.08,32.61h8.49c0.13,0,0.24,0.11,0.24,0.24v8.49c0,0.13-0.11,0.24-0.24,0.24 h-8.49c-0.13,0-0.24-0.11-0.24-0.24v-8.49C56.84,32.71,56.95,32.61,57.08,32.61L57.08,32.61z M42.49,32.61h8.49 c0.13,0,0.24,0.11,0.24,0.24v8.49c0,0.13-0.11,0.24-0.24,0.24h-8.49c-0.13,0-0.24-0.11-0.24-0.24v-8.49 C42.25,32.71,42.36,32.61,42.49,32.61L42.49,32.61z"}})])])};
var __vue_staticRenderFns__$l = [];

  /* style */
  const __vue_inject_styles__$l = function (inject) {
    if (!inject) return
    inject("data-v-32fcde4e_0", { source: ".icon-company[data-v-32fcde4e]{fill:var(--color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$l = "data-v-32fcde4e";
  /* module identifier */
  const __vue_module_identifier__$l = undefined;
  /* functional template */
  const __vue_is_functional_template__$l = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$l = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$l, staticRenderFns: __vue_staticRenderFns__$l },
    __vue_inject_styles__$l,
    __vue_script__$l,
    __vue_scope_id__$l,
    __vue_is_functional_template__$l,
    __vue_module_identifier__$l,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$k = Vue.extend({
  name: "DefaIconPdf"
});

/* script */
const __vue_script__$k = script$k;

/* template */
var __vue_render__$k = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon-pdf",attrs:{"viewBox":"0 0 115.28 122.88"}},[_c('title',[_vm._v(_vm._s(_vm.$t("defaIconPdf.title")))]),_vm._v(" "),_c('path',{attrs:{"d":"m25.38 57h64.88v-19.66h-20.67c-2.17 0-5.19-1.17-6.62-2.6s-2.3-4.01-2.3-6.17v-20.93h-52.52c-0.18 0-0.32 0.09-0.41 0.18-0.15 0.1-0.19 0.23-0.19 0.42v106.45c0 0.14 0.09 0.32 0.18 0.41 0.09 0.14 0.28 0.18 0.41 0.18h81.51c0.18 0 0.17-0.09 0.27-0.18 0.14-0.09 0.33-0.28 0.33-0.41v-11.16h-64.87c-4.14 0-7.56-3.4-7.56-7.56v-31.42c0-4.15 3.4-7.55 7.56-7.55zm72.41 0h9.93c4.16 0 7.56 3.41 7.56 7.56v31.42c0 4.15-3.41 7.56-7.56 7.56h-9.93v13.55c0 1.61-0.65 3.04-1.7 4.1-1.06 1.06-2.49 1.7-4.1 1.7h-86.18c-1.61 0-3.04-0.64-4.1-1.7s-1.7-2.49-1.7-4.1v-111.24c0-1.61 0.65-3.04 1.7-4.1 1.06-1.06 2.53-1.7 4.1-1.7h58.72c0.13-0.05 0.27-0.05 0.41-0.05 0.64 0 1.29 0.28 1.75 0.69h0.09c0.09 0.05 0.14 0.09 0.23 0.18l29.99 30.36c0.51 0.51 0.88 1.2 0.88 1.98 0 0.23-0.05 0.41-0.09 0.65v23.14zm-30.27-29.03v-19.03l21.43 21.7h-18.76c-0.74 0-1.38-0.32-1.89-0.78-0.46-0.46-0.78-1.15-0.78-1.89z"}}),_vm._v(" "),_c('text',{staticStyle:{"line-height":"1.25"},attrs:{"x":"26.576527","y":"94.053299","font-size":"40px","fill":"#fff"}},[_c('tspan',{attrs:{"x":"26.576527","y":"94.053299"}},[_vm._v("PDF")])])])};
var __vue_staticRenderFns__$k = [];

  /* style */
  const __vue_inject_styles__$k = function (inject) {
    if (!inject) return
    inject("data-v-20052d85_0", { source: ".icon-pdf[data-v-20052d85]{fill:var(--defa-oreon-color-primary);stroke:none}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$k = "data-v-20052d85";
  /* module identifier */
  const __vue_module_identifier__$k = undefined;
  /* functional template */
  const __vue_is_functional_template__$k = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$k = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$k, staticRenderFns: __vue_staticRenderFns__$k },
    __vue_inject_styles__$k,
    __vue_script__$k,
    __vue_scope_id__$k,
    __vue_is_functional_template__$k,
    __vue_module_identifier__$k,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$j = Vue.extend({
  name: "DefaIconExternal"
});

/* script */
const __vue_script__$j = script$j;

/* template */
var __vue_render__$j = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon-external",attrs:{"viewBox":"0 0 122.6 122.88"}},[_c('title',[_vm._v(_vm._s(_vm.$t("defaIconExternal.title")))]),_vm._v(" "),_c('path',{attrs:{"d":"M110.6,72.58c0-3.19,2.59-5.78,5.78-5.78c3.19,0,5.78,2.59,5.78,5.78v33.19c0,4.71-1.92,8.99-5.02,12.09 c-3.1,3.1-7.38,5.02-12.09,5.02H17.11c-4.71,0-8.99-1.92-12.09-5.02c-3.1-3.1-5.02-7.38-5.02-12.09V17.19 C0,12.48,1.92,8.2,5.02,5.1C8.12,2,12.4,0.08,17.11,0.08h32.98c3.19,0,5.78,2.59,5.78,5.78c0,3.19-2.59,5.78-5.78,5.78H17.11 c-1.52,0-2.9,0.63-3.91,1.63c-1.01,1.01-1.63,2.39-1.63,3.91v88.58c0,1.52,0.63,2.9,1.63,3.91c1.01,1.01,2.39,1.63,3.91,1.63h87.95 c1.52,0,2.9-0.63,3.91-1.63s1.63-2.39,1.63-3.91V72.58L110.6,72.58z M112.42,17.46L54.01,76.6c-2.23,2.27-5.89,2.3-8.16,0.07 c-2.27-2.23-2.3-5.89-0.07-8.16l56.16-56.87H78.56c-3.19,0-5.78-2.59-5.78-5.78c0-3.19,2.59-5.78,5.78-5.78h26.5 c5.12,0,11.72-0.87,15.65,3.1c2.48,2.51,1.93,22.52,1.61,34.11c-0.08,3-0.15,5.29-0.15,6.93c0,3.19-2.59,5.78-5.78,5.78 c-3.19,0-5.78-2.59-5.78-5.78c0-0.31,0.08-3.32,0.19-7.24C110.96,30.94,111.93,22.94,112.42,17.46L112.42,17.46z"}})])};
var __vue_staticRenderFns__$j = [];

  /* style */
  const __vue_inject_styles__$j = function (inject) {
    if (!inject) return
    inject("data-v-a0ce6da2_0", { source: ".icon-external[data-v-a0ce6da2]{fill:var(--defa-oreon-color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$j = "data-v-a0ce6da2";
  /* module identifier */
  const __vue_module_identifier__$j = undefined;
  /* functional template */
  const __vue_is_functional_template__$j = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$j = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$j, staticRenderFns: __vue_staticRenderFns__$j },
    __vue_inject_styles__$j,
    __vue_script__$j,
    __vue_scope_id__$j,
    __vue_is_functional_template__$j,
    __vue_module_identifier__$j,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$i = Vue.extend({
  name: "DefaIconEthernet",
  mixins: [CssPropsMixin],
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  computed: {
    getTitle: function getTitle() {
      return this.title || this.$t("defaIconEthernet.title");
    }
  }
});

/* script */
const __vue_script__$i = script$i;

/* template */
var __vue_render__$i = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon-ethernet",style:(_vm.cssProps),attrs:{"viewBox":"0 0 122.88 122.15","width":"32"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M18.23,17.84h13.12v19.82c0,2.05,1.66,3.71,3.71,3.71c2.05,0,3.71-1.66,3.71-3.71V17.84h10.17v19.82 c0,2.05,1.66,3.71,3.71,3.71c2.05,0,3.71-1.66,3.71-3.71V17.84h10.17v19.82c0,2.05,1.66,3.71,3.71,3.71c2.05,0,3.71-1.66,3.71-3.71 V17.84h10.17v19.82c0,2.05,1.66,3.71,3.71,3.71c2.05,0,3.71-1.66,3.71-3.71V17.84h13.12c0.63,0,1.15,0.52,1.15,1.15v57.48 c0,0.63-0.52,1.15-1.15,1.15H78.46v13.28c0,0.33-0.27,0.61-0.61,0.61H46.1c-0.33,0-0.61-0.27-0.61-0.61V77.61H18.23 c-0.63,0-1.15-0.52-1.15-1.15V18.98C17.09,18.35,17.6,17.84,18.23,17.84L18.23,17.84z M13.48,0h95.92c3.71,0,7.08,1.52,9.52,3.96 c2.44,2.44,3.96,5.81,3.96,9.52v95.19c0,3.71-1.52,7.08-3.96,9.52c-2.44,2.44-5.81,3.96-9.52,3.96H13.48 c-3.71,0-7.08-1.52-9.52-3.96C1.52,115.75,0,112.38,0,108.67V13.48C0,9.77,1.52,6.4,3.96,3.96C6.4,1.52,9.77,0,13.48,0L13.48,0z M109.4,6.54H13.48c-1.9,0-3.64,0.78-4.9,2.04c-1.26,1.26-2.04,2.99-2.04,4.9v95.19c0,1.9,0.78,3.64,2.04,4.9 c1.26,1.26,2.99,2.04,4.9,2.04h95.92c1.9,0,3.64-0.78,4.9-2.04c1.26-1.26,2.04-2.99,2.04-4.9V13.48c0-1.9-0.78-3.64-2.04-4.9 C113.04,7.32,111.31,6.54,109.4,6.54L109.4,6.54z"}})])};
var __vue_staticRenderFns__$i = [];

  /* style */
  const __vue_inject_styles__$i = function (inject) {
    if (!inject) return
    inject("data-v-f4313e56_0", { source: ".icon-ethernet[data-v-f4313e56]{stroke:var(--color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$i = "data-v-f4313e56";
  /* module identifier */
  const __vue_module_identifier__$i = undefined;
  /* functional template */
  const __vue_is_functional_template__$i = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$i = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$i, staticRenderFns: __vue_staticRenderFns__$i },
    __vue_inject_styles__$i,
    __vue_script__$i,
    __vue_scope_id__$i,
    __vue_is_functional_template__$i,
    __vue_module_identifier__$i,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$h = Vue.extend({
  name: "DefaIconWifi",
  mixins: [CssPropsMixin],
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  computed: {
    getTitle: function getTitle() {
      return this.title || this.$t("defaIconWifi.title");
    }
  }
});

/* script */
const __vue_script__$h = script$h;

/* template */
var __vue_render__$h = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon-wifi",style:(_vm.cssProps),attrs:{"viewBox":"0 0 122.88 94.72","width":"32"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M8.46,31.23c-1.08,0.92-2.42,1.32-3.72,1.22c-1.31-0.1-2.58-0.7-3.5-1.78l-0.02-0.03c-0.91-1.07-1.3-2.41-1.2-3.7 c0.1-1.31,0.7-2.58,1.78-3.5l0.01-0.01c9.06-7.77,18.73-13.65,28.73-17.58c10.08-3.96,20.5-5.93,31-5.84 c10.35,0.09,20.74,2.19,30.9,6.36c9.81,4.03,19.4,10,28.55,17.97c0.11,0.08,0.21,0.17,0.29,0.26c0.96,0.92,1.5,2.13,1.58,3.37 c0.08,1.24-0.29,2.51-1.12,3.55c-0.08,0.12-0.18,0.23-0.29,0.33c-0.92,0.96-2.13,1.5-3.37,1.58c-1.3,0.09-2.65-0.33-3.71-1.26 c-8.27-7.23-16.9-12.62-25.68-16.25c-8.99-3.72-18.14-5.58-27.23-5.66c-9.2-0.08-18.38,1.68-27.31,5.2 C25.25,18.97,16.6,24.25,8.46,31.23L8.46,31.23z M61.44,72.27c3.1,0,5.9,1.26,7.93,3.29c2.03,2.03,3.29,4.84,3.29,7.93 c0,3.1-1.26,5.9-3.29,7.93c-2.03,2.03-4.84,3.29-7.93,3.29c-3.1,0-5.9-1.26-7.94-3.29c-2.03-2.03-3.29-4.84-3.29-7.93 c0-3.09,1.26-5.9,3.29-7.93l0,0C55.54,73.53,58.34,72.27,61.44,72.27L61.44,72.27z M42.07,66.17c-1.1,0.89-2.46,1.26-3.76,1.12 c-1.24-0.13-2.44-0.71-3.32-1.71c-0.1-0.1-0.19-0.21-0.26-0.32c-0.8-1.07-1.12-2.35-0.99-3.59c0.13-1.24,0.71-2.44,1.71-3.32 c0.09-0.09,0.19-0.17,0.29-0.24c4-3.23,8.18-5.7,12.47-7.37c4.35-1.7,8.82-2.57,13.33-2.58c4.45-0.01,8.89,0.81,13.27,2.5 c4.25,1.64,8.44,4.11,12.48,7.41c1.1,0.89,1.73,2.15,1.87,3.45c0.13,1.3-0.23,2.66-1.12,3.76l-0.01,0.01 c-0.89,1.09-2.14,1.72-3.45,1.86c-1.3,0.13-2.66-0.23-3.76-1.12l0,0c-3.14-2.57-6.35-4.47-9.56-5.73c-3.25-1.28-6.5-1.9-9.72-1.89 c-3.25,0.01-6.52,0.67-9.77,1.96C48.46,61.67,45.21,63.62,42.07,66.17L42.07,66.17z M25.81,49.65c-0.08,0.08-0.17,0.16-0.26,0.22 c-1.03,0.84-2.3,1.21-3.53,1.14c-1.27-0.08-2.51-0.63-3.44-1.63c-0.09-0.08-0.16-0.17-0.23-0.26c-0.84-1.03-1.21-2.3-1.14-3.53 c0.08-1.31,0.66-2.59,1.72-3.53c6.81-6.03,13.85-10.59,21.01-13.61c7.18-3.02,14.49-4.51,21.85-4.38c7.27,0.12,14.53,1.8,21.69,5.1 c6.97,3.21,13.86,7.96,20.59,14.3l0.13,0.12c0.95,0.95,1.44,2.2,1.48,3.46c0.04,1.31-0.42,2.63-1.39,3.66l-0.12,0.13 c-0.96,0.95-2.2,1.45-3.46,1.49c-1.31,0.04-2.63-0.42-3.66-1.39c-5.83-5.5-11.73-9.59-17.62-12.35c-5.95-2.78-11.9-4.19-17.8-4.29 c-5.99-0.1-12,1.15-17.96,3.69C37.64,40.58,31.66,44.48,25.81,49.65L25.81,49.65z"}})])};
var __vue_staticRenderFns__$h = [];

  /* style */
  const __vue_inject_styles__$h = function (inject) {
    if (!inject) return
    inject("data-v-729f3a9e_0", { source: ".icon-wifi[data-v-729f3a9e]{stroke:var(--color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$h = "data-v-729f3a9e";
  /* module identifier */
  const __vue_module_identifier__$h = undefined;
  /* functional template */
  const __vue_is_functional_template__$h = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$h = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$h, staticRenderFns: __vue_staticRenderFns__$h },
    __vue_inject_styles__$h,
    __vue_script__$h,
    __vue_scope_id__$h,
    __vue_is_functional_template__$h,
    __vue_module_identifier__$h,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$g = Vue.extend({
  name: "DefaIconEthernet",
  mixins: [CssPropsMixin],
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  computed: {
    getTitle: function getTitle() {
      return this.title || this.$t("defaIconMobile.title");
    }
  }
});

/* script */
const __vue_script__$g = script$g;

/* template */
var __vue_render__$g = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon-mobile",style:(_vm.cssProps),attrs:{"viewBox":"0 0 122.88 88.78","width":"32"}},[_c('title',[_vm._v(_vm._s(_vm.getTitle))]),_vm._v(" "),_c('path',{attrs:{"xmlns":"http://www.w3.org/2000/svg","d":"M21.09,84.44c0.94,1.12,0.83,2.77-0.29,3.71c-1.12,0.94-2.77,0.83-3.71-0.29C5.72,74.58-0.14,59.54,0,44.32 C0.15,29.46,5.94,14.52,17.85,0.89c0.94-1.08,2.59-1.19,3.71-0.25c1.08,0.94,1.19,2.59,0.25,3.71 C10.76,16.97,5.36,30.75,5.26,44.35C5.15,58.31,10.55,72.13,21.09,84.44L21.09,84.44z M34.83,71.66c0.97,1.08,0.86,2.73-0.22,3.71 c-1.08,0.97-2.73,0.86-3.71-0.22c-8.74-9.89-13.24-20.37-13.06-30.98c0.18-10.33,4.75-20.69,14.07-30.58 c1.01-1.04,2.66-1.12,3.71-0.11s1.12,2.66,0.11,3.71c-8.38,8.92-12.52,18.06-12.67,27.06c-0.14,9.28,3.89,18.57,11.73,27.45 L34.83,71.66L34.83,71.66z M46.99,59.5c0.9,1.12,0.76,2.77-0.4,3.67c-1.12,0.9-2.77,0.76-3.67-0.4c-4.71-5.79-7.16-12.09-7.2-18.49 c-0.04-6.22,2.3-12.49,7.09-18.35c0.9-1.12,2.55-1.3,3.67-0.4c1.12,0.9,1.3,2.55,0.4,3.67c-3.99,4.89-5.94,10.04-5.94,15.04 c0,5.15,2.09,10.33,6.01,15.18L46.99,59.5L46.99,59.5z M105.79,87.85c-0.94,1.12-2.59,1.22-3.71,0.29 c-1.12-0.94-1.22-2.59-0.29-3.71c10.54-12.31,15.98-26.16,15.83-40.08c-0.11-13.6-5.51-27.38-16.55-40.01 c-0.94-1.08-0.83-2.73,0.25-3.71c1.08-0.94,2.73-0.83,3.71,0.25c11.91,13.64,17.7,28.57,17.85,43.43 C123.02,59.54,117.16,74.58,105.79,87.85L105.79,87.85z M92.01,75.12c-0.97,1.08-2.63,1.19-3.71,0.22 c-1.08-0.97-1.19-2.63-0.22-3.71c7.88-8.89,11.87-18.17,11.73-27.45C99.67,35.14,95.53,26,87.15,17.12 c-1.01-1.04-0.94-2.7,0.11-3.71c1.04-1.01,2.7-0.94,3.71,0.11c9.32,9.89,13.89,20.22,14.07,30.58 c0.18,10.61-4.28,21.08-13.06,30.98L92.01,75.12L92.01,75.12z M79.99,62.78c-0.9,1.12-2.55,1.3-3.67,0.4 c-1.12-0.9-1.3-2.55-0.4-3.67c3.96-4.86,6.01-10.04,6.01-15.18c0-5.04-1.91-10.15-5.94-15.04c-0.9-1.12-0.76-2.77,0.4-3.67 c1.12-0.9,2.77-0.76,3.67,0.4c4.79,5.87,7.12,12.13,7.09,18.35c-0.04,6.4-2.48,12.67-7.2,18.49L79.99,62.78L79.99,62.78z M61.39,54.07c-0.85,0-1.71-0.07-2.56-0.22c-1.34-0.38-2.59-1.02-3.65-1.89c-0.24-0.2-0.48-0.41-0.7-0.63 c-1.8-1.8-2.88-4.25-2.88-6.98c0-2.73,1.12-5.18,2.88-6.98c1.8-1.8,4.25-2.88,6.98-2.88c2.73,0,5.18,1.12,6.98,2.88 c1.8,1.8,2.88,4.25,2.88,6.98c0,1.51-0.34,2.94-0.95,4.22C68.64,52.22,65.42,54.08,61.39,54.07L61.39,54.07z"}})])};
var __vue_staticRenderFns__$g = [];

  /* style */
  const __vue_inject_styles__$g = function (inject) {
    if (!inject) return
    inject("data-v-1a228dd7_0", { source: ".icon-mobile[data-v-1a228dd7]{stroke:var(--color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$g = "data-v-1a228dd7";
  /* module identifier */
  const __vue_module_identifier__$g = undefined;
  /* functional template */
  const __vue_is_functional_template__$g = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$g = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$g, staticRenderFns: __vue_staticRenderFns__$g },
    __vue_inject_styles__$g,
    __vue_script__$g,
    __vue_scope_id__$g,
    __vue_is_functional_template__$g,
    __vue_module_identifier__$g,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$e(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$e(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$e() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaBaseLinkExternal = /*#__PURE__*/function (_Vue) {
  _inherits(DefaBaseLinkExternal, _Vue);

  var _super = _createSuper$e(DefaBaseLinkExternal);

  function DefaBaseLinkExternal() {
    _classCallCheck(this, DefaBaseLinkExternal);

    return _super.apply(this, arguments);
  }

  return DefaBaseLinkExternal;
}(Vue$1);

__decorate([Prop({
  required: true,
  type: String
}), __metadata("design:type", String)], DefaBaseLinkExternal.prototype, "href", void 0);

DefaBaseLinkExternal = __decorate([Component({
  components: {
    DefaIconExternal: __vue_component__$j
  },
  name: "DefaBaseLinkExternal"
})], DefaBaseLinkExternal);
var script$f = DefaBaseLinkExternal;

/* script */
const __vue_script__$f = script$f;

/* template */
var __vue_render__$f = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"base-link-external",attrs:{"href":_vm.href,"rel":"noopener","target":"_blank"}},[_vm._t("default"),_vm._v(" "),_c('DefaIconExternal',{staticClass:"base-link-external__icon"})],2)};
var __vue_staticRenderFns__$f = [];

  /* style */
  const __vue_inject_styles__$f = function (inject) {
    if (!inject) return
    inject("data-v-3d84dc3d_0", { source: ".base-link-external[data-v-3d84dc3d]{display:inline-flex;gap:.5em;align-items:center;color:var(--defa-oreon-color-primary);-webkit-text-decoration-line:none;text-decoration-line:none}.base-link-external[data-v-3d84dc3d]:hover{-webkit-text-decoration-line:underline;text-decoration-line:underline}.base-link-external__icon[data-v-3d84dc3d]{width:1em}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$f = "data-v-3d84dc3d";
  /* module identifier */
  const __vue_module_identifier__$f = undefined;
  /* functional template */
  const __vue_is_functional_template__$f = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$f = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$f, staticRenderFns: __vue_staticRenderFns__$f },
    __vue_inject_styles__$f,
    __vue_script__$f,
    __vue_scope_id__$f,
    __vue_is_functional_template__$f,
    __vue_module_identifier__$f,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$d(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$d(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$d() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaBaseRadio = /*#__PURE__*/function (_Vue) {
  _inherits(DefaBaseRadio, _Vue);

  var _super = _createSuper$d(DefaBaseRadio);

  function DefaBaseRadio() {
    _classCallCheck(this, DefaBaseRadio);

    return _super.apply(this, arguments);
  }

  _createClass(DefaBaseRadio, [{
    key: "onClick",
    // Workaround for browser bug: https://github.com/vuejs/vue/issues/5650#issuecomment-300701271
    value: function onClick() {
      var _this = this;

      _setTimeout(function () {
        return _this.$emit("change", _this.option.value);
      }, 0);
    }
  }, {
    key: "isChecked",
    get: function get() {
      return this.modelValue === this.option.value;
    }
  }]);

  return DefaBaseRadio;
}(Vue$1);

__decorate([Prop({
  required: true,
  type: Object
}), __metadata("design:type", Object)], DefaBaseRadio.prototype, "option", void 0);

__decorate([Prop({
  required: true,
  type: String
}), __metadata("design:type", String)], DefaBaseRadio.prototype, "name", void 0);

__decorate([Prop({
  default: null,
  type: [String, Number, Boolean]
}), __metadata("design:type", Object)], DefaBaseRadio.prototype, "modelValue", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseRadio.prototype, "disabled", void 0);

DefaBaseRadio = __decorate([Component({
  inheritAttrs: false,
  model: {
    prop: "modelValue",
    event: "change"
  },
  name: "DefaBaseRadio"
})], DefaBaseRadio);
var script$e = DefaBaseRadio;

/* script */
const __vue_script__$e = script$e;

/* template */
var __vue_render__$e = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"defa-base-radio",class:{ 'defa-base-radio--disabled': _vm.disabled }},[_c('input',_vm._b({staticClass:"defa-base-radio__input",attrs:{"disabled":_vm.disabled,"name":_vm.name,"type":"radio"},domProps:{"checked":_vm.isChecked,"value":_vm.option.value},on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},'input',_vm.$attrs,false)),_vm._v(" "),_vm._t("default",function(){return [_c('span',{staticClass:"defa-base-radio__label"},[_vm._v("\n      "+_vm._s(_vm.option.label)+"\n    ")])]})],2)};
var __vue_staticRenderFns__$e = [];

  /* style */
  const __vue_inject_styles__$e = function (inject) {
    if (!inject) return
    inject("data-v-237b218d_0", { source: ".defa-base-radio[data-v-237b218d]{display:flex;align-items:center;gap:1em;cursor:pointer}.defa-base-radio--disabled[data-v-237b218d]{cursor:not-allowed}.defa-base-radio--disabled .defa-base-radio__label[data-v-237b218d]{color:var(--defa-oreon-color-gray-shade-3)}.defa-base-radio__input[data-v-237b218d]{flex-shrink:0;-moz-appearance:none;appearance:none;-webkit-appearance:none;border-radius:50%;width:2em;height:2em;border:4px solid var(--defa-oreon-color-primary);transition:background-color .3s ease-in-out;cursor:inherit}.defa-base-radio__input[data-v-237b218d]:checked{background-color:var(--defa-oreon-color-primary)}.defa-base-radio__input[data-v-237b218d]:disabled{border-color:var(--defa-oreon-color-gray-shade-3)}.defa-base-radio__input[data-v-237b218d]:disabled:checked{background-color:var(--defa-oreon-color-gray-shade-3)}.defa-base-radio__label[data-v-237b218d]{-webkit-hyphens:auto;-ms-hyphens:auto;hyphens:auto}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$e = "data-v-237b218d";
  /* module identifier */
  const __vue_module_identifier__$e = undefined;
  /* functional template */
  const __vue_is_functional_template__$e = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$e = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$e, staticRenderFns: __vue_staticRenderFns__$e },
    __vue_inject_styles__$e,
    __vue_script__$e,
    __vue_scope_id__$e,
    __vue_is_functional_template__$e,
    __vue_module_identifier__$e,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$c(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$c(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$c() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaBaseRadioGroup = /*#__PURE__*/function (_Vue) {
  _inherits(DefaBaseRadioGroup, _Vue);

  var _super = _createSuper$c(DefaBaseRadioGroup);

  function DefaBaseRadioGroup() {
    _classCallCheck(this, DefaBaseRadioGroup);

    return _super.apply(this, arguments);
  }

  _createClass(DefaBaseRadioGroup, [{
    key: "getRules",
    get: function get() {
      return getRules(this.rules, this.disabled);
    }
  }, {
    key: "hasRequiredRule",
    get: function get() {
      return hasRequiredRule(this.rules);
    }
  }, {
    key: "hasRequiredRuleHasLabelAndIsNotDisabled",
    get: function get() {
      if (this.disabled) {
        return false;
      }

      return this.hasRequiredRule && Boolean(this.label);
    }
  }, {
    key: "value",
    get: function get() {
      return this.modelValue;
    },
    set: function set(newValue) {
      this.$emit("change", newValue);
    }
  }]);

  return DefaBaseRadioGroup;
}(Vue$1);

__decorate([Prop({
  required: true,
  type: Array
}), __metadata("design:type", Array)], DefaBaseRadioGroup.prototype, "options", void 0);

__decorate([Prop({
  required: true,
  type: String
}), __metadata("design:type", String)], DefaBaseRadioGroup.prototype, "name", void 0);

__decorate([Prop({
  default: null,
  type: [String, Number, Boolean]
}), __metadata("design:type", Object)], DefaBaseRadioGroup.prototype, "modelValue", void 0);

__decorate([Prop({
  default: null,
  type: String
}), __metadata("design:type", Object)], DefaBaseRadioGroup.prototype, "label", void 0);

__decorate([Prop({
  default: null,
  type: [Object, String]
}), __metadata("design:type", Object)], DefaBaseRadioGroup.prototype, "rules", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseRadioGroup.prototype, "disabled", void 0);

__decorate([Prop({
  default: null,
  type: Object
}), __metadata("design:type", Object)], DefaBaseRadioGroup.prototype, "optionsStyle", void 0);

__decorate([Prop({
  default: null,
  type: Object
}), __metadata("design:type", Object)], DefaBaseRadioGroup.prototype, "customMessages", void 0);

__decorate([Prop({
  default: "top",
  type: String
}), __metadata("design:type", String)], DefaBaseRadioGroup.prototype, "errorMessagePosition", void 0);

DefaBaseRadioGroup = __decorate([Component({
  components: {
    DefaBaseInputErrorMessage: __vue_component__$F,
    ValidationProvider: ValidationProvider,
    DefaBaseRadio: __vue_component__$e
  },
  model: {
    prop: "modelValue",
    event: "change"
  },
  inheritAttrs: false,
  name: "DefaBaseRadioGroup"
})], DefaBaseRadioGroup);
var script$d = DefaBaseRadioGroup;

/* script */
const __vue_script__$d = script$d;

/* template */
var __vue_render__$d = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"tag":"div","rules":_vm.getRules,"name":_vm.name,"custom-messages":_vm.customMessages},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var failed = ref.failed;
var ariaInput = ref.ariaInput;
var errors = ref.errors;
var ariaMsg = ref.ariaMsg;
return [_c('div',{staticClass:"base-radio-group",attrs:{"id":_vm.name}},[_c('span',{staticClass:"base-radio-group__label",class:{
        'base-radio-group__label--disabled': _vm.disabled,
        'base-radio-group__label--required': _vm.hasRequiredRuleHasLabelAndIsNotDisabled,
        'base-radio-group__label--has-error': failed,
      }},[_vm._t("label",function(){return [_vm._v(_vm._s(_vm.label))]},null,{ hasRequiredRule: _vm.hasRequiredRule })],2),_vm._v(" "),_c('div',{staticClass:"base-radio-group__options",style:(_vm.optionsStyle)},_vm._l((_vm.options),function(option){return _c('DefaBaseRadio',_vm._b({key:option.value,attrs:{"option":option,"disabled":option.disabled || _vm.disabled,"data-test":(_vm.name + "-" + (option.value)),"name":_vm.name},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v;},expression:"value"}},'DefaBaseRadio',Object.assign({}, ariaInput,
          _vm.$attrs),false),[(_vm.$scopedSlots.option)?_vm._t("option",function(){return [_vm._v("\n          "+_vm._s(option.label)+"\n        ")]},null,option):_vm._e()],2)}),1),_vm._v(" "),_c('DefaBaseInputErrorMessage',_vm._b({directives:[{name:"show",rawName:"v-show",value:(failed),expression:"failed"}],attrs:{"position":_vm.errorMessagePosition}},'DefaBaseInputErrorMessage',ariaMsg,false),[_vm._v("\n      "+_vm._s(errors[0])+"\n    ")])],1)]}}],null,true)})};
var __vue_staticRenderFns__$d = [];

  /* style */
  const __vue_inject_styles__$d = function (inject) {
    if (!inject) return
    inject("data-v-19f82e42_0", { source: ".base-radio-group[data-v-19f82e42]{padding:2em;border:1px solid var(--defa-oreon-color-gray-shade-3);position:relative}.base-radio-group__label[data-v-19f82e42]{padding:0 1em;font-weight:700;display:flex;align-items:center;gap:.5em;position:absolute;bottom:100%;transform:translateY(50%);left:2em;background-color:#fff}.base-radio-group__label--required[data-v-19f82e42]::after{content:\"*\"}.base-radio-group__label--disabled[data-v-19f82e42]{color:var(--defa-oreon-color-gray-shade-3)}.base-radio-group__label.base-radio-group__label--has-error[data-v-19f82e42]{color:var(--defa-oreon-color-error)}.base-radio-group__options[data-v-19f82e42]{display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:1em}.base-radio-group__options:focus-within~.base-input-error-message[data-v-19f82e42],.base-radio-group__options:focus~.base-input-error-message[data-v-19f82e42],.base-radio-group__options:hover~.base-input-error-message[data-v-19f82e42]{opacity:1;z-index:0}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$d = "data-v-19f82e42";
  /* module identifier */
  const __vue_module_identifier__$d = undefined;
  /* functional template */
  const __vue_is_functional_template__$d = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$d = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$d, staticRenderFns: __vue_staticRenderFns__$d },
    __vue_inject_styles__$d,
    __vue_script__$d,
    __vue_scope_id__$d,
    __vue_is_functional_template__$d,
    __vue_module_identifier__$d,
    false,
    createInjector,
    undefined,
    undefined
  );

// Inspired by https://github.com/sagalbot/vue-select/blob/5dfb9e5f73291cafceac54a47e7e74b8958696d1/src/directives/appendToBody.js
// Append an element to another element, with the added flexibility of positioning it relative to another element
var update = function update(el, _ref) {
  var value = _ref.value;

  if (value) {
    var elToAppendTo = value.elToAppendTo;
    var elToPositionRelativeTo = value.elToPositionRelativeTo;

    if (typeof elToAppendTo === "string") {
      var selectedEl = document.querySelector(elToAppendTo);

      if (!selectedEl) {
        throw new Error("No element matching selector ".concat(elToAppendTo, " was found!"));
      }

      elToAppendTo = selectedEl;
    } // Only insert element once, the first time it's activated


    if (el.parentNode !== elToAppendTo) {
      var _getBoundingClientRec = (elToPositionRelativeTo || elToAppendTo).getBoundingClientRect(),
          parentLeft = _getBoundingClientRec.left,
          parentTop = _getBoundingClientRec.top;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          elHeight = _el$getBoundingClient.height;

      var scrollX = window.scrollX || window.pageXOffset;
      var scrollY = window.scrollY || window.pageYOffset;
      el.style.left = "".concat(parentLeft + scrollX, "px");
      el.style.top = "calc(".concat(parentTop + scrollY - elHeight, "px - 1em)");
      el.style.height = "".concat(elHeight, "px");
      elToAppendTo.appendChild(el);
    }
  }
};

var appendTo = {
  update: update
};

function _createSuper$b(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$b(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$b() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaBaseTooltip = /*#__PURE__*/function (_Vue) {
  _inherits(DefaBaseTooltip, _Vue);

  var _super = _createSuper$b(DefaBaseTooltip);

  function DefaBaseTooltip() {
    var _this;

    _classCallCheck(this, DefaBaseTooltip);

    _this = _super.apply(this, arguments);
    _this.active = false;
    return _this;
  }

  _createClass(DefaBaseTooltip, [{
    key: "mounted",
    value: function mounted() {
      if (!this.$slots.default) {
        console.error("DefaBaseTooltip: Content for the default slot needs to be provided!");
      }
    }
  }, {
    key: "onClick",
    value: function onClick($event) {
      this.active = !this.active;
      this.$emit("click", $event);
    }
  }, {
    key: "closeTooltip",
    value: function closeTooltip() {
      this.active = false;
    }
  }, {
    key: "onActiveChange",
    value: function () {
      var _onActiveChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.active && this.positionRelativeToParent)) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return this.$nextTick();

              case 3:
                // Wait for element to come into view
                this.repositionTooltipIfNeeded();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onActiveChange() {
        return _onActiveChange.apply(this, arguments);
      }

      return onActiveChange;
    }()
  }, {
    key: "repositionTooltipIfNeeded",
    value: function repositionTooltipIfNeeded() {
      var _this2 = this;

      var intersectionObserver = new IntersectionObserver(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
            intersectionRatio = _ref2[0].intersectionRatio;

        if (intersectionRatio < 1) {
          // Move part that's out of bounds + a small margin
          var percentageToMove = (1 - intersectionRatio) * 100 + 2;
          gsap.set(_this2.tooltipBox, {
            xPercent: "-".concat(percentageToMove)
          });
        }

        intersectionObserver.unobserve(_this2.tooltipBox);
      }, {
        root: document.documentElement
      });
      intersectionObserver.observe(this.tooltipBox);
    }
  }, {
    key: "positionRelativeToParent",
    get: function get() {
      return !this.selectorElToAppendTo;
    }
  }]);

  return DefaBaseTooltip;
}(Vue$1);

__decorate([Prop({
  default: "",
  type: String
}), __metadata("design:type", String)], DefaBaseTooltip.prototype, "selectorElToAppendTo", void 0);

__decorate([Ref(), __metadata("design:type", HTMLDivElement)], DefaBaseTooltip.prototype, "tooltipBox", void 0);

__decorate([Watch("active"), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", _Promise)], DefaBaseTooltip.prototype, "onActiveChange", null);

DefaBaseTooltip = __decorate([Component({
  components: {
    DefaTransitionFadeSlide: __vue_component__$1b
  },
  directives: {
    appendTo: appendTo
  },
  name: "DefaBaseTooltip"
})], DefaBaseTooltip);
var script$c = DefaBaseTooltip;

/* script */
const __vue_script__$c = script$c;

/* template */
var __vue_render__$c = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tooltip",staticClass:"base-tooltip",class:{
    'base-tooltip--position-relative-to-parent': _vm.positionRelativeToParent,
  },on:{"click":_vm.onClick}},[_c('span',{staticClass:"base-tooltip__circle"},[_vm._v("?")]),_vm._v(" "),_c('DefaTransitionFadeSlide',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"},{name:"append-to",rawName:"v-append-to",value:(
        !_vm.positionRelativeToParent
          ? {
              elToAppendTo: _vm.selectorElToAppendTo,
              elToPositionRelativeTo: _vm.$refs.tooltip,
            }
          : null
      ),expression:"\n        !positionRelativeToParent\n          ? {\n              elToAppendTo: selectorElToAppendTo,\n              elToPositionRelativeTo: $refs.tooltip,\n            }\n          : null\n      "}],ref:"tooltipBox",staticClass:"base-tooltip__tooltip",on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"base-tooltip__tooltip__close",on:{"click":_vm.closeTooltip}},[_vm._v("\n        ×\n      ")])],2)])],1)};
var __vue_staticRenderFns__$c = [];

  /* style */
  const __vue_inject_styles__$c = function (inject) {
    if (!inject) return
    inject("data-v-a1e0c764_0", { source: ".base-tooltip[data-v-a1e0c764]{position:relative;display:inline-flex;justify-content:center;align-items:center;width:1.5em;height:1.5em;border-radius:50%;color:#fff;background-color:var(--defa-oreon-color-primary);cursor:pointer}.base-tooltip__circle[data-v-a1e0c764]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-weight:700}.base-tooltip__tooltip[data-v-a1e0c764]{z-index:50;position:absolute;left:calc(50% - 40px);bottom:calc(100% + 1em);width:min(50ch,80vw);color:var(--defa-oreon-color-black);background-color:#fff;padding:2em 1em 1em 1em;box-shadow:0 2px 4px #00000024;border-radius:1em;font-weight:400;cursor:initial}.base-tooltip__tooltip.base-tooltip--position-relative-to-parent[data-v-a1e0c764]{bottom:calc(100% + 1em);left:calc(50% - 40px)}.base-tooltip__tooltip__close[data-v-a1e0c764]{position:absolute;top:2%;right:2%;font-size:2em;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$c = "data-v-a1e0c764";
  /* module identifier */
  const __vue_module_identifier__$c = undefined;
  /* functional template */
  const __vue_is_functional_template__$c = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$c = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$c, staticRenderFns: __vue_staticRenderFns__$c },
    __vue_inject_styles__$c,
    __vue_script__$c,
    __vue_scope_id__$c,
    __vue_is_functional_template__$c,
    __vue_module_identifier__$c,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$a(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$a(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$a() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaBaseSelect = /*#__PURE__*/function (_Vue) {
  _inherits(DefaBaseSelect, _Vue);

  var _super = _createSuper$a(DefaBaseSelect);

  function DefaBaseSelect() {
    var _this;

    _classCallCheck(this, DefaBaseSelect);

    _this = _super.apply(this, arguments);
    _this.searchTerm = "";
    return _this;
  }

  _createClass(DefaBaseSelect, [{
    key: "created",
    value: function created() {
      if (this.multiple && !_Array$isArray(this.modelValue)) {
        console.error("DefaBaseSelect: 'modelValue' should be an array when specifying 'multiple'!");
      }

      if (!this.multiple && _Array$isArray(this.modelValue)) {
        console.error("DefaBaseSelect: 'modelValue' can only be an array when specifying 'multiple'!");
      }
    } // Required to highlight search term, also see https://github.com/sagalbot/vue-select/issues/632

  }, {
    key: "syncSearch",
    value: function syncSearch(searchTerm) {
      this.searchTerm = searchTerm;
    }
  }, {
    key: "searchMatch",
    get: function get() {
      var _this2 = this;

      return function (option) {
        var _match;

        // https://stackoverflow.com/questions/17885855/use-dynamic-variable-string-as-regex-pattern-in-javascript/17886301
        var escapedSearchTerm = _this2.searchTerm.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");

        return (_match = ("" + option).match(new RegExp(escapedSearchTerm, "i"))) === null || _match === void 0 ? void 0 : _match[0];
      };
    }
  }, {
    key: "preSearchMatch",
    get: function get() {
      var _this3 = this;

      return function (option) {
        var matched = _this3.searchMatch(option);

        if (matched) {
          var searchMatchIndex = _indexOfInstanceProperty(option).call(option, matched);

          return _sliceInstanceProperty(option).call(option, 0, searchMatchIndex);
        }

        return option;
      };
    }
  }, {
    key: "postSearchMatch",
    get: function get() {
      var _this4 = this;

      return function (option) {
        var matched = _this4.searchMatch(option);

        if (matched) {
          var searchMatchIndex = _indexOfInstanceProperty(option).call(option, matched);

          return _sliceInstanceProperty(option).call(option, searchMatchIndex).replace(matched, "");
        }

        return "";
      };
    }
  }, {
    key: "hasLabel",
    get: function get() {
      return Boolean(this.label);
    }
  }, {
    key: "getRules",
    get: function get() {
      return getRules(this.rules, this.disabled);
    }
  }, {
    key: "reduce",
    get: function get() {
      var _this5 = this;

      return function (option) {
        return _this5.noReduce ? option : option.value;
      };
    }
  }, {
    key: "defaultOption",
    get: function get() {
      var _ref;

      return _ref = {}, _defineProperty(_ref, this.optionLabelProp, this.$t("defaBaseSelect.defaultOption.label")), _defineProperty(_ref, "value", ""), _ref;
    }
  }, {
    key: "optionsOptionallyWithDefault",
    get: function get() {
      var _context;

      if (this.excludeDefaultOption) {
        return this.options;
      }

      return _concatInstanceProperty(_context = [this.defaultOption]).call(_context, _toConsumableArray(this.options));
    }
  }, {
    key: "isOptionSelectable",
    get: function get() {
      var _this6 = this;

      return function (option) {
        return option.value !== _this6.defaultOption.value;
      };
    }
  }, {
    key: "searchable",
    get: function get() {
      if (this.disableSearch) {
        return false;
      }

      return this.options.length > 5;
    }
  }, {
    key: "hasRequiredRule",
    get: function get() {
      return hasRequiredRule(this.rules);
    }
  }, {
    key: "hasRequiredRuleHasLabelAndIsNotDisabled",
    get: function get() {
      if (this.disabled) {
        return false;
      }

      return this.hasRequiredRule && Boolean(this.label);
    }
  }, {
    key: "value",
    get: function get() {
      return this.modelValue;
    },
    set: function set(newValue) {
      this.$emit("change", newValue);
    }
  }]);

  return DefaBaseSelect;
}(Vue$1);

__decorate([Prop({
  required: true,
  type: Array
}), __metadata("design:type", Array)], DefaBaseSelect.prototype, "options", void 0);

__decorate([Prop({
  default: null,
  type: [String, Number, Array]
}), __metadata("design:type", Object)], DefaBaseSelect.prototype, "modelValue", void 0);

__decorate([Prop({
  default: null,
  type: String
}), __metadata("design:type", Object)], DefaBaseSelect.prototype, "name", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseSelect.prototype, "disableSearch", void 0);

__decorate([Prop({
  default: null,
  type: String
}), __metadata("design:type", Object)], DefaBaseSelect.prototype, "label", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseSelect.prototype, "excludeDefaultOption", void 0);

__decorate([Prop({
  default: null,
  type: [Object, String]
}), __metadata("design:type", Object)], DefaBaseSelect.prototype, "rules", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseSelect.prototype, "noReduce", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseSelect.prototype, "disabled", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseSelect.prototype, "multiple", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseSelect.prototype, "appendToBody", void 0);

__decorate([Prop({
  default: "label",
  type: String
}), __metadata("design:type", String)], DefaBaseSelect.prototype, "optionLabelProp", void 0);

__decorate([Prop({
  default: null,
  type: Object
}), __metadata("design:type", Object)], DefaBaseSelect.prototype, "customMessages", void 0);

__decorate([Prop({
  default: "top",
  type: String
}), __metadata("design:type", String)], DefaBaseSelect.prototype, "errorMessagePosition", void 0);

DefaBaseSelect = __decorate([Component({
  components: {
    DefaBaseInputErrorMessage: __vue_component__$F,
    VueSelect: VueSelect,
    ValidationProvider: ValidationProvider
  },
  model: {
    prop: "modelValue",
    event: "change"
  },
  name: "DefaBaseSelect"
})], DefaBaseSelect);
var script$b = DefaBaseSelect;

/* script */
const __vue_script__$b = script$b;

/* template */
var __vue_render__$b = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"tag":"div","mode":"aggressive","rules":_vm.getRules,"name":_vm.name,"custom-messages":_vm.customMessages},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var failed = ref.failed;
var errors = ref.errors;
var ariaMsg = ref.ariaMsg;
return [_c('div',{staticClass:"base-select",class:{
      'base-select--with-label': _vm.hasLabel,
      'base-select--has-error': failed,
    }},[(_vm.hasLabel)?_c('label',{staticClass:"base-select__label",class:{
        'base-select__label--required': _vm.hasRequiredRuleHasLabelAndIsNotDisabled,
        'base-select__label--disabled': _vm.disabled,
        'base-select__label--has-error': failed,
      },attrs:{"for":_vm.name}},[_vm._t("label",function(){return [_vm._v(_vm._s(_vm.label))]},null,{ hasRequiredRule: _vm.hasRequiredRule })],2):_vm._e(),_vm._v(" "),_c('VueSelect',{staticClass:"base-select__select",attrs:{"label":_vm.optionLabelProp,"append-to-body":_vm.appendToBody,"disabled":_vm.disabled,"options":_vm.optionsOptionallyWithDefault,"searchable":_vm.searchable,"clearable":false,"selectable":_vm.isOptionSelectable,"reduce":_vm.reduce,"input-id":_vm.name,"multiple":_vm.multiple,"data-test":_vm.name},on:{"search":_vm.syncSearch},scopedSlots:_vm._u([{key:"selected-option",fn:function(option){return [_vm._t("selected-option",function(){return [_vm._v("\n          "+_vm._s(option[_vm.optionLabelProp])+"\n        ")]},null,option)]}},{key:"option",fn:function(option){return [_c('div',{attrs:{"data-test":(_vm.name + "-" + (option.value))}},[_vm._t("option",function(){return [_c('span',[_vm._v(_vm._s(_vm.preSearchMatch(option[_vm.optionLabelProp])))]),_c('span',{staticClass:"search-match"},[_vm._v(_vm._s(_vm.searchMatch(option[_vm.optionLabelProp])))]),_c('span',[_vm._v(_vm._s(_vm.postSearchMatch(option[_vm.optionLabelProp])))])]},null,{
              option: option,
              searchMatch: _vm.searchMatch(option[_vm.optionLabelProp]),
              preSearchMatch: _vm.preSearchMatch(option[_vm.optionLabelProp]),
              postSearchMatch: _vm.postSearchMatch(option[_vm.optionLabelProp]),
            })],2)]}},{key:"no-options",fn:function(ref){
            var search = ref.search;
return [_c('i18n',{staticClass:"no-options",attrs:{"tag":"div","path":"defaBaseSelect.noOptions"},scopedSlots:_vm._u([{key:"searchTerm",fn:function(){return [_c('span',{staticClass:"no-options__search"},[_vm._v(_vm._s(search))])]},proxy:true}],null,true)})]}}],null,true),model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v;},expression:"value"}}),_vm._v(" "),_c('DefaBaseInputErrorMessage',_vm._b({directives:[{name:"show",rawName:"v-show",value:(failed),expression:"failed"}],attrs:{"position":_vm.errorMessagePosition}},'DefaBaseInputErrorMessage',ariaMsg,false),[_vm._v("\n      "+_vm._s(errors[0])+"\n    ")])],1)]}}],null,true)})};
var __vue_staticRenderFns__$b = [];

  /* style */
  const __vue_inject_styles__$b = function (inject) {
    if (!inject) return
    inject("data-v-62a84e24_0", { source: ".v-select{position:relative;font-family:inherit}.v-select,.v-select *{box-sizing:border-box}@-webkit-keyframes vSelectSpinner{0%{transform:rotate(0)}to{transform:rotate(1turn)}}@keyframes vSelectSpinner{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.vs__fade-enter-active,.vs__fade-leave-active{pointer-events:none;transition:opacity .15s cubic-bezier(1,.5,.8,1)}.vs__fade-enter,.vs__fade-leave-to{opacity:0}.vs--disabled .vs__clear,.vs--disabled .vs__dropdown-toggle,.vs--disabled .vs__open-indicator,.vs--disabled .vs__search,.vs--disabled .vs__selected{cursor:not-allowed;background-color:#f8f8f8}.v-select[dir=rtl] .vs__actions{padding:0 3px 0 6px}.v-select[dir=rtl] .vs__clear{margin-left:6px;margin-right:0}.v-select[dir=rtl] .vs__deselect{margin-left:0;margin-right:2px}.v-select[dir=rtl] .vs__dropdown-menu{text-align:right}.vs__dropdown-toggle{-webkit-appearance:none;-moz-appearance:none;appearance:none;display:flex;padding:0 0 4px;background:0 0;border:1px solid rgba(60,60,60,.26);border-radius:4px;white-space:normal}.vs__selected-options{display:flex;flex-basis:100%;flex-grow:1;flex-wrap:wrap;padding:0 2px;position:relative}.vs__actions{display:flex;align-items:center;padding:4px 6px 0 3px}.vs--searchable .vs__dropdown-toggle{cursor:text}.vs--unsearchable .vs__dropdown-toggle{cursor:pointer}.vs--open .vs__dropdown-toggle{border-bottom-color:transparent;border-bottom-left-radius:0;border-bottom-right-radius:0}.vs__open-indicator{fill:rgba(60,60,60,.5);transform:scale(1);transition:transform .15s cubic-bezier(1,-.115,.975,.855);transition-timing-function:cubic-bezier(1,-.115,.975,.855)}.vs--open .vs__open-indicator{transform:rotate(180deg) scale(1)}.vs--loading .vs__open-indicator{opacity:0}.vs__clear{fill:rgba(60,60,60,.5);padding:0;border:0;background-color:transparent;cursor:pointer;margin-right:8px}.vs__dropdown-menu{display:block;box-sizing:border-box;position:absolute;top:calc(100% - 1px);left:0;z-index:1000;padding:5px 0;margin:0;width:100%;max-height:350px;min-width:160px;overflow-y:auto;box-shadow:0 3px 6px 0 rgba(0,0,0,.15);border:1px solid rgba(60,60,60,.26);border-top-style:none;border-radius:0 0 4px 4px;text-align:left;list-style:none;background:#fff}.vs__no-options{text-align:center}.vs__dropdown-option{line-height:1.42857143;display:block;padding:3px 20px;clear:both;color:#333;white-space:nowrap}.vs__dropdown-option:hover{cursor:pointer}.vs__dropdown-option--highlight{background:#5897fb;color:#fff}.vs__dropdown-option--disabled{background:inherit;color:rgba(60,60,60,.5)}.vs__dropdown-option--disabled:hover{cursor:inherit}.vs__selected{display:flex;align-items:center;background-color:#f0f0f0;border:1px solid rgba(60,60,60,.26);border-radius:4px;color:#333;line-height:1.4;margin:4px 2px 0;padding:0 .25em;z-index:0}.vs__deselect{display:inline-flex;-webkit-appearance:none;-moz-appearance:none;appearance:none;margin-left:4px;padding:0;border:0;cursor:pointer;background:0 0;fill:rgba(60,60,60,.5);text-shadow:0 1px 0 #fff}.vs--single .vs__selected{background-color:transparent;border-color:transparent}.vs--single.vs--open .vs__selected{position:absolute;opacity:.4}.vs--single.vs--searching .vs__selected{display:none}.vs__search::-webkit-search-cancel-button{display:none}.vs__search::-ms-clear,.vs__search::-webkit-search-decoration,.vs__search::-webkit-search-results-button,.vs__search::-webkit-search-results-decoration{display:none}.vs__search,.vs__search:focus{-webkit-appearance:none;-moz-appearance:none;appearance:none;line-height:1.4;font-size:1em;border:1px solid transparent;border-left:none;outline:0;margin:4px 0 0;padding:0 7px;background:0 0;box-shadow:none;width:0;max-width:100%;flex-grow:1;z-index:1}.vs__search::-moz-placeholder{color:inherit}.vs__search:-ms-input-placeholder{color:inherit}.vs__search::placeholder{color:inherit}.vs--unsearchable .vs__search{opacity:1}.vs--unsearchable:not(.vs--disabled) .vs__search:hover{cursor:pointer}.vs--single.vs--searching:not(.vs--open):not(.vs--loading) .vs__search{opacity:.2}.vs__spinner{align-self:center;opacity:0;font-size:5px;text-indent:-9999em;overflow:hidden;border:.9em solid hsla(0,0%,39.2%,.1);border-left-color:rgba(60,60,60,.45);transform:translateZ(0);-webkit-animation:vSelectSpinner 1.1s linear infinite;animation:vSelectSpinner 1.1s linear infinite;transition:opacity .1s}.vs__spinner,.vs__spinner:after{border-radius:50%;width:5em;height:5em}.vs--loading .vs__spinner{opacity:1}:root .vs__dropdown-option--highlight{background-color:var(--defa-oreon-color-primary);width:100%;color:#fff}:root .vs__dropdown-menu{width:auto!important}.base-select{position:relative}.base-select__label{padding:0 1em;font-weight:700;display:flex;align-items:center;gap:.5em;position:absolute;bottom:100%;transform:translateY(50%);left:2em;background-color:#fff}.base-select__label--required::after{content:\"*\"}.base-select__label--disabled{color:var(--defa-oreon-color-gray-shade-3)}.base-select .vs__dropdown-toggle{overflow-x:hidden}.base-select--with-label{padding:2em;border:1px solid var(--defa-oreon-color-gray-shade-3);position:relative}.base-select--has-error .vs__dropdown-toggle{border-color:var(--defa-oreon-color-error)}.base-select .vs__actions{cursor:pointer}.base-select .vs__dropdown-menu{width:auto;min-width:100%}.base-select .v-select:not(.vs--open) .vs__search{border:0;height:0;margin:0}.base-select__select:focus-within~.base-input-error-message,.base-select__select:focus~.base-input-error-message,.base-select__select:hover~.base-input-error-message{opacity:1;z-index:0}.base-select__label.base-select__label--has-error{color:var(--defa-oreon-color-error)}.search-match{font-weight:700}.no-options{padding:.5em}.no-options__search{font-weight:700}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$b = undefined;
  /* module identifier */
  const __vue_module_identifier__$b = undefined;
  /* functional template */
  const __vue_is_functional_template__$b = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$b = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$b, staticRenderFns: __vue_staticRenderFns__$b },
    __vue_inject_styles__$b,
    __vue_script__$b,
    __vue_scope_id__$b,
    __vue_is_functional_template__$b,
    __vue_module_identifier__$b,
    false,
    createInjector,
    undefined,
    undefined
  );

var _context, _context2, _context3;

// Generates every 15 minutes from 04:00 to 23:30
var timepickerOptions = _concatInstanceProperty(_context = _mapInstanceProperty(_context2 = _fillInstanceProperty(_context3 = Array(40)).call(_context3, null)).call(_context2, function (_, i) {
  var _context4, _context5;

  var minutes = i % 2 === 0 ? "00" : "30";
  var hours = Math.floor(i / 2) + 4;

  var hoursAsString = _padStartInstanceProperty(_context4 = hours.toString()).call(_context4, 2, "0");

  return {
    id: i,
    value: _concatInstanceProperty(_context5 = "".concat(hoursAsString, ":")).call(_context5, minutes)
  };
})).call(_context, [{
  id: 40,
  value: "00:00"
}]);

function _createSuper$9(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$9(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$9() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaBaseDatetimeInputOverlayTimepicker = /*#__PURE__*/function (_Vue) {
  _inherits(DefaBaseDatetimeInputOverlayTimepicker, _Vue);

  var _super = _createSuper$9(DefaBaseDatetimeInputOverlayTimepicker);

  function DefaBaseDatetimeInputOverlayTimepicker() {
    var _this;

    _classCallCheck(this, DefaBaseDatetimeInputOverlayTimepicker);

    _this = _super.apply(this, arguments);
    _this.showTimepickerOptions = false;
    _this.timepickerOptions = timepickerOptions;
    return _this;
  }

  _createClass(DefaBaseDatetimeInputOverlayTimepicker, [{
    key: "toggleTimepickerOptions",
    value: function toggleTimepickerOptions() {
      this.showTimepickerOptions = !this.showTimepickerOptions;
    }
  }, {
    key: "onClickOption",
    value: function onClickOption(timeValue) {
      this.$emit("select-time", {
        time: timeValue
      });
      this.showTimepickerOptions = false;
    }
  }, {
    key: "isSelectedOption",
    get: function get() {
      var _this2 = this;

      return function (value) {
        return _this2.selectedOption === value;
      };
    }
  }]);

  return DefaBaseDatetimeInputOverlayTimepicker;
}(Vue$1);

__decorate([Prop({
  default: "",
  type: String
}), __metadata("design:type", String)], DefaBaseDatetimeInputOverlayTimepicker.prototype, "selectedOption", void 0);

DefaBaseDatetimeInputOverlayTimepicker = __decorate([Component({
  name: "DefaBaseDatetimeInputOverlayTimepicker"
})], DefaBaseDatetimeInputOverlayTimepicker);
var script$a = DefaBaseDatetimeInputOverlayTimepicker;

/* script */
const __vue_script__$a = script$a;

/* template */
var __vue_render__$a = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-datetime-input-overlay-timepicker"},[_c('input',{staticClass:"base-datetime-input-overlay-timepicker__input",class:{ selected: !!_vm.selectedOption },attrs:{"placeholder":_vm.$t('datetimeInputOverlayTimepicker.placeholder'),"readonly":"","type":"text"},domProps:{"value":_vm.selectedOption},on:{"click":_vm.toggleTimepickerOptions}}),_vm._v(" "),_c('div',{staticClass:"base-datetime-input-overlay-timepicker__options-arrow",class:{ selected: !!_vm.selectedOption },on:{"click":_vm.toggleTimepickerOptions}},[_vm._v("\n    ˇ\n  ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTimepickerOptions),expression:"showTimepickerOptions"}],staticClass:"base-datetime-input-overlay-timepicker__options"},_vm._l((_vm.timepickerOptions),function(option){return _c('div',{key:option.id,staticClass:"base-datetime-input-overlay-timepicker__option",class:{ selected: _vm.isSelectedOption(option.value) },on:{"click":function($event){return _vm.onClickOption(option.value)}}},[_vm._v("\n      "+_vm._s(option.value)+"\n    ")])}),0)])};
var __vue_staticRenderFns__$a = [];

  /* style */
  const __vue_inject_styles__$a = function (inject) {
    if (!inject) return
    inject("data-v-f8e66a22_0", { source: ".base-datetime-input-overlay-timepicker[data-v-f8e66a22]{position:relative;width:80%;margin:1rem auto}.base-datetime-input-overlay-timepicker__input[data-v-f8e66a22]{display:block;width:100%;border:none;background-color:var(--defa-oreon-color-gray-contrast-low);border-radius:26px;padding:.5rem 1rem;font-size:.9rem;cursor:pointer;outline:0}.base-datetime-input-overlay-timepicker__input.selected[data-v-f8e66a22]{color:#fff;background-color:var(--defa-oreon-color-primary);font-weight:700}.base-datetime-input-overlay-timepicker__options-arrow[data-v-f8e66a22]{position:absolute;top:0;right:1rem;cursor:pointer;font-size:2.5rem;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.base-datetime-input-overlay-timepicker__options-arrow.selected[data-v-f8e66a22]{color:#fff}.base-datetime-input-overlay-timepicker__options[data-v-f8e66a22]{position:absolute;background-color:#fff;cursor:pointer;width:100%;box-shadow:0 3px 6px #00000029;top:110%;overflow-y:auto;max-height:8rem;left:50%;transform:translateX(-50%)}.base-datetime-input-overlay-timepicker__option[data-v-f8e66a22]{display:flex;align-items:center;justify-content:flex-end;padding-right:1rem;height:2rem}.base-datetime-input-overlay-timepicker__option[data-v-f8e66a22]:hover{background-color:var(--defa-oreon-color-gray-shade-1)}.base-datetime-input-overlay-timepicker__option.selected[data-v-f8e66a22]{color:#fff;font-weight:700;background-color:var(--defa-oreon-color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$a = "data-v-f8e66a22";
  /* module identifier */
  const __vue_module_identifier__$a = undefined;
  /* functional template */
  const __vue_is_functional_template__$a = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$a = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$a, staticRenderFns: __vue_staticRenderFns__$a },
    __vue_inject_styles__$a,
    __vue_script__$a,
    __vue_scope_id__$a,
    __vue_is_functional_template__$a,
    __vue_module_identifier__$a,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$8(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$8(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$8() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var dateWithoutTime = function dateWithoutTime() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  return new Date(date.toDateString());
};

var setTimeOnDate = function setTimeOnDate(date, hoursAndMinutes) {
  return set(date, {
    hours: hoursAndMinutes[0],
    minutes: hoursAndMinutes[1]
  });
};

var toHoursAndMinutesArray = function toHoursAndMinutesArray(time) {
  var _context;

  return _mapInstanceProperty(_context = time.split(":")).call(_context, function (value) {
    return _parseInt(value);
  });
};

var DefaBaseDatetimeInputOverlay = /*#__PURE__*/function (_Vue) {
  _inherits(DefaBaseDatetimeInputOverlay, _Vue);

  var _super = _createSuper$8(DefaBaseDatetimeInputOverlay);

  function DefaBaseDatetimeInputOverlay() {
    var _this;

    _classCallCheck(this, DefaBaseDatetimeInputOverlay);

    _this = _super.apply(this, arguments);
    _this.date = null;
    _this.time = "";
    return _this;
  }

  _createClass(DefaBaseDatetimeInputOverlay, [{
    key: "created",
    value: function created() {
      if (_Array$isArray(this.modelValue)) {
        var _context2, _context3;

        this.date = this.modelValue ? _mapInstanceProperty(_context2 = this.modelValue).call(_context2, dateWithoutTime) : [dateWithoutTime(), dateWithoutTime()];
        this.time = this.modelValue ? _mapInstanceProperty(_context3 = this.modelValue).call(_context3, function (value) {
          return formatTimeString(value);
        }) : ["", ""];
      } else {
        this.date = this.modelValue ? dateWithoutTime(this.modelValue) : dateWithoutTime();
        this.time = this.modelValue ? formatTimeString(this.modelValue) : "";
      }
    }
  }, {
    key: "onSelectDate",
    value: function onSelectDate(date) {
      this.date = date;

      if (this.closeOnSelect) {
        if (this.date) {
          if (this.includeTimepicker) {
            if (this.time && this.time !== TIME_DEFAULT) {
              this.onChange();
            }
          } else {
            this.onChange();
          }
        }
      }
    }
  }, {
    key: "onSelectTime",
    value: function onSelectTime(_ref) {
      var time = _ref.time;
      this.time = time;

      if (this.closeOnSelect) {
        if (this.time !== TIME_DEFAULT) {
          this.onChange();
        }
      }
    }
  }, {
    key: "onChange",
    value: function onChange() {
      this.$emit("change", this.value);
    }
  }, {
    key: "positionOverlayClass",
    get: function get() {
      return "base-datetime-input-overlay--".concat(this.positionOverlay);
    }
  }, {
    key: "hoursAndMinutes",
    get: function get() {
      if (_Array$isArray(this.time)) {
        var _context4;

        return _mapInstanceProperty(_context4 = this.time).call(_context4, toHoursAndMinutesArray);
      }

      return toHoursAndMinutesArray(this.time);
    }
  }, {
    key: "value",
    get: function get() {
      var _this2 = this;

      if (_Array$isArray(this.date)) {
        if (this.time) {
          var _context5;

          return _mapInstanceProperty(_context5 = this.date).call(_context5, function (value, index) {
            return setTimeOnDate(value, _this2.hoursAndMinutes[index]);
          });
        }

        return this.date;
      } else if (this.date) {
        if (this.time) {
          return setTimeOnDate(this.date, this.hoursAndMinutes);
        }

        return this.date;
      }

      return this.date;
    }
  }]);

  return DefaBaseDatetimeInputOverlay;
}(Vue$1);

__decorate([Prop({
  required: true,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseDatetimeInputOverlay.prototype, "range", void 0);

__decorate([Prop({
  required: true,
  type: String
}), __metadata("design:type", String)], DefaBaseDatetimeInputOverlay.prototype, "positionOverlay", void 0);

__decorate([Prop({
  required: true,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseDatetimeInputOverlay.prototype, "closeOnSelect", void 0);

__decorate([Prop({
  default: null,
  type: [Date, Array]
}), __metadata("design:type", Object)], DefaBaseDatetimeInputOverlay.prototype, "modelValue", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseDatetimeInputOverlay.prototype, "includeTimepicker", void 0);

__decorate([Prop({
  default: null,
  type: Function
}), __metadata("design:type", Function)], DefaBaseDatetimeInputOverlay.prototype, "disabledDate", void 0);

DefaBaseDatetimeInputOverlay = __decorate([Component({
  components: {
    DefaBaseDatetimeInputOverlayTimepicker: __vue_component__$a,
    Datepicker: Datepicker
  },
  model: {
    prop: "modelValue",
    event: "change"
  },
  name: "DefaBaseDatetimeInputOverlay"
})], DefaBaseDatetimeInputOverlay);
var script$9 = DefaBaseDatetimeInputOverlay;

/* script */
const __vue_script__$9 = script$9;

/* template */
var __vue_render__$9 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-datetime-input-overlay",class:_vm.positionOverlayClass},[_c('datepicker',{staticClass:"base-datetime-input-overlay__datepicker",attrs:{"disabled-date":_vm.disabledDate,"lang":_vm.$t('defaBaseDatetimePicker'),"range":_vm.range,"value":_vm.date,"inline":""},on:{"input":_vm.onSelectDate}}),_vm._v(" "),(_vm.includeTimepicker)?_c('DefaBaseDatetimeInputOverlayTimepicker',{attrs:{"selected-option":_vm.time},on:{"select-time":_vm.onSelectTime}}):_vm._e(),_vm._v(" "),(!_vm.closeOnSelect)?_c('div',{staticClass:"base-datetime-input-overlay__close",attrs:{"data-test":"datetime-close"},on:{"click":_vm.onChange}},[_vm._v("\n    "+_vm._s(_vm.$t("datetimeInputOverlay.done"))+"\n  ")]):_vm._e()],1)};
var __vue_staticRenderFns__$9 = [];

  /* style */
  const __vue_inject_styles__$9 = function (inject) {
    if (!inject) return
    inject("data-v-afa1d1c4_0", { source: ".mx-icon-double-left:after,.mx-icon-double-left:before,.mx-icon-double-right:after,.mx-icon-double-right:before,.mx-icon-left:before,.mx-icon-right:before{content:\"\";position:relative;top:-1px;display:inline-block;width:10px;height:10px;vertical-align:middle;border-style:solid;border-color:currentColor;border-width:2px 0 0 2px;border-radius:1px;box-sizing:border-box;transform-origin:center;transform:rotate(-45deg) scale(.7)}.mx-icon-double-left:after{left:-4px}.mx-icon-double-right:before{left:4px}.mx-icon-double-right:after,.mx-icon-double-right:before,.mx-icon-right:before{transform:rotate(135deg) scale(.7)}.mx-btn{box-sizing:border-box;line-height:1;font-size:14px;font-weight:500;padding:7px 15px;margin:0;cursor:pointer;background-color:transparent;outline:0;border:1px solid rgba(0,0,0,.1);border-radius:4px;color:#73879c;white-space:nowrap}.mx-btn:hover{border-color:#1284e7;color:#1284e7}.mx-btn-text{border:0;padding:0 4px;text-align:left;line-height:inherit}.mx-scrollbar{height:100%}.mx-scrollbar:hover .mx-scrollbar-track{opacity:1}.mx-scrollbar-wrap{height:100%;overflow-x:hidden;overflow-y:auto}.mx-scrollbar-track{position:absolute;top:2px;right:2px;bottom:2px;width:6px;z-index:1;border-radius:4px;opacity:0;transition:opacity .24s ease-out}.mx-scrollbar-track .mx-scrollbar-thumb{position:absolute;width:100%;height:0;cursor:pointer;border-radius:inherit;background-color:rgba(144,147,153,.3);transition:background-color .3s}.mx-zoom-in-down-enter-active,.mx-zoom-in-down-leave-active{opacity:1;transform:scaleY(1);transition:transform .3s cubic-bezier(.23,1,.32,1),opacity .3s cubic-bezier(.23,1,.32,1);transform-origin:center top}.mx-zoom-in-down-enter,.mx-zoom-in-down-leave-to{opacity:0;transform:scaleY(0)}.mx-datepicker{position:relative;display:inline-block;width:210px}.mx-datepicker svg{width:1em;height:1em;vertical-align:-.15em;fill:currentColor;overflow:hidden}.mx-datepicker-range{width:320px}.mx-datepicker-inline{width:auto}.mx-input-wrapper{position:relative}.mx-input-wrapper .mx-icon-clear{display:none}.mx-input-wrapper:hover .mx-icon-clear{display:block}.mx-input-wrapper:hover .mx-icon-clear+.mx-icon-calendar{display:none}.mx-input{display:inline-block;box-sizing:border-box;width:100%;height:34px;padding:6px 30px;padding-left:10px;font-size:14px;line-height:1.4;color:#555;background-color:#fff;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.mx-input:focus,.mx-input:hover{border-color:#409aff}.mx-input.disabled,.mx-input:disabled{color:#ccc;background-color:#f3f3f3;border-color:#ccc;cursor:not-allowed}.mx-input:focus{outline:0}.mx-input::-ms-clear{display:none}.mx-icon-calendar,.mx-icon-clear{position:absolute;top:50%;right:8px;transform:translateY(-50%);font-size:16px;line-height:1;color:rgba(0,0,0,.5);vertical-align:middle}.mx-icon-clear{cursor:pointer}.mx-icon-clear:hover{color:rgba(0,0,0,.8)}.mx-datepicker-main{font:14px/1.5 \"Helvetica Neue\",Helvetica,Arial,\"Microsoft Yahei\",sans-serif;color:#73879c;background-color:#fff;border:1px solid #e8e8e8}.mx-datepicker-popup{position:absolute;margin-top:1px;margin-bottom:1px;box-shadow:0 6px 12px rgba(0,0,0,.175);z-index:2001}.mx-datepicker-sidebar{float:left;box-sizing:border-box;width:100px;padding:6px;overflow:auto}.mx-datepicker-sidebar+.mx-datepicker-content{margin-left:100px;border-left:1px solid #e8e8e8}.mx-datepicker-body{position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.mx-btn-shortcut{display:block;padding:0 6px;line-height:24px}.mx-range-wrapper{display:flex}@media (max-width:750px){.mx-range-wrapper{flex-direction:column}}.mx-datepicker-header{padding:6px 8px;border-bottom:1px solid #e8e8e8}.mx-datepicker-footer{padding:6px 8px;text-align:right;border-top:1px solid #e8e8e8}.mx-calendar{box-sizing:border-box;width:248px;padding:6px 12px}.mx-calendar+.mx-calendar{border-left:1px solid #e8e8e8}.mx-calendar-header,.mx-time-header{box-sizing:border-box;height:34px;line-height:34px;text-align:center;overflow:hidden}.mx-btn-icon-double-left,.mx-btn-icon-left{float:left}.mx-btn-icon-double-right,.mx-btn-icon-right{float:right}.mx-calendar-header-label{font-size:14px}.mx-calendar-decade-separator{margin:0 2px}.mx-calendar-decade-separator:after{content:\"~\"}.mx-calendar-content{position:relative;height:224px;box-sizing:border-box}.mx-calendar-content .cell{cursor:pointer}.mx-calendar-content .cell:hover{color:#73879c;background-color:#f3f9fe}.mx-calendar-content .cell.active{color:#fff;background-color:#1284e7}.mx-calendar-content .cell.in-range{color:#73879c;background-color:#dbedfb}.mx-calendar-content .cell.disabled{cursor:not-allowed;color:#ccc;background-color:#f3f3f3}.mx-calendar-week-mode .mx-date-row{cursor:pointer}.mx-calendar-week-mode .mx-date-row:hover{background-color:#f3f9fe}.mx-calendar-week-mode .mx-date-row.mx-active-week{background-color:#dbedfb}.mx-calendar-week-mode .mx-date-row .cell:hover{color:inherit;background-color:transparent}.mx-calendar-week-mode .mx-date-row .cell.active{color:inherit;background-color:transparent}.mx-week-number{opacity:.5}.mx-table{table-layout:fixed;border-collapse:separate;border-spacing:0;width:100%;height:100%;box-sizing:border-box;text-align:center;vertical-align:middle}.mx-table th{padding:0;font-weight:500}.mx-table td{padding:0}.mx-table-date td,.mx-table-date th{height:32px;font-size:12px}.mx-table-date .today{color:#2a90e9}.mx-table-date .cell.not-current-month{color:#ccc}.mx-time{flex:1;width:224px;background:#fff}.mx-time+.mx-time{border-left:1px solid #e8e8e8}.mx-calendar-time{position:absolute;top:0;left:0;width:100%;height:100%}.mx-time-header{border-bottom:1px solid #e8e8e8}.mx-time-content{height:224px;box-sizing:border-box;overflow:hidden}.mx-time-columns{display:flex;width:100%;height:100%;overflow:hidden}.mx-time-column{flex:1;position:relative;border-left:1px solid #e8e8e8;text-align:center}.mx-time-column:first-child{border-left:0}.mx-time-column .mx-time-list{margin:0;padding:0;list-style:none}.mx-time-column .mx-time-list::after{content:\"\";display:block;height:192px}.mx-time-column .mx-time-item{cursor:pointer;font-size:12px;height:32px;line-height:32px}.mx-time-column .mx-time-item:hover{color:#73879c;background-color:#f3f9fe}.mx-time-column .mx-time-item.active{color:#1284e7;background-color:transparent;font-weight:700}.mx-time-column .mx-time-item.disabled{cursor:not-allowed;color:#ccc;background-color:#f3f3f3}.mx-time-option{cursor:pointer;padding:8px 10px;font-size:14px;line-height:20px}.mx-time-option:hover{color:#73879c;background-color:#f3f9fe}.mx-time-option.active{color:#1284e7;background-color:transparent;font-weight:700}.mx-time-option.disabled{cursor:not-allowed;color:#ccc;background-color:#f3f3f3}.base-datetime-input-overlay{position:absolute;z-index:1;padding:1rem;background-color:#fff;box-shadow:0 3px 6px #00000029;transform:translateX(-50%);left:50%}.base-datetime-input-overlay--top{bottom:110%}.base-datetime-input-overlay--bottom{top:110%}.base-datetime-input-overlay__close{text-align:center;cursor:pointer;color:var(--defa-oreon-color-primary)}.base-datetime-input-overlay__datepicker .mx-datepicker-main{border:none}.base-datetime-input-overlay__datepicker .today{color:inherit}.base-datetime-input-overlay__datepicker .mx-date-row .cell.active,.base-datetime-input-overlay__datepicker .mx-table-month .cell.active,.base-datetime-input-overlay__datepicker .mx-table-year .cell.active{color:#fff;background-color:var(--defa-oreon-color-primary);font-weight:700}.base-datetime-input-overlay__datepicker .mx-date-row .cell.active{border-radius:50%}.base-datetime-input-overlay__datepicker .mx-btn:hover{color:var(--defa-oreon-color-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$9 = undefined;
  /* module identifier */
  const __vue_module_identifier__$9 = undefined;
  /* functional template */
  const __vue_is_functional_template__$9 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$9 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$9, staticRenderFns: __vue_staticRenderFns__$9 },
    __vue_inject_styles__$9,
    __vue_script__$9,
    __vue_scope_id__$9,
    __vue_is_functional_template__$9,
    __vue_module_identifier__$9,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$7(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$7(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaBaseDatetimeInput = /*#__PURE__*/function (_Vue) {
  _inherits(DefaBaseDatetimeInput, _Vue);

  var _super = _createSuper$7(DefaBaseDatetimeInput);

  function DefaBaseDatetimeInput() {
    var _this;

    _classCallCheck(this, DefaBaseDatetimeInput);

    _this = _super.apply(this, arguments);
    _this.datetimePickerOpened = false;
    return _this;
  }

  _createClass(DefaBaseDatetimeInput, [{
    key: "onChange",
    value: function () {
      var _onChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(value) {
        var _this$validationProvi;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (_this$validationProvi = this.validationProvider) === null || _this$validationProvi === void 0 ? void 0 : _this$validationProvi.validate(value);

              case 2:
                this.$emit("change", value);
                this.datetimePickerOpened = false;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onChange(_x) {
        return _onChange.apply(this, arguments);
      }

      return onChange;
    }()
  }, {
    key: "toggleDatetimePicker",
    value: function toggleDatetimePicker() {
      if (this.disabled) {
        return;
      }

      this.datetimePickerOpened = !this.datetimePickerOpened;
    }
  }, {
    key: "hasRequiredRuleAndIsNotDisabled",
    get: function get() {
      if (this.disabled) {
        return false;
      }

      return hasRequiredRule(this.rules);
    }
  }, {
    key: "getRules",
    get: function get() {
      return getRules(this.rules, this.disabled);
    }
  }, {
    key: "hasLabel",
    get: function get() {
      return Boolean(this.label);
    }
  }, {
    key: "isCloseOnSelect",
    get: function get() {
      return !this.includeTimepicker;
    } // vue2-datepicker library breaks if no disabled-date function is given

  }, {
    key: "disabledDateFn",
    get: function get() {
      if (this.disabledDate) {
        return this.disabledDate;
      }

      return function () {
        return false;
      };
    }
  }, {
    key: "hasValue",
    get: function get() {
      return Boolean(this.modelValue);
    }
  }, {
    key: "colorPrimaryCalendar",
    get: function get() {
      var _this2 = this;

      return function (failed) {
        if (_this2.disabled) {
          return "var(--defa-oreon-color-gray-shade-3)";
        }

        if (failed) {
          return "var(--defa-oreon-color-error)";
        }

        if (_this2.hasValue) {
          return "white";
        }

        return "var(--defa-oreon-color-primary)";
      };
    }
  }, {
    key: "placeholderOrDefault",
    get: function get() {
      if (this.placeholder) {
        return this.placeholder;
      }

      if (this.modelValue) {
        var dateFormat = this.includeTimepicker ? DATE_TIME_FORMAT : DATE_FORMAT;

        if (_Array$isArray(this.modelValue)) {
          return this.$t("defaBaseDatetimeInput.defaultPlaceholder.filledRange", {
            dateFrom: format(this.modelValue[0], dateFormat),
            dateTo: format(this.modelValue[1], dateFormat)
          });
        }

        return this.$t("defaBaseDatetimeInput.defaultPlaceholder.filled", {
          date: format(this.modelValue, dateFormat)
        });
      }

      return this.$t("defaBaseDatetimeInput.defaultPlaceholder.empty");
    }
  }]);

  return DefaBaseDatetimeInput;
}(Vue$1);

__decorate([Prop({
  default: null,
  type: [Date, Array]
}), __metadata("design:type", Object)], DefaBaseDatetimeInput.prototype, "modelValue", void 0);

__decorate([Prop({
  default: null,
  type: String
}), __metadata("design:type", Object)], DefaBaseDatetimeInput.prototype, "name", void 0);

__decorate([Prop({
  default: "",
  type: String
}), __metadata("design:type", String)], DefaBaseDatetimeInput.prototype, "placeholder", void 0);

__decorate([Prop({
  default: "",
  type: String
}), __metadata("design:type", String)], DefaBaseDatetimeInput.prototype, "label", void 0);

__decorate([Prop({
  default: true,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseDatetimeInput.prototype, "includeTimepicker", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseDatetimeInput.prototype, "range", void 0);

__decorate([Prop({
  default: "top",
  type: String
}), __metadata("design:type", String)], DefaBaseDatetimeInput.prototype, "positionOverlay", void 0);

__decorate([Prop({
  default: null,
  type: Function
}), __metadata("design:type", Function)], DefaBaseDatetimeInput.prototype, "disabledDate", void 0);

__decorate([Prop({
  default: null,
  type: [Object, String]
}), __metadata("design:type", Object)], DefaBaseDatetimeInput.prototype, "rules", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseDatetimeInput.prototype, "disabled", void 0);

__decorate([Prop({
  default: "bottom",
  type: String
}), __metadata("design:type", String)], DefaBaseDatetimeInput.prototype, "errorMessagePosition", void 0);

__decorate([Ref(), __metadata("design:type", Object)], DefaBaseDatetimeInput.prototype, "validationProvider", void 0);

DefaBaseDatetimeInput = __decorate([Component({
  components: {
    ValidationProvider: ValidationProvider,
    DefaCircleWrapper: __vue_component__$19,
    DefaIconCalendar: __vue_component__$A,
    DefaBaseDatetimeInputOverlay: __vue_component__$9,
    DefaTransitionSlide: __vue_component__$1a,
    DefaBaseInputErrorMessage: __vue_component__$F
  },
  model: {
    prop: "modelValue",
    event: "change"
  },
  name: "DefaBaseDatetimeInput"
})], DefaBaseDatetimeInput);
var script$8 = DefaBaseDatetimeInput;

/* script */
const __vue_script__$8 = script$8;

/* template */
var __vue_render__$8 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{ref:"validationProvider",attrs:{"rules":_vm.getRules,"name":_vm.name,"tag":"div"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var failed = ref.failed;
var errors = ref.errors;
var ariaMsg = ref.ariaMsg;
return [_c('div',{staticClass:"base-datetime",class:{ 'base-datetime--with-label': _vm.hasLabel },attrs:{"id":_vm.name}},[(_vm.hasLabel)?_c('div',{staticClass:"base-datetime__label",class:{
        'base-datetime__label--required': _vm.hasRequiredRuleAndIsNotDisabled,
        'base-datetime__label--disabled': _vm.disabled,
        'base-datetime__label--has-error': failed,
      }},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"base-datetime-input",attrs:{"data-test":_vm.name}},[_c('DefaCircleWrapper',{staticClass:"base-datetime__icon-calendar-wrapper",class:{
          'base-datetime__icon-calendar-wrapper--filled': _vm.hasValue,
          'base-datetime__icon-calendar-wrapper--disabled': _vm.disabled,
          'base-datetime__icon-calendar-wrapper--has-error': failed,
        },on:{"click":_vm.toggleDatetimePicker}},[_c('DefaIconCalendar',{staticClass:"base-datetime__icon-calendar",attrs:{"color-primary":_vm.colorPrimaryCalendar(failed)}})],1),_vm._v(" "),_c('DefaTransitionSlide',{attrs:{"percentage-after-leave":-20,"percentage-before-enter":-20}},[_c('DefaBaseDatetimeInputOverlay',{directives:[{name:"show",rawName:"v-show",value:(_vm.datetimePickerOpened),expression:"datetimePickerOpened"}],attrs:{"close-on-select":_vm.isCloseOnSelect,"disabled-date":_vm.disabledDateFn,"include-timepicker":_vm.includeTimepicker,"position-overlay":_vm.positionOverlay,"range":_vm.range,"model-value":_vm.modelValue},on:{"change":_vm.onChange}})],1)],1),_vm._v(" "),_c('span',{staticClass:"base-datetime__placeholder",class:{
        'base-datetime__placeholder--filled': _vm.hasValue,
        'base-datetime__placeholder--has-error': failed,
        'base-datetime__placeholder--disabled': _vm.disabled,
      },on:{"click":_vm.toggleDatetimePicker}},[_vm._v("\n      "+_vm._s(_vm.placeholderOrDefault)+"\n    ")]),_vm._v(" "),_c('DefaBaseInputErrorMessage',_vm._b({directives:[{name:"show",rawName:"v-show",value:(failed),expression:"failed"}],attrs:{"position":_vm.errorMessagePosition}},'DefaBaseInputErrorMessage',ariaMsg,false),[_vm._v("\n      "+_vm._s(errors[0])+"\n    ")])],1)]}}])})};
var __vue_staticRenderFns__$8 = [];

  /* style */
  const __vue_inject_styles__$8 = function (inject) {
    if (!inject) return
    inject("data-v-119b953c_0", { source: ".base-datetime[data-v-119b953c]{display:flex;align-items:center;position:relative}.base-datetime__label[data-v-119b953c]{padding:0 1em;font-weight:700;display:flex;align-items:center;gap:.5em;position:absolute;bottom:100%;transform:translateY(50%);left:2em;background-color:#fff}.base-datetime__label--required[data-v-119b953c]::after{content:\"*\"}.base-datetime__label--disabled[data-v-119b953c]{color:var(--defa-oreon-color-gray-shade-3)}.base-datetime--with-label[data-v-119b953c]{padding:2em;border:1px solid var(--defa-oreon-color-gray-shade-3)}.base-datetime__label.base-datetime__label--has-error[data-v-119b953c]{color:var(--defa-oreon-color-error)}.base-datetime-input:focus-within~.base-input-error-message[data-v-119b953c],.base-datetime-input:focus~.base-input-error-message[data-v-119b953c],.base-datetime-input:hover~.base-input-error-message[data-v-119b953c]{opacity:1;z-index:0}@media (min-width:768px){.base-datetime-input[data-v-119b953c]{position:relative;display:flex;align-items:center}}.base-datetime-input__icon[data-v-119b953c]{cursor:pointer}.base-datetime-input__icon--disabled[data-v-119b953c]{cursor:not-allowed}.base-datetime__icon-calendar-wrapper[data-v-119b953c]{border-color:var(--defa-oreon-color-primary);width:2.5rem;height:2.5rem;cursor:pointer}.base-datetime__icon-calendar-wrapper--filled[data-v-119b953c]{background-color:var(--defa-oreon-color-primary)}.base-datetime__icon-calendar-wrapper--has-error[data-v-119b953c]{border-color:var(--defa-oreon-color-error);background-color:transparent}.base-datetime__icon-calendar-wrapper--disabled[data-v-119b953c]{cursor:not-allowed;border-color:var(--defa-oreon-color-gray-shade-3);background-color:transparent}.base-datetime__icon-calendar[data-v-119b953c]{width:50%}.base-datetime__placeholder[data-v-119b953c]{margin-left:1rem;cursor:pointer;color:var(--defa-oreon-color-gray-shade-3)}.base-datetime__placeholder.base-datetime__placeholder--has-error[data-v-119b953c]{color:var(--defa-oreon-color-error)}.base-datetime__placeholder--filled[data-v-119b953c]{color:var(--defa-oreon-color-primary)}.base-datetime__placeholder--disabled[data-v-119b953c]{color:var(--defa-oreon-color-gray-shade-3);cursor:not-allowed}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$8 = "data-v-119b953c";
  /* module identifier */
  const __vue_module_identifier__$8 = undefined;
  /* functional template */
  const __vue_is_functional_template__$8 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$8 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$8, staticRenderFns: __vue_staticRenderFns__$8 },
    __vue_inject_styles__$8,
    __vue_script__$8,
    __vue_scope_id__$8,
    __vue_is_functional_template__$8,
    __vue_module_identifier__$8,
    false,
    createInjector,
    undefined,
    undefined
  );

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$6(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$6(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$6() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var addTimestampToLine = function addTimestampToLine(value) {
  var _context;

  return _concatInstanceProperty(_context = "".concat(value)).call(_context, formatDateShortWithDots(new Date()), " ");
};

var DefaBaseTextarea = /*#__PURE__*/function (_Vue) {
  _inherits(DefaBaseTextarea, _Vue);

  var _super = _createSuper$6(DefaBaseTextarea);

  function DefaBaseTextarea() {
    var _this;

    _classCallCheck(this, DefaBaseTextarea);

    _this = _super.apply(this, arguments);
    _this.debouncedInput = debounce(function (input) {
      this.onInput(input, "input:debounced");
    }, 300);
    return _this;
  }

  _createClass(DefaBaseTextarea, [{
    key: "onKeyup",
    value: function onKeyup(event) {
      var value = event.target.value;

      if (this.timestampLines && event.key === "Enter") {
        this.$emit("input", addTimestampToLine(event.target.value));
      }

      this.$emit("keyup", value);
    }
  }, {
    key: "onFocus",
    value: function onFocus(event) {
      var value = event.target.value;

      if (this.timestampLines && !value) {
        this.$emit("input", addTimestampToLine(value));
      }

      this.$emit("focus", value);
    }
  }, {
    key: "onInput",
    value: function onInput(event) {
      var eventName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "input";
      this.$emit(eventName, event.target.value);
    }
  }, {
    key: "cssProps",
    get: function get() {
      return {
        "--label-background-color": this.labelBackgroundColor
      };
    }
  }, {
    key: "getRules",
    get: function get() {
      return getRules(this.rules, this.disabled);
    }
  }, {
    key: "hasRequiredRuleAndIsNotDisabled",
    get: function get() {
      if (this.disabled) {
        return false;
      }

      return hasRequiredRule(this.rules);
    }
  }, {
    key: "textareaListeners",
    get: function get() {
      var _this2 = this;

      return _objectSpread(_objectSpread({}, this.$listeners), {}, {
        keyup: this.onKeyup,
        focus: this.onFocus,
        input: function input(event) {
          _this2.debouncedInput(event);

          _this2.onInput(event);
        }
      });
    }
  }, {
    key: "value",
    get: function get() {
      return this.modelValue;
    },
    set: function set(newValue) {
      this.$emit("input", newValue);
    }
  }]);

  return DefaBaseTextarea;
}(Vue$1);

__decorate([Prop({
  required: true,
  type: String
}), __metadata("design:type", String)], DefaBaseTextarea.prototype, "label", void 0);

__decorate([Prop({
  default: null,
  type: String
}), __metadata("design:type", Object)], DefaBaseTextarea.prototype, "modelValue", void 0);

__decorate([Prop({
  default: null,
  type: String
}), __metadata("design:type", Object)], DefaBaseTextarea.prototype, "name", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseTextarea.prototype, "hideLabel", void 0);

__decorate([Prop({
  default: true,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseTextarea.prototype, "enableResizeVertical", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseTextarea.prototype, "enableResizeHorizontal", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseTextarea.prototype, "enableResizeBoth", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseTextarea.prototype, "timestampLines", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseTextarea.prototype, "disabled", void 0);

__decorate([Prop({
  default: 5,
  type: Number
}), __metadata("design:type", Number)], DefaBaseTextarea.prototype, "rows", void 0);

__decorate([Prop({
  default: "white",
  type: String
}), __metadata("design:type", String)], DefaBaseTextarea.prototype, "labelBackgroundColor", void 0);

__decorate([Prop({
  default: null,
  type: [Object, String]
}), __metadata("design:type", Object)], DefaBaseTextarea.prototype, "rules", void 0);

__decorate([Prop({
  default: "top",
  type: String
}), __metadata("design:type", String)], DefaBaseTextarea.prototype, "errorMessagePosition", void 0);

DefaBaseTextarea = __decorate([Component({
  inheritAttrs: false,
  components: {
    DefaBaseInputErrorMessage: __vue_component__$F,
    ValidationProvider: ValidationProvider
  },
  model: {
    prop: "modelValue"
  },
  name: "DefaBaseTextarea"
})], DefaBaseTextarea);
var script$7 = DefaBaseTextarea;

/* script */
const __vue_script__$7 = script$7;

/* template */
var __vue_render__$7 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{style:(_vm.cssProps),attrs:{"tag":"div","name":_vm.name,"rules":_vm.getRules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var failed = ref.failed;
var ariaInput = ref.ariaInput;
var errors = ref.errors;
var ariaMsg = ref.ariaMsg;
return [_c('div',{staticClass:"base-textarea",class:{ 'base-textarea--with-label': !_vm.hideLabel }},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hideLabel),expression:"!hideLabel"}],staticClass:"base-textarea__label",class:{
        'base-textarea__label--disabled': _vm.disabled,
        'base-textarea__label--required': _vm.hasRequiredRuleAndIsNotDisabled,
        'base-textarea__label--has-error': failed,
      },attrs:{"for":_vm.name}},[_vm._v(_vm._s(_vm.label)+"\n    ")]),_vm._v(" "),_c('textarea',_vm._g(_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"base-textarea__textarea",class:{
        'base-textarea__textarea--enable-resize-horizontal': _vm.enableResizeHorizontal,
        'base-textarea__textarea--enable-resize-vertical': _vm.enableResizeVertical,
        'base-textarea__textarea--enable-resize-both': _vm.enableResizeBoth,
        'base-textarea__textarea--has-error': failed,
      },attrs:{"id":_vm.name,"disabled":_vm.disabled,"rows":_vm.rows},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value;}}},'textarea',Object.assign({}, _vm.$attrs,
        ariaInput),false),_vm.textareaListeners)),_vm._v(" "),_c('DefaBaseInputErrorMessage',_vm._b({directives:[{name:"show",rawName:"v-show",value:(failed),expression:"failed"}],attrs:{"position":_vm.errorMessagePosition}},'DefaBaseInputErrorMessage',ariaMsg,false),[_vm._v("\n      "+_vm._s(errors[0])+"\n    ")])],1)]}}])})};
var __vue_staticRenderFns__$7 = [];

  /* style */
  const __vue_inject_styles__$7 = function (inject) {
    if (!inject) return
    inject("data-v-16b08a98_0", { source: ".base-textarea__label[data-v-16b08a98]{padding:0 1em;font-weight:700;display:flex;align-items:center;gap:.5em;position:absolute;bottom:100%;transform:translateY(50%);left:2em;background-color:#fff}.base-textarea__label--required[data-v-16b08a98]::after{content:\"*\"}.base-textarea__label--disabled[data-v-16b08a98]{color:var(--defa-oreon-color-gray-shade-3)}.base-textarea--with-label[data-v-16b08a98]{position:relative;padding:2em;border:1px solid var(--defa-oreon-color-gray-shade-3)}.base-textarea:focus-within .base-textarea__label[data-v-16b08a98]{color:var(--defa-oreon-color-primary)}.base-textarea__label[data-v-16b08a98]{background-color:var(--label-background-color)}.base-textarea__label.base-textarea__label--has-error[data-v-16b08a98]{color:var(--defa-oreon-color-error)}.base-textarea__textarea[data-v-16b08a98]{padding:.75em;border-radius:2px;opacity:1;outline:0;resize:none;width:100%}.base-textarea__textarea[data-v-16b08a98]:focus{border-color:var(--defa-oreon-color-primary)}.base-textarea__textarea.base-textarea__textarea--has-error[data-v-16b08a98]{border-color:var(--defa-oreon-color-error)}.base-textarea__textarea:focus-within~.base-input-error-message[data-v-16b08a98],.base-textarea__textarea:focus~.base-input-error-message[data-v-16b08a98],.base-textarea__textarea:hover~.base-input-error-message[data-v-16b08a98]{opacity:1;z-index:0}.base-textarea__textarea[data-v-16b08a98]:disabled{color:var(--defa-oreon-color-gray-shade-3)}.base-textarea__textarea--enable-resize-horizontal[data-v-16b08a98]{resize:horizontal}.base-textarea__textarea--enable-resize-vertical[data-v-16b08a98]{resize:vertical}.base-textarea__textarea--enable-resize-both[data-v-16b08a98]{resize:both}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$7 = "data-v-16b08a98";
  /* module identifier */
  const __vue_module_identifier__$7 = undefined;
  /* functional template */
  const __vue_is_functional_template__$7 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$7 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
    __vue_inject_styles__$7,
    __vue_script__$7,
    __vue_scope_id__$7,
    __vue_is_functional_template__$7,
    __vue_module_identifier__$7,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$5(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$5(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// This will break validation and seems to be a bug with vee-validate

var DefaBaseBorderedArea = /*#__PURE__*/function (_Vue) {
  _inherits(DefaBaseBorderedArea, _Vue);

  var _super = _createSuper$5(DefaBaseBorderedArea);

  function DefaBaseBorderedArea() {
    _classCallCheck(this, DefaBaseBorderedArea);

    return _super.apply(this, arguments);
  }

  _createClass(DefaBaseBorderedArea, [{
    key: "mounted",
    value: function mounted() {
      if (!this.$slots.content) {
        console.error("DefaBaseBorderedArea: Slot 'content' is required!");
      }
    }
  }, {
    key: "labelStyle",
    get: function get() {
      return {
        color: this.labelColor,
        backgroundColor: this.labelBackgroundColor
      };
    }
  }]);

  return DefaBaseBorderedArea;
}(Vue$1);

__decorate([Prop({
  default: "div",
  type: String
}), __metadata("design:type", String)], DefaBaseBorderedArea.prototype, "tag", void 0);

__decorate([Prop({
  default: "inherit",
  type: String
}), __metadata("design:type", String)], DefaBaseBorderedArea.prototype, "labelColor", void 0);

__decorate([Prop({
  default: "white",
  type: String
}), __metadata("design:type", String)], DefaBaseBorderedArea.prototype, "labelBackgroundColor", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseBorderedArea.prototype, "overflow", void 0);

DefaBaseBorderedArea = __decorate([Component({
  name: "DefaBaseBorderedArea"
})], DefaBaseBorderedArea);
var script$6 = DefaBaseBorderedArea;

/* script */
const __vue_script__$6 = script$6;

/* template */
var __vue_render__$6 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-bordered-area"},[_c('div',{class:{ 'overflow-container': _vm.overflow }},[(_vm.$slots.label)?_c('div',{staticClass:"base-bordered-area__label",style:(_vm.labelStyle)},[_vm._t("label")],2):_vm._e(),_vm._v(" "),_vm._t("content")],2)])};
var __vue_staticRenderFns__$6 = [];

  /* style */
  const __vue_inject_styles__$6 = function (inject) {
    if (!inject) return
    inject("data-v-1599e8ef_0", { source: ".base-bordered-area[data-v-1599e8ef]{position:relative;padding:2em;border:1px solid var(--defa-oreon-color-gray-shade-3)}.overflow-container[data-v-1599e8ef]{overflow-x:auto}.base-bordered-area__label[data-v-1599e8ef]{position:absolute;bottom:100%;transform:translateY(50%);left:2em;padding:0 1em;font-weight:700}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$6 = "data-v-1599e8ef";
  /* module identifier */
  const __vue_module_identifier__$6 = undefined;
  /* functional template */
  const __vue_is_functional_template__$6 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$6 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
    __vue_inject_styles__$6,
    __vue_script__$6,
    __vue_scope_id__$6,
    __vue_is_functional_template__$6,
    __vue_module_identifier__$6,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$5 = {
  name: "DefaBaseCard",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    hoverEffectColor: {
      type: String,
      default: "white"
    }
  }
};

/* script */
const __vue_script__$5 = script$5;

/* template */
var __vue_render__$5 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"defa-base-card",style:({ '--hover-effect-color': _vm.hoverEffectColor }),on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)};
var __vue_staticRenderFns__$5 = [];

  /* style */
  const __vue_inject_styles__$5 = function (inject) {
    if (!inject) return
    inject("data-v-7b001172_0", { source: ".defa-base-card{padding:1em;border:1px solid var(--defa-oreon-color-black);border-radius:4px;cursor:pointer;background-color:#fff;position:relative;box-shadow:0 .125rem .25rem var(--hover-effect-color)}.defa-base-card::after{content:\"\";position:absolute;top:0;left:0;right:0;bottom:0;box-shadow:0 .5rem 2rem var(--hover-effect-color);opacity:0;transition:opacity .5s ease;z-index:-1}.defa-base-card:hover::after{opacity:1}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$5 = undefined;
  /* module identifier */
  const __vue_module_identifier__$5 = undefined;
  /* functional template */
  const __vue_is_functional_template__$5 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$5 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
    __vue_inject_styles__$5,
    __vue_script__$5,
    __vue_scope_id__$5,
    __vue_is_functional_template__$5,
    __vue_module_identifier__$5,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaBaseDurationInput = /*#__PURE__*/function (_Vue) {
  _inherits(DefaBaseDurationInput, _Vue);

  var _super = _createSuper$4(DefaBaseDurationInput);

  function DefaBaseDurationInput() {
    var _this;

    _classCallCheck(this, DefaBaseDurationInput);

    _this = _super.apply(this, arguments);
    _this.model = {
      hours: 0,
      minutes: 0
    };
    return _this;
  }

  _createClass(DefaBaseDurationInput, [{
    key: "onInputHours",
    value: function onInputHours(value) {
      this.model.hours = +value;
      this.onInput();
    }
  }, {
    key: "onInputMinutes",
    value: function onInputMinutes(value) {
      this.model.minutes = +value;
      this.onInput();
    }
  }, {
    key: "onInput",
    value: function () {
      var _onInput = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$emit("input", this.valueHoursAndMinutesCombined);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onInput() {
        return _onInput.apply(this, arguments);
      }

      return onInput;
    }()
  }, {
    key: "valueHoursAndMinutesCombined",
    get: function get() {
      return (this.model.hours || 0) * 60 + (this.model.minutes || 0);
    }
  }]);

  return DefaBaseDurationInput;
}(Vue$1);

__decorate([Prop({
  required: true,
  type: Number
}), __metadata("design:type", Number)], DefaBaseDurationInput.prototype, "modelValue", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseDurationInput.prototype, "disabled", void 0);

DefaBaseDurationInput = __decorate([Component({
  model: {
    prop: "modelValue"
  },
  name: "DefaBaseDurationInput",
  components: {
    DefaBaseInput: __vue_component__$B
  }
})], DefaBaseDurationInput);
var script$4 = DefaBaseDurationInput;

/* script */
const __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-duration-input"},[_c('DefaBaseInput',{staticClass:"base-duration-input__input",attrs:{"model-value":_vm.model.hours,"label":_vm.$t('defaBaseDurationInput.characterHours'),"min":"0","max":"99","type":"number"},on:{"input":_vm.onInputHours}}),_vm._v(" "),_c('DefaBaseInput',{staticClass:"base-duration-input__input",attrs:{"model-value":_vm.model.minutes,"disabled":_vm.disabled,"label":_vm.$t('defaBaseDurationInput.characterMinutes'),"min":"0","max":"59","step":"15","type":"number"},on:{"input":_vm.onInputMinutes}})],1)};
var __vue_staticRenderFns__$4 = [];

  /* style */
  const __vue_inject_styles__$4 = function (inject) {
    if (!inject) return
    inject("data-v-05c70be2_0", { source: ".base-duration-input[data-v-05c70be2]{display:flex;gap:1rem}.base-duration-input__input[data-v-05c70be2]{flex-basis:6rem}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$4 = "data-v-05c70be2";
  /* module identifier */
  const __vue_module_identifier__$4 = undefined;
  /* functional template */
  const __vue_is_functional_template__$4 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$4 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * We can't add <ValidationProvider> within DefaBaseDurationInput as we need to emit a "single" @input event from the component
 * Hence we have this intermediate component that will handle validation for us while having DefaBaseDurationInput as a single child component
 */

var DefaBaseDurationInputWithValidation = /*#__PURE__*/function (_Vue) {
  _inherits(DefaBaseDurationInputWithValidation, _Vue);

  var _super = _createSuper$3(DefaBaseDurationInputWithValidation);

  function DefaBaseDurationInputWithValidation() {
    _classCallCheck(this, DefaBaseDurationInputWithValidation);

    return _super.apply(this, arguments);
  }

  _createClass(DefaBaseDurationInputWithValidation, [{
    key: "getRules",
    get: function get() {
      return getRules(this.rules, this.disabled);
    }
  }, {
    key: "value",
    get: function get() {
      return this.modelValue;
    },
    set: function set(value) {
      this.validationProvider.validate(value);
      this.$emit("input", value);
    }
  }]);

  return DefaBaseDurationInputWithValidation;
}(Vue$1);

__decorate([Prop({
  required: true,
  type: Number
}), __metadata("design:type", Number)], DefaBaseDurationInputWithValidation.prototype, "modelValue", void 0);

__decorate([Prop({
  required: true,
  type: String
}), __metadata("design:type", String)], DefaBaseDurationInputWithValidation.prototype, "name", void 0);

__decorate([Prop({
  default: null,
  type: [Object, String]
}), __metadata("design:type", Object)], DefaBaseDurationInputWithValidation.prototype, "rules", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseDurationInputWithValidation.prototype, "disabled", void 0);

__decorate([Prop({
  default: null,
  type: Object
}), __metadata("design:type", Object)], DefaBaseDurationInputWithValidation.prototype, "customMessages", void 0);

__decorate([Prop({
  default: "top",
  type: String
}), __metadata("design:type", String)], DefaBaseDurationInputWithValidation.prototype, "errorMessagePosition", void 0);

__decorate([Ref(), __metadata("design:type", void 0)], DefaBaseDurationInputWithValidation.prototype, "validationProvider", void 0);

DefaBaseDurationInputWithValidation = __decorate([Component({
  model: {
    prop: "modelValue"
  },
  name: "DefaBaseDurationInputWithValidation",
  components: {
    ValidationProvider: ValidationProvider,
    DefaBaseDurationInput: __vue_component__$4,
    DefaBaseInputErrorMessage: __vue_component__$F
  }
})], DefaBaseDurationInputWithValidation);
var script$3 = DefaBaseDurationInputWithValidation;

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{ref:"validationProvider",staticClass:"base-duration-input-with-validation",attrs:{"tag":"div","name":_vm.name,"rules":_vm.getRules,"custom-messages":_vm.customMessages},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var failed = ref.failed;
var errors = ref.errors;
var ariaMsg = ref.ariaMsg;
return [_c('DefaBaseDurationInput',{staticClass:"base-duration-input-with-validation__input",class:{
      'base-duration-input-with-validation__input--has-error': failed,
    },attrs:{"disabled":_vm.disabled},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v;},expression:"value"}}),_vm._v(" "),_c('DefaBaseInputErrorMessage',_vm._b({directives:[{name:"show",rawName:"v-show",value:(failed),expression:"failed"}],attrs:{"position":_vm.errorMessagePosition}},'DefaBaseInputErrorMessage',ariaMsg,false),[_vm._v("\n    "+_vm._s(errors[0])+"\n  ")])]}}])})};
var __vue_staticRenderFns__$3 = [];

  /* style */
  const __vue_inject_styles__$3 = function (inject) {
    if (!inject) return
    inject("data-v-4141f2bf_0", { source: ".base-duration-input-with-validation[data-v-4141f2bf]{position:relative}.base-duration-input-with-validation__input:focus-within~.base-input-error-message[data-v-4141f2bf],.base-duration-input-with-validation__input:focus~.base-input-error-message[data-v-4141f2bf],.base-duration-input-with-validation__input:hover~.base-input-error-message[data-v-4141f2bf]{opacity:1;z-index:0}.base-duration-input-with-validation__input--has-error[data-v-4141f2bf]  .base-input__input{border-color:var(--defa-oreon-color-error)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$3 = "data-v-4141f2bf";
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$3 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaBaseCheckboxMulti = /*#__PURE__*/function (_Vue) {
  _inherits(DefaBaseCheckboxMulti, _Vue);

  var _super = _createSuper$2(DefaBaseCheckboxMulti);

  function DefaBaseCheckboxMulti() {
    _classCallCheck(this, DefaBaseCheckboxMulti);

    return _super.apply(this, arguments);
  }

  _createClass(DefaBaseCheckboxMulti, [{
    key: "onClickCheckAll",
    value: function onClickCheckAll() {
      this.$emit("change", this.options);
    }
  }, {
    key: "onClickUncheckAll",
    value: function onClickUncheckAll() {
      this.$emit("change", []);
    }
  }, {
    key: "onChange",
    value: function onChange(option, checked) {
      var _context, _context3;

      // Checkbox ticked
      if (!_includesInstanceProperty(_context = this.modelValue).call(_context, option) && checked) {
        var _context2;

        this.$emit("change", _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(this.modelValue), [option]));
        return;
      } // Checkbox unticked


      if (_includesInstanceProperty(_context3 = this.modelValue).call(_context3, option) && !checked) {
        var _context4;

        this.$emit("change", _filterInstanceProperty(_context4 = this.modelValue).call(_context4, function (modelStatus) {
          return modelStatus !== option;
        }));
      }
    }
  }, {
    key: "isChecked",
    get: function get() {
      var _this = this;

      return function (option) {
        var _context5;

        return _includesInstanceProperty(_context5 = _this.modelValue).call(_context5, option);
      };
    }
  }]);

  return DefaBaseCheckboxMulti;
}(Vue$1);

__decorate([Prop({
  required: true,
  type: Array
}), __metadata("design:type", Array)], DefaBaseCheckboxMulti.prototype, "modelValue", void 0);

__decorate([Prop({
  required: true,
  type: Array
}), __metadata("design:type", Array)], DefaBaseCheckboxMulti.prototype, "options", void 0);

__decorate([Prop({
  required: true,
  type: String
}), __metadata("design:type", String)], DefaBaseCheckboxMulti.prototype, "label", void 0);

__decorate([Prop({
  default: false,
  type: Boolean
}), __metadata("design:type", Boolean)], DefaBaseCheckboxMulti.prototype, "includeMultiCheck", void 0);

__decorate([Prop({
  default: "inherit",
  type: String
}), __metadata("design:type", String)], DefaBaseCheckboxMulti.prototype, "labelColor", void 0);

__decorate([Prop({
  default: "white",
  type: String
}), __metadata("design:type", String)], DefaBaseCheckboxMulti.prototype, "labelBackgroundColor", void 0);

DefaBaseCheckboxMulti = __decorate([Component({
  components: {
    DefaBaseCheckbox: __vue_component__$E,
    DefaBaseButton: __vue_component__$P,
    DefaBaseBorderedArea: __vue_component__$6
  },
  model: {
    prop: "modelValue",
    event: "change"
  }
})], DefaBaseCheckboxMulti);
var script$2 = DefaBaseCheckboxMulti;

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaBaseBorderedArea',{attrs:{"label-color":_vm.labelColor,"label-background-color":_vm.labelBackgroundColor},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._v(_vm._s(_vm.label))]},proxy:true},{key:"content",fn:function(){return [(_vm.includeMultiCheck)?_c('div',{staticClass:"multi-check-container"},[_c('DefaBaseButton',{attrs:{"secondary":"","type":"button"},on:{"click":_vm.onClickCheckAll}},[_vm._v("\n        "+_vm._s(_vm.$t("defaBaseCheckboxMulti.checkAll"))+"\n      ")]),_vm._v(" "),_c('DefaBaseButton',{attrs:{"secondary":"","type":"button"},on:{"click":_vm.onClickUncheckAll}},[_vm._v("\n        "+_vm._s(_vm.$t("defaBaseCheckboxMulti.uncheckAll"))+"\n      ")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"checkboxes"},_vm._l((_vm.options),function(option){return _c('DefaBaseCheckbox',{key:option,attrs:{"model-value":_vm.isChecked(option)},on:{"change":function($event){return _vm.onChange(option, $event)}}},[_vm._t("default",function(){return [_vm._v("\n          "+_vm._s(option)+"\n        ")]},{"checked":_vm.isChecked(option),"option":option})],2)}),1)]},proxy:true}],null,true)})};
var __vue_staticRenderFns__$2 = [];

  /* style */
  const __vue_inject_styles__$2 = function (inject) {
    if (!inject) return
    inject("data-v-acd6df56_0", { source: ".checkboxes{display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));align-items:center;gap:1rem}.multi-check-container{margin-bottom:2rem;display:flex;justify-content:flex-end;gap:1rem}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaBaseDropzone = /*#__PURE__*/function (_Vue) {
  _inherits(DefaBaseDropzone, _Vue);

  var _super = _createSuper$1(DefaBaseDropzone);

  function DefaBaseDropzone() {
    var _this;

    _classCallCheck(this, DefaBaseDropzone);

    _this = _super.apply(this, arguments);
    _this.isDestroying = false; // See https://github.com/rowanwins/vue-dropzone/issues/85

    return _this;
  }

  _createClass(DefaBaseDropzone, [{
    key: "created",
    value: function created() {
      this.dropzoneOptions = {
        url: this.uploadUrl,
        acceptedFiles: this.acceptedFiles,
        addRemoveLinks: true,
        createImageThumbnails: true,
        dictCancelUpload: this.$t("defaDropzone.uploadCancel"),
        dictUploadCanceled: this.$t("defaDropzone.uploadCancelled"),
        dictRemoveFile: this.$t("defaDropzone.uploadFileRemove"),
        dictCancelUploadConfirmation: this.$t("defaDropzone.uploadCancelConfirmation"),
        dictInvalidFileType: this.$t("defaDropzone.wrongFile"),
        dictFileTooBig: this.$t("defaDropzone.fileTooBig"),
        resizeWidth: 2000,
        resizeQuality: 0.6,
        maxFilesize: 20,
        headers: {
          authorization: "Secret ".concat(this.orderSecret)
        }
      };
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      this.isDestroying = true;
    }
  }, {
    key: "onDropzoneSuccess",
    value: function () {
      var _onDropzoneSuccess = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file, _ref) {
        var _context;

        var id;
        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                id = _ref.id;
                this.value = _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(this.value), [{
                  id: id,
                  uuid: file.upload.uuid
                }]);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee, this);
      }));

      function onDropzoneSuccess(_x, _x2) {
        return _onDropzoneSuccess.apply(this, arguments);
      }

      return onDropzoneSuccess;
    }()
  }, {
    key: "onDropzoneRemovedFile",
    value: function onDropzoneRemovedFile(_ref2) {
      var upload = _ref2.upload;

      if (!this.isDestroying) {
        var _this$value$find, _context3;

        var id = (_this$value$find = _findInstanceProperty(_context3 = this.value).call(_context3, function (file) {
          return file.uuid === upload.uuid;
        })) === null || _this$value$find === void 0 ? void 0 : _this$value$find.id;

        if (id) {
          var _context4;

          this.value = _filterInstanceProperty(_context4 = this.value).call(_context4, function (file) {
            return file.id !== id;
          });
        }
      }
    }
  }, {
    key: "onDropzoneMounted",
    value: function onDropzoneMounted() {
      var _context5,
          _this2 = this;

      _forEachInstanceProperty(_context5 = this.value).call(_context5, function (file) {
        // Temporary solution to at least show that some file was added. Fix this once we can query files by ID from the backend
        _this2.dropzone.manuallyAddFile({
          upload: {
            uuid: file.uuid
          }
        }, "");
      });
    }
  }, {
    key: "cssProps",
    get: function get() {
      return {
        "--secondary-color": this.secondaryColor
      };
    }
  }, {
    key: "value",
    get: function get() {
      return this.modelValue;
    },
    set: function set(files) {
      this.$emit("change", files);
    }
  }]);

  return DefaBaseDropzone;
}(Vue$1);

__decorate([Prop({
  required: true,
  type: String
}), __metadata("design:type", String)], DefaBaseDropzone.prototype, "id", void 0);

__decorate([Prop({
  required: true,
  type: String
}), __metadata("design:type", String)], DefaBaseDropzone.prototype, "orderSecret", void 0);

__decorate([Prop({
  required: true,
  type: String
}), __metadata("design:type", String)], DefaBaseDropzone.prototype, "uploadUrl", void 0);

__decorate([Prop({
  required: true,
  type: String
}), __metadata("design:type", String)], DefaBaseDropzone.prototype, "secondaryColor", void 0);

__decorate([Prop({
  default: function _default() {
    return [];
  },
  type: Array
}), __metadata("design:type", Array)], DefaBaseDropzone.prototype, "modelValue", void 0);

__decorate([Prop({
  default: null,
  type: String
}), __metadata("design:type", String)], DefaBaseDropzone.prototype, "acceptedFiles", void 0);

__decorate([Ref(), __metadata("design:type", Object)], DefaBaseDropzone.prototype, "dropzone", void 0);

DefaBaseDropzone = __decorate([Component({
  components: {
    VueDropzone: VueDropzone,
    DefaIconUpload: __vue_component__$x
  },
  name: "DefaBaseDropzone",
  model: {
    event: "change",
    prop: "modelValue"
  }
})], DefaBaseDropzone);
var script$1 = DefaBaseDropzone;

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueDropzone',{ref:"dropzone",staticClass:"base-dropzone",style:(_vm.cssProps),attrs:{"id":_vm.id,"options":_vm.dropzoneOptions,"use-custom-slot":""},on:{"vdropzone-success":_vm.onDropzoneSuccess,"vdropzone-removed-file":_vm.onDropzoneRemovedFile,"vdropzone-mounted":_vm.onDropzoneMounted}},[_c('DefaIconUpload'),_vm._v(" "),_c('div',{staticClass:"upload-subtext"},[_vm._v("\n    "+_vm._s(_vm.$t("defaDropzone.uploadSubtext"))+"\n  ")])],1)};
var __vue_staticRenderFns__$1 = [];

  /* style */
  const __vue_inject_styles__$1 = function (inject) {
    if (!inject) return
    inject("data-v-6a3ba1cc_0", { source: "@-webkit-keyframes passing-through{0%{opacity:0;transform:translateY(40px)}30%,70%{opacity:1;transform:translateY(0)}100%{opacity:0;transform:translateY(-40px)}}@keyframes passing-through{0%{opacity:0;transform:translateY(40px)}30%,70%{opacity:1;transform:translateY(0)}100%{opacity:0;transform:translateY(-40px)}}@-webkit-keyframes slide-in{0%{opacity:0;transform:translateY(40px)}30%{opacity:1;transform:translateY(0)}}@keyframes slide-in{0%{opacity:0;transform:translateY(40px)}30%{opacity:1;transform:translateY(0)}}@-webkit-keyframes pulse{0%{transform:scale(1)}10%{transform:scale(1.1)}20%{transform:scale(1)}}@keyframes pulse{0%{transform:scale(1)}10%{transform:scale(1.1)}20%{transform:scale(1)}}.dropzone,.dropzone *{box-sizing:border-box}.dropzone{min-height:150px;border:2px solid rgba(0,0,0,.3);background:#fff;padding:20px 20px}.dropzone.dz-clickable{cursor:pointer}.dropzone.dz-clickable *{cursor:default}.dropzone.dz-clickable .dz-message,.dropzone.dz-clickable .dz-message *{cursor:pointer}.dropzone.dz-started .dz-message{display:none}.dropzone.dz-drag-hover{border-style:solid}.dropzone.dz-drag-hover .dz-message{opacity:.5}.dropzone .dz-message{text-align:center;margin:2em 0}.dropzone .dz-preview{position:relative;display:inline-block;vertical-align:top;margin:16px;min-height:100px}.dropzone .dz-preview:hover{z-index:1000}.dropzone .dz-preview:hover .dz-details{opacity:1}.dropzone .dz-preview.dz-file-preview .dz-image{border-radius:20px;background:#999;background:linear-gradient(to bottom,#eee,#ddd)}.dropzone .dz-preview.dz-file-preview .dz-details{opacity:1}.dropzone .dz-preview.dz-image-preview{background:#fff}.dropzone .dz-preview.dz-image-preview .dz-details{transition:opacity .2s linear}.dropzone .dz-preview .dz-remove{font-size:14px;text-align:center;display:block;cursor:pointer;border:none}.dropzone .dz-preview .dz-remove:hover{text-decoration:underline}.dropzone .dz-preview:hover .dz-details{opacity:1}.dropzone .dz-preview .dz-details{z-index:20;position:absolute;top:0;left:0;opacity:0;font-size:13px;min-width:100%;max-width:100%;padding:2em 1em;text-align:center;color:rgba(0,0,0,.9);line-height:150%}.dropzone .dz-preview .dz-details .dz-size{margin-bottom:1em;font-size:16px}.dropzone .dz-preview .dz-details .dz-filename{white-space:nowrap}.dropzone .dz-preview .dz-details .dz-filename:hover span{border:1px solid rgba(200,200,200,.8);background-color:rgba(255,255,255,.8)}.dropzone .dz-preview .dz-details .dz-filename:not(:hover){overflow:hidden;text-overflow:ellipsis}.dropzone .dz-preview .dz-details .dz-filename:not(:hover) span{border:1px solid transparent}.dropzone .dz-preview .dz-details .dz-filename span,.dropzone .dz-preview .dz-details .dz-size span{background-color:rgba(255,255,255,.4);padding:0 .4em;border-radius:3px}.dropzone .dz-preview:hover .dz-image img{transform:scale(1.05,1.05);filter:blur(8px)}.dropzone .dz-preview .dz-image{border-radius:20px;overflow:hidden;width:120px;height:120px;position:relative;display:block;z-index:10}.dropzone .dz-preview .dz-image img{display:block}.dropzone .dz-preview.dz-success .dz-success-mark{-webkit-animation:passing-through 3s cubic-bezier(.77,0,.175,1);animation:passing-through 3s cubic-bezier(.77,0,.175,1)}.dropzone .dz-preview.dz-error .dz-error-mark{opacity:1;-webkit-animation:slide-in 3s cubic-bezier(.77,0,.175,1);animation:slide-in 3s cubic-bezier(.77,0,.175,1)}.dropzone .dz-preview .dz-error-mark,.dropzone .dz-preview .dz-success-mark{pointer-events:none;opacity:0;z-index:500;position:absolute;display:block;top:50%;left:50%;margin-left:-27px;margin-top:-27px}.dropzone .dz-preview .dz-error-mark svg,.dropzone .dz-preview .dz-success-mark svg{display:block;width:54px;height:54px}.dropzone .dz-preview.dz-processing .dz-progress{opacity:1;transition:all .2s linear}.dropzone .dz-preview.dz-complete .dz-progress{opacity:0;transition:opacity .4s ease-in}.dropzone .dz-preview:not(.dz-processing) .dz-progress{-webkit-animation:pulse 6s ease infinite;animation:pulse 6s ease infinite}.dropzone .dz-preview .dz-progress{opacity:1;z-index:1000;pointer-events:none;position:absolute;height:16px;left:50%;top:50%;margin-top:-8px;width:80px;margin-left:-40px;background:rgba(255,255,255,.9);-webkit-transform:scale(1);border-radius:8px;overflow:hidden}.dropzone .dz-preview .dz-progress .dz-upload{background:#333;background:linear-gradient(to bottom,#666,#444);position:absolute;top:0;left:0;bottom:0;width:0;transition:width .3s ease-in-out}.dropzone .dz-preview.dz-error .dz-error-message{display:block}.dropzone .dz-preview.dz-error:hover .dz-error-message{opacity:1;pointer-events:auto}.dropzone .dz-preview .dz-error-message{pointer-events:none;z-index:1000;position:absolute;display:block;display:none;opacity:0;transition:opacity .3s ease;border-radius:8px;font-size:13px;top:130px;left:-10px;width:140px;background:#be2626;background:linear-gradient(to bottom,#be2626,#a92222);padding:.5em 1.2em;color:#fff}.dropzone .dz-preview .dz-error-message:after{content:\"\";position:absolute;top:-6px;left:64px;width:0;height:0;border-left:6px solid transparent;border-right:6px solid transparent;border-bottom:6px solid #be2626}.vue-dropzone{border:2px solid #e5e5e5;font-family:Arial,sans-serif;letter-spacing:.2px;color:#777;transition:.2s linear}.vue-dropzone:hover{background-color:#f6f6f6}.vue-dropzone>i{color:#ccc}.vue-dropzone>.dz-preview .dz-image{border-radius:0;width:100%;height:100%}.vue-dropzone>.dz-preview .dz-image img:not([src]){width:200px;height:200px}.vue-dropzone>.dz-preview .dz-image:hover img{transform:none;-webkit-filter:none}.vue-dropzone>.dz-preview .dz-details{bottom:0;top:0;color:#fff;background-color:rgba(33,150,243,.8);transition:opacity .2s linear;text-align:left}.vue-dropzone>.dz-preview .dz-details .dz-filename{overflow:hidden}.vue-dropzone>.dz-preview .dz-details .dz-filename span,.vue-dropzone>.dz-preview .dz-details .dz-size span{background-color:transparent}.vue-dropzone>.dz-preview .dz-details .dz-filename:not(:hover) span{border:none}.vue-dropzone>.dz-preview .dz-details .dz-filename:hover span{background-color:transparent;border:none}.vue-dropzone>.dz-preview .dz-progress .dz-upload{background:#ccc}.vue-dropzone>.dz-preview .dz-remove{position:absolute;z-index:30;color:#fff;margin-left:15px;padding:10px;top:inherit;bottom:15px;border:2px #fff solid;text-decoration:none;text-transform:uppercase;font-size:.8rem;font-weight:800;letter-spacing:1.1px;opacity:0}.vue-dropzone>.dz-preview:hover .dz-remove{opacity:1}.vue-dropzone>.dz-preview .dz-error-mark,.vue-dropzone>.dz-preview .dz-success-mark{margin-left:auto;margin-top:auto;width:100%;top:35%;left:0}.vue-dropzone>.dz-preview .dz-error-mark svg,.vue-dropzone>.dz-preview .dz-success-mark svg{margin-left:auto;margin-right:auto}.vue-dropzone>.dz-preview .dz-error-message{margin-left:auto;margin-right:auto;left:0;width:100%;text-align:center}.vue-dropzone>.dz-preview .dz-error-message:after{display:none}.base-dropzone{background-color:var(--secondary-color);border:none;border-radius:1rem}.base-dropzone .dz-preview .dz-details{color:#fff;background-color:var(--defa-oreon-color-primary)}.base-dropzone .dz-preview .dz-remove{color:var(--defa-oreon-color-primary);border-color:var(--secondary-color);background-color:var(--secondary-color)}.base-dropzone .dz-preview .dz-error-message{top:100%}.upload-subtext{color:var(--defa-oreon-color-primary);margin-top:.5rem}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    createInjector,
    undefined,
    undefined
  );

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * We can't add <ValidationProvider> within DefaDropzone as we need to emit a @change or @input event from the component
 * Hence we have this intermediate component that will handle validation for us while having DefaDropzone emit a @change event
 */

var DefaBaseDropzoneWithValidation = /*#__PURE__*/function (_Vue) {
  _inherits(DefaBaseDropzoneWithValidation, _Vue);

  var _super = _createSuper(DefaBaseDropzoneWithValidation);

  function DefaBaseDropzoneWithValidation() {
    _classCallCheck(this, DefaBaseDropzoneWithValidation);

    return _super.apply(this, arguments);
  }

  _createClass(DefaBaseDropzoneWithValidation, [{
    key: "onChange",
    value: function onChange(files) {
      this.validationProvider.validate(files);
      this.$emit("change", files);
    }
  }, {
    key: "dropzoneColorPrimary",
    get: function get() {
      return function (failed) {
        return failed ? "var(--defa-oreon-color-error)" : "var(--defa-oreon-color-primary)";
      };
    }
  }, {
    key: "idOrName",
    get: function get() {
      return this.id || this.name;
    }
  }]);

  return DefaBaseDropzoneWithValidation;
}(Vue$1);

__decorate([Prop({
  required: true
}), __metadata("design:type", String)], DefaBaseDropzoneWithValidation.prototype, "name", void 0);

__decorate([Prop({
  required: true
}), __metadata("design:type", String)], DefaBaseDropzoneWithValidation.prototype, "orderSecret", void 0);

__decorate([Prop({
  required: true
}), __metadata("design:type", String)], DefaBaseDropzoneWithValidation.prototype, "uploadUrl", void 0);

__decorate([Prop({
  required: true
}), __metadata("design:type", String)], DefaBaseDropzoneWithValidation.prototype, "secondaryColor", void 0);

__decorate([Prop({
  default: function _default() {
    return [];
  }
}), __metadata("design:type", Array)], DefaBaseDropzoneWithValidation.prototype, "modelValue", void 0);

__decorate([Prop({
  default: ""
}), __metadata("design:type", String)], DefaBaseDropzoneWithValidation.prototype, "id", void 0);

__decorate([Prop({
  default: null
}), __metadata("design:type", String)], DefaBaseDropzoneWithValidation.prototype, "acceptedFiles", void 0);

__decorate([Prop({
  default: null,
  type: [Object, String]
}), __metadata("design:type", Object)], DefaBaseDropzoneWithValidation.prototype, "rules", void 0);

__decorate([Prop({
  default: "top",
  type: String
}), __metadata("design:type", String)], DefaBaseDropzoneWithValidation.prototype, "errorMessagePosition", void 0);

__decorate([Ref(), __metadata("design:type", void 0)], DefaBaseDropzoneWithValidation.prototype, "validationProvider", void 0);

DefaBaseDropzoneWithValidation = __decorate([Component({
  components: {
    ValidationProvider: ValidationProvider,
    DefaBaseInputErrorMessage: __vue_component__$F,
    DefaBaseDropzone: __vue_component__$1
  },
  name: "DefaBaseDropzoneWithValidation",
  model: {
    prop: "modelValue",
    event: "change"
  }
})], DefaBaseDropzoneWithValidation);
var script = DefaBaseDropzoneWithValidation;

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{ref:"validationProvider",staticClass:"base-dropzone-with-validation",attrs:{"tag":"div","rules":_vm.rules,"name":_vm.name},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var failed = ref.failed;
var errors = ref.errors;
var ariaMsg = ref.ariaMsg;
return [_c('DefaBaseDropzone',{staticClass:"base-dropzone-with-validation__dropzone",attrs:{"id":_vm.name,"order-secret":_vm.orderSecret,"upload-url":_vm.uploadUrl,"color-primary":_vm.dropzoneColorPrimary(failed),"secondary-color":_vm.secondaryColor,"model-value":_vm.modelValue,"accepted-files":_vm.acceptedFiles},on:{"change":_vm.onChange}}),_vm._v(" "),_c('DefaBaseInputErrorMessage',_vm._b({directives:[{name:"show",rawName:"v-show",value:(failed),expression:"failed"}],attrs:{"position":_vm.errorMessagePosition}},'DefaBaseInputErrorMessage',ariaMsg,false),[_vm._v("\n    "+_vm._s(errors[0])+"\n  ")])]}}])})};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-69884dae_0", { source: ".base-dropzone-with-validation[data-v-69884dae]{position:relative}.base-dropzone-with-validation__dropzone:focus-within~.base-input-error-message[data-v-69884dae],.base-dropzone-with-validation__dropzone:focus~.base-input-error-message[data-v-69884dae],.base-dropzone-with-validation__dropzone:hover~.base-input-error-message[data-v-69884dae]{opacity:1;z-index:0}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-69884dae";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export { __vue_component__$13 as DefaAlertHeader, __vue_component__$M as DefaBackendErrorMessages, __vue_component__$6 as DefaBaseBorderedArea, __vue_component__$P as DefaBaseButton, __vue_component__$5 as DefaBaseCard, __vue_component__$E as DefaBaseCheckbox, __vue_component__$2 as DefaBaseCheckboxMulti, __vue_component__$8 as DefaBaseDatetimeInput, __vue_component__$1 as DefaBaseDropzone, __vue_component__ as DefaBaseDropzoneWithValidation, __vue_component__$4 as DefaBaseDurationInput, __vue_component__$3 as DefaBaseDurationInputWithValidation, __vue_component__$B as DefaBaseInput, __vue_component__$f as DefaBaseLinkExternal, __vue_component__$I as DefaBaseMessageInput, __vue_component__$18 as DefaBaseNotification, __vue_component__$C as DefaBaseOrderLine, __vue_component__$d as DefaBaseRadioGroup, __vue_component__$b as DefaBaseSelect, __vue_component__$7 as DefaBaseTextarea, __vue_component__$c as DefaBaseTooltip, __vue_component__$11 as DefaBlurUpImage, __vue_component__$19 as DefaCircleWrapper, __vue_component__$J as DefaComment, __vue_component__$H as DefaComments, __vue_component__$Q as DefaConfirmation, __vue_component__$R as DefaConfirmationResend, __vue_component__$K as DefaFooter, __vue_component__$L as DefaFullPageLoader, __vue_component__$A as DefaIconCalendar, __vue_component__$w as DefaIconCar, __vue_component__$p as DefaIconCaret, __vue_component__$l as DefaIconCompany, __vue_component__$W as DefaIconEllipsis, __vue_component__$u as DefaIconEnvelope, __vue_component__$i as DefaIconEthernet, __vue_component__$j as DefaIconExternal, __vue_component__$o as DefaIconHouseOwnerApproved, __vue_component__$n as DefaIconHouseOwnerNA, __vue_component__$m as DefaIconHouseOwnerRejected, __vue_component__$v as DefaIconId, __vue_component__$D as DefaIconImagePlaceholder, __vue_component__$y as DefaIconList, __vue_component__$t as DefaIconMapPointer, __vue_component__$g as DefaIconMobile, __vue_component__$k as DefaIconPdf, __vue_component__$s as DefaIconPhone, __vue_component__$q as DefaIconPlus, __vue_component__$r as DefaIconStats, __vue_component__$x as DefaIconUpload, __vue_component__$z as DefaIconUser, __vue_component__$h as DefaIconWifi, __vue_component__$_ as DefaImageCarousel, __vue_component__$15 as DefaInfoBubble, __vue_component__$Y as DefaLanguageSwitcher, __vue_component__$G as DefaLoaderBar, __vue_component__$S as DefaLoaderCircle, __vue_component__$V as DefaLoadingTextWithEllipsis, __vue_component__$16 as DefaModal, __vue_component__$O as DefaModalAlert, __vue_component__$N as DefaModalConfirmCancel, __vue_component__$17 as DefaNotificationError, __vue_component__$U as DefaPageError, __vue_component__$12 as DefaPageNotFound, __vue_component__$T as DefaProgressBar, __vue_component__$X as DefaRetailerGroupLogo, __vue_component__$14 as DefaTestHeader, __vue_component__$Z as DefaTrackingInformation, __vue_component__$1c as DefaTransitionDrawerLeft, __vue_component__$1e as DefaTransitionExpand, __vue_component__$1f as DefaTransitionFadeOutIn, __vue_component__$1b as DefaTransitionFadeSlide, __vue_component__$1a as DefaTransitionSlide, __vue_component__$1d as DefaTransitionStaggerList, getRules, hasRequiredRule };
